export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The Bourse Code represents the SIX Financial Information identifier for exchanges, trading platforms, regulated or
   * non-regulated markets and trade reporting facilities as sources of prices and related information and is assigned
   * to all markets in SIX Financial Information's database.
   *
   * Always serialized as integer.
   */
  Bc: { input: any; output: any; }
  /**
   * Country code delivered as ISO 3166. Please note that there are few custom codes.
   *
   * Examples for ALPHA-2: CH  US  FR  DE  IT  XX
   * Examples for ALPHA-3: CHE USA FRA DEU ITA XXX
   *
   * See: https://www.iso.org/iso-3166-country-codes.html
   *
   * Custom codes:
   * - XX/XXX for unmappable/historical country codes
   * - XU/XEU for European Union
   * - XA/XEA for European Economic Area
   */
  Country: { input: any; output: any; }
  /** Specified by SIX, typically follows the ISO 4217 alpha-3 code. For cryptocurrencies, the Cryptocurrency Symbol in Instrument Symbology can be used for reference. */
  Currency: { input: any; output: any; }
  /**
   * Duration represented as ISO 8601. The format is "PTnMnS".
   *
   * Example: PT10D PT1H PT5M PT1S PT0.1S
   *
   * NB: this is currently supporting a subset of ISO 8601 and precision from seconds to days.
   */
  Duration: { input: any; output: any; }
  /**
   * Company key identifier allocated by SIX Financial Information on all institutions present in the SIX Financial Information database.
   *
   * Always serialized as integer.
   */
  Gk: { input: any; output: any; }
  /**
   * Local date represented as ISO 8601 with format YYYY-MM-DD.
   *
   * Examples: 2021-01-01  1981-07-27
   *
   * See:
   * https://www.iso.org/iso-8601-date-and-time-format.html
   */
  LocalDate: { input: any; output: any; }
  /**
   * Local date time represented as ISO 8601 with format YYYY-MM-DD'T'HH:mm:ss.
   *
   * Examples: 2021-01-01T07:45:15
   *
   * See:
   * https://www.iso.org/iso-8601-date-and-time-format.html
   */
  LocalDateTime: { input: any; output: any; }
  /** Local time represented as ISO 8601 with format hh:mm. */
  LocalTime: { input: any; output: any; }
  /**
   * Represents a time zone as registered in the IANA time zone database.
   *
   * Example: Europe/Zurich America/New_York Asia/Tokyo
   *
   * See: https://www.iana.org/time-zones
   */
  TimeZone: { input: any; output: any; }
  /** Denotes a user input to be used as identifier. For security reason this is restricted (i.e. length and content). */
  UserInputId: { input: any; output: any; }
  /** Denotes a user input to be used for free text. Used for search for example. For security reason this is restricted (i.e. length). */
  UserInputText: { input: any; output: any; }
  /**
   * Official national instrument identifier assigned by the National Numbering Agency responsible for Switzerland: SIX Financial Information.
   *
   * Always serialized as integer (64 bits).
   */
  Valor: { input: any; output: any; }
  /**
   * Date time with timezone information represented as ISO 8601 with format YYYY-MM-DD'T'HH:mm:ss+hh:mm.
   *
   * Examples: 2021-01-01T07:45:15−02:00 2021-01-01T07:45:15+01:00
   *
   * See https://www.iso.org/iso-8601-date-and-time-format.html
   */
  ZonedDateTime: { input: any; output: any; }
};

export type ApprovalProductCategory = {
  __typename?: 'ApprovalProductCategory';
  approvalDate?: Maybe<Scalars['LocalDate']['output']>;
};

/** Indicates the type of bond issuer that applies. May cover countries, banks or financial institutions or any private bodies. */
export enum BorrowerCategory {
  BanksAndFinancialInstitution = 'BANKS_AND_FINANCIAL_INSTITUTION',
  BondsOfPublicLawEntitiesEstablishedForThePublicGood = 'BONDS_OF_PUBLIC_LAW_ENTITIES_ESTABLISHED_FOR_THE_PUBLIC_GOOD',
  /** Bond issued by cantons, federal states, 'Bundesländer', provinces, local authorities, etc. */
  CantonsAndFederalStates = 'CANTONS_AND_FEDERAL_STATES',
  CitiesAndMunicipAuthorities = 'CITIES_AND_MUNICIP_AUTHORITIES',
  CountriesAndCentralGovernments = 'COUNTRIES_AND_CENTRAL_GOVERNMENTS',
  IndustryBond = 'INDUSTRY_BOND',
  MortgageAndFundingInstitutionsMbsAbs = 'MORTGAGE_AND_FUNDING_INSTITUTIONS_MBS_ABS',
  Other = 'OTHER',
  SupranationalOrganisations = 'SUPRANATIONAL_ORGANISATIONS',
  UtilityCompanies = 'UTILITY_COMPANIES'
}

/** Describes the exact value date if payment of a debt instrument falls on a public holiday or weekend. */
export enum BusinessDayConvention {
  /** Adjustment on the following business day. */
  Following = 'FOLLOWING',
  /** Adjustment on the following business day, unless the adjustment date falls in the next calendar month, in which case the adjustment day rolls backward to the preceding business day. */
  ModifiedFollowing = 'MODIFIED_FOLLOWING',
  /** Adjustment on the preceding business day, unless the adjustment date falls in another month, in which case the adjustment day is rolled forward to the following business day. */
  ModifiedPreceding = 'MODIFIED_PRECEDING',
  Other = 'OTHER',
  /** Adjustment on the preceding business day. */
  Preceding = 'PRECEDING'
}

/** Type of certificate such as ADR or GDR. May also be specific to geographical areas or with mention of voting rights.  */
export enum CertificateType {
  /** Sponsored American Depository Shares (SADS). An American depositary share (ADS) is a U.S. dollar-denominated equity share of a foreign-based company available for purchase on an American stock exchange. American Depositary Shares (ADSs) are issued by depository banks in the U.S. under agreement with the issuing foreign company. The entire issuance is called an American Depositary Receipt (ADR) and the individual shares are referred to as ADSs. Depending on the level of compliance with U.S. securities regulations the foreign company wishes to follow, companies may either list its shares over-the-counter (OTC) with low reporting requirements or on a major exchange like The New York Stock Exchange (NYSE) or The NASDAQ Stock Market (Nasdaq). Listings on the latter exchanges generally require the same level of reporting as domestic companies, and also require adherence to Generally Accepted Accounting Principles (GAAP) rules.  (http://www.investopedia.com/terms/a/ads.asp). */
  AmericanDepositaryShare = 'AMERICAN_DEPOSITARY_SHARE',
  AustrianCertificate = 'AUSTRIAN_CERTIFICATE',
  BdrBearerDepositreceipt = 'BDR_BEARER_DEPOSITRECEIPT',
  BelgianCertificate = 'BELGIAN_CERTIFICATE',
  /** CHESS Depository Interests (CDIs) is the general term for two products, CHESS Units of Foreign Securities (CUFS), and Depository Interests (DIs). Both types of CDI are electronic depository receipts issued over different security types and are units of beneficial ownership issued over principal securities. CUFS are the equity component of the product and apply to foreign securities only. DIs are the debt/bearer component and apply to both foreign and domestic securities. */
  CdiChessDepositoryInterests = 'CDI_CHESS_DEPOSITORY_INTERESTS',
  CdrContinentdepositreceipt = 'CDR_CONTINENTDEPOSITRECEIPT',
  /** Certificado de Deposito Argentino. */
  Cedear = 'CEDEAR',
  /** The investment certificate (CI) and the voting right certificate (CDV) are issued  from the existing shares or are created by financial recapitalization with issue of certificates of investment. The CI is entitled to the same dividend as the share, is tradable and can be quoted on the stock exchange. The voting rights certificates (CDV) are issued only to the existing shareholders. The owners of CI can buy CDV and thus reconstitute an ordinary share. */
  CertificateOfInvestment = 'CERTIFICATE_OF_INVESTMENT',
  /** The certificates of voting right (CDV) are given only to the existing shareholders as compensation of an emission of certificates of investment (CI). The owners of CI can buy CDV’s and thus reconstitute an ordinary share. */
  CertificateOfVotingRights = 'CERTIFICATE_OF_VOTING_RIGHTS',
  /** Certificate issued by Fortis (BNP)  (ex Societe Fi-duciaire de la Societe Generale de Banque). */
  CertificateSofigen = 'CERTIFICATE_SOFIGEN',
  /** Administratie-en Trustkantoor. */
  CertAteka = 'CERT_ATEKA',
  /** Belgian Overseas Issuing Corporation. */
  CertBelgianOvsIssuingCorp = 'CERT_BELGIAN_OVS_ISSUING_CORP',
  /** Belgian Overseas Agencies Limited. */
  CertBoal = 'CERT_BOAL',
  CertEuroclearFrance = 'CERT_EUROCLEAR_FRANCE',
  CertSogesAteka = 'CERT_SOGES_ATEKA',
  CertSogesDewaay = 'CERT_SOGES_DEWAAY',
  CertSogesFiducem = 'CERT_SOGES_FIDUCEM',
  /** Local depositary receipts are established for companies seeking to list their stock on a local exchange where a direct listing of foreign securities is not permitted or not possible due to a lack of settlement linkage between the country where the company is located and the country of listing. Local depositary receipt programs are often named according to the exchanges on which they are listed and traded eg. Singapore Depositary Receipts (listed in Singapore) and Hong Kong Depositary Receipts (listed in Hong Kong). */
  DepositaryReceipt = 'DEPOSITARY_RECEIPT',
  /** Certificates issued by a depository bank for example in the USA, representing preferred shares of a corporation.Depository shares have the same   characteristics as the underlying and receive dividends paid on the preferred shares. The depository bank holds the entire issue of the preferred shares, which are therefore not listed in any stock exchange. */
  DepositoryShares = 'DEPOSITORY_SHARES',
  DutchCertificate = 'DUTCH_CERTIFICATE',
  EdrEuropeanDepositreceipt = 'EDR_EUROPEAN_DEPOSITRECEIPT',
  /** An exchange-traded commodity (ETC) gives traders and investors exposure to commodities (called the underlying), in the form of shares. Traded like a stock, i.e. bought and sold on a stock exchange, ETCs track the price movement of commodities--such as oil, gold and silver--and then fluctuate in value based on those commodity(ies). ETCs may track individual commodities and/or a commodity basket. An example of a commodity basket ETC is one that tracks multiple metals (not just one) or tracks a group of agricultural commodities, such as wheat, soybeans and corn. According to ESMA an exchange-traded commodity (ETC) is a debt instrument issued against a direct investment by the issuer in commodities or commodities derivative contracts. The price of an ETC is directly or indirectly linked to the performance of the underlying. An ETC passively tracks the performance of the commodity or commodity indices to which it refers. */
  ExchangeTradedCommodities = 'EXCHANGE_TRADED_COMMODITIES',
  /** Exchange-traded notes (ETNs) are a type of unsecured, unsubordinated debt security based on the performance of a market index minus applicable fees, with no period coupon payments distributed and no principal protections. According to ESMA an Exchange Traded Notes (ETNs) is a debt instrument issued against a direct investment by the issuer in the underlying or underlying derivative contracts. The price of an ETN is directly or indirectly linked to the performance of the underlying. An ETN passively tracks the performance of the underlying to which it refers. */
  ExchangeTradedNotes = 'EXCHANGE_TRADED_NOTES',
  GermanCertificate = 'GERMAN_CERTIFICATE',
  /** Sponsored Global Depository Shares. A global depositary receipt (GDS) is a bank certificate issued in more than one country for shares in a foreign company. The shares are held by a foreign branch of an international bank. The shares trade as domestic shares but are offered for sale globally through the various bank branches. A GDS is a financial instrument used by private markets to raise capital denominated in either U.S. dollars or euros. Each GDR represents a particular number of shares in a specific company. A single GDS can represent anywhere from a fraction of a share to multiple shares, depending on its design. When multiple shares are involved, the receipt value shows an amount higher than the price for a single share. Depository banks manage and distribute various GDRs and function in an international context. (http://www.investopedia.com/terms/g/gdr.asp). */
  GlobalDepositaryShare = 'GLOBAL_DEPOSITARY_SHARE',
  IdrInternatdepositreceipt = 'IDR_INTERNATDEPOSITRECEIPT',
  /** Local depositary receipts are established for companies seeking to list their stock on a local exchange where a direct listing of foreign securities is not permitted or not possible due to a lack of settlement linkage between the country where the company is located and the country of listing. Local depositary receipt programs are often named according to the exchanges on which they are listed and traded eg. Singapore Depositary Receipts (listed in Singapore) and Hong Kong Depositary Receipts (listed in Hong Kong). */
  JapanDepositaryReceipt = 'JAPAN_DEPOSITARY_RECEIPT',
  Other = 'OTHER',
  /** An instrument which is issued with the cooperation of the company whose stock will underlie the Sponsored American Depository Receipt (SADR). These shares carry all the rights of the common share, such as voting rights. */
  SponsoredAdrAds = 'SPONSORED_ADR_ADS',
  /** An instrument issued by a depositary bank in more than one country, representing a specific number of securities of a foreign corporation and issued with the cooperation of the company whose stock will underlie the Sponsored Global Depository Receipt (GDR). */
  SponsoredGdrGds = 'SPONSORED_GDR_GDS',
  /** A record that proves that the right to subscribe to the assets was exercised by its owner. Receipts may be traded on the market until they are converted into shares, when they are assimilated. */
  SubscriptionReceipt = 'SUBSCRIPTION_RECEIPT',
  SwissCertificate = 'SWISS_CERTIFICATE',
  /** This Depository Receipt is a trading instrument issued by Thai NVDR Co Ltd. It is a valid security as specified by Securities and Exchange Commission, Thailand and is automatically regarded as a listed security by Stock Exchange of Thailand. */
  ThaiCertificate = 'THAI_CERTIFICATE',
  /** An American Depository Receipt that is issued by a broker/dealer or depositary bank without the involvement of the company whose stock underlies the ADR. Shareholder benefits, voting rights and other rights may not be extended to the holders of unsponsored ADRs. */
  UnsponsoredAdr = 'UNSPONSORED_ADR',
  /** Unsponsored Brazilian Depositary Receipt (UBDR). A Brazilian Depositary Receipt (BDR) is a negotiable instrument that represents an ownership interest in the securities of a non-Brazilian publicly traded company which must be backed by its own securities listed in its home or other markets. BDR's are quoted and traded in Brazilian reais, and are settled according to procedures governing the Brazilian market. A BDR Program is a mechanism which can be used by a foreign company that wishes to have its securities traded in the Brazilian capital market. BDRs are receipts issued by a Brazilian depositary institution representing securities issued by a foreign domiciled company which have been deposited with a foreign custodian bank or institution. The securities underlying the BDRs must be deposited with institutions that are in countries which have signed agreements with the Brazilian Securities Commission (Comissão de Valores Mobiliários (CVM)) or have signed a memorandum of understanding with the International Organization of Securities Commissions - IOSCO. Unsponsored programs can be launched without the support of the underlying company and the securities are traded on BM&FBOVESPA. The depositary institutions that issue Level I BDRs are responsible for disclosing information to the market. Although the program is registered with the CVM, the foreign issuers of shares represented by Level I Unsponsored BDRs are not required to register the company with the CVM. Proceeds cannot be raised in Brazil through an issuance of securities. Only "Qualified Investors" (as defined - see later) are permitted to trade Unsponsored Level I BDRs. (Source: http://www.bmfbovespa.com.br/lumis/portal/file/fileDownload.jsp?fileId=8AA8D09754177C0901553C89D7C944F1&inline=1). */
  UnsponsoredBrazilianDepositaryReceipt = 'UNSPONSORED_BRAZILIAN_DEPOSITARY_RECEIPT',
  /** An instrument, issued in more than one country, by a depositary bank, and without the involvement of the company whose stock will underlie the GDR. The depositary holds the foreign securities (under-lying instrument) represented by the foreign certifi-cate, and generally pays cash dividends paid to it as a holder of the underlying security to the holders of the foreign certificate. */
  UnsponsoredGdr = 'UNSPONSORED_GDR',
  /** The 'VVPR strip' is a tax instrument under Belgian Law. It enables the shareholder who holds it at the same time as a share to limit to 15% the tax deduc-tion levied in the form of a retention at source on the amount of the gross dividend attributed to the corresponding share.In the absence of a strip, the initial retention is 25% of the gross dividend. The tax deduction for dividends with a VVPR Strip falls usually 3 years after the payment due date of each dividend. */
  VvprStrip = 'VVPR_STRIP'
}

export enum Conflation {
  Interval = 'INTERVAL',
  NoConflation = 'NO_CONFLATION'
}

/**
 * Used for reporting the usage of a particular API.
 * This should be never used by the client but it cannot be removed from the schema because it is needed at run-time.
 */
export enum ContentType {
  EntityBase = 'ENTITY_BASE',
  EodTimeseries = 'EOD_TIMESERIES',
  EuesgManufacturer = 'EUESG_MANUFACTURER',
  EuTaxonomy = 'EU_TAXONOMY',
  FreeTextSearch = 'FREE_TEXT_SEARCH',
  InstitutionSummary = 'INSTITUTION_SUMMARY',
  InstitutionSymbology = 'INSTITUTION_SYMBOLOGY',
  InstrumentBase = 'INSTRUMENT_BASE',
  InstrumentSummary = 'INSTRUMENT_SUMMARY',
  InstrumentSymbology = 'INSTRUMENT_SYMBOLOGY',
  IntradaySnap = 'INTRADAY_SNAP',
  IntradayTimeseries = 'INTRADAY_TIMESERIES',
  ListingBase = 'LISTING_BASE',
  ListingSymbology = 'LISTING_SYMBOLOGY',
  MarketplaceSummary = 'MARKETPLACE_SUMMARY',
  MarketBase = 'MARKET_BASE',
  MarketDataStreaming = 'MARKET_DATA_STREAMING',
  Search = 'SEARCH',
  SfdrInvestee = 'SFDR_INVESTEE'
}

/** The type indicates the type of underlying to which the exchange-traded derivatives relates (e.g. ETD on interest, etc.). */
export enum ContractType {
  EtdOnBasket = 'ETD_ON_BASKET',
  EtdOnBond = 'ETD_ON_BOND',
  EtdOnCommodity = 'ETD_ON_COMMODITY',
  EtdOnCurrency = 'ETD_ON_CURRENCY',
  EtdOnDividend = 'ETD_ON_DIVIDEND',
  EtdOnEquity = 'ETD_ON_EQUITY',
  /** ETD on Equity Total Return. */
  EtdOnEquityTotalReturn = 'ETD_ON_EQUITY_TOTAL_RETURN',
  EtdOnFund = 'ETD_ON_FUND',
  EtdOnFuture = 'ETD_ON_FUTURE',
  EtdOnIndex = 'ETD_ON_INDEX',
  EtdOnInterest = 'ETD_ON_INTEREST',
  EtdOnOption = 'ETD_ON_OPTION',
  EtdOnPreciousMetal = 'ETD_ON_PRECIOUS_METAL',
  EtdOnStrategy = 'ETD_ON_STRATEGY',
  EtdOnStructuredInstrument = 'ETD_ON_STRUCTURED_INSTRUMENT',
  EtdOnSwap = 'ETD_ON_SWAP',
  Other = 'OTHER',
  /** Indicates that an underlying future can be traded at special conditions (e.g. Traded at Settlement). */
  RelativePriceTransactionOnEtd = 'RELATIVE_PRICE_TRANSACTION_ON_ETD'
}

/** Indicates the unit of measurement in which the instrument quantity is expressed: per instrument or per nominal. For prices, this is the unit in which the instrument is traded. */
export enum ContractUnitType {
  Arroba = 'ARROBA',
  /** Unit of weight for gold in Thailand. 1 Baht = 15.244 grams. */
  Baht = 'BAHT',
  Barrel = 'BARREL',
  /** The board foot is a specialized unit of measure for the volume of lumber in the United States and Canada. It is the volume of a one foot length of a board one foot wide and one inch thick. */
  BoardFoot = 'BOARD_FOOT',
  Bushel = 'BUSHEL',
  Contract = 'CONTRACT',
  /** Cubic meters (m3), volume equals 1000 liters. */
  CubicMetersM3 = 'CUBIC_METERS_M3',
  Gallon = 'GALLON',
  /** Gigawatt-hours (GWh). */
  GigawattHoursGwh = 'GIGAWATT_HOURS_GWH',
  Gram = 'GRAM',
  HundredweightCwt = 'HUNDREDWEIGHT_CWT',
  IndexPoint = 'INDEX_POINT',
  Kilogram = 'KILOGRAM',
  /** Kilowatt-hours (kWh). */
  KilowattHoursKwh = 'KILOWATT_HOURS_KWH',
  Megawatt = 'MEGAWATT',
  /** Megawatt-hours (MWh). */
  MegawattHoursMwh = 'MEGAWATT_HOURS_MWH',
  MetricTonne = 'METRIC_TONNE',
  Mmbtu = 'MMBTU',
  /** Nominal value: The price of a security (stocks, shares, bonds etc.) when originally issued. This bears no relation to the market price. Also known as face value or par value. */
  Nominal = 'NOMINAL',
  NominalCurrencyUnitPerIndexPoint = 'NOMINAL_CURRENCY_UNIT_PER_INDEX_POINT',
  Other = 'OTHER',
  Ounce = 'OUNCE',
  PhysicalUnit = 'PHYSICAL_UNIT',
  PieceUnit = 'PIECE_UNIT',
  PoundLb = 'POUND_LB',
  /** Ratio of two values according to the definition of the specific amount. */
  Ratio = 'RATIO',
  Sack = 'SACK',
  Tael = 'TAEL',
  Tola = 'TOLA',
  TroyOunce = 'TROY_OUNCE'
}

/** ISO 3166 format preference. */
export enum CountryFormat {
  /** Delivers all country codes as 2 letters codes, e.g. CH, DE, IT, FR, GB, etc. */
  Alpha2 = 'ALPHA2',
  /** Delivers all country codes as 3 letters codes, e.g. CHE, DEU, ITA, FRA, GBR, etc. */
  Alpha3 = 'ALPHA3'
}

export enum CouponPaymentFrequencyTimeUnit {
  IrregularPeriods = 'IRREGULAR_PERIODS',
  Month = 'MONTH',
  None = 'NONE',
  Once = 'ONCE',
  Other = 'OTHER',
  UnknownOrNotAvailable = 'UNKNOWN_OR_NOT_AVAILABLE',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** Represents the characteristics of an interest payment made for an instrument. Interest payments are regular payments, their amounts are either fixed or depend on certain reference sizes such as reference interest rates. */
export enum CurrentCouponType {
  /** This code is used for all types of bonds or debentures with fixed interest rate, including graduated interest bonds, zero bonds, GMBF etc. as well as for pref. Shares and dividend right certificates that have a fixed rate. */
  Fixed = 'FIXED',
  /** The determination of the interest/income payment depends on any strikes and/or barriers. */
  OptionalPayment = 'OPTIONAL_PAYMENT',
  Other = 'OTHER',
  /** This code is used for all types of bonds or debentures with variable interest rates that are reset at regular intervals and for a specified period of time on the basis of an underlying instrument. */
  Variable = 'VARIABLE'
}

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DelayedInterestPayment = {
  __typename?: 'DelayedInterestPayment';
  /** @deprecated No longer supported */
  delayInMonths?: Maybe<Scalars['Int']['output']>;
  /** @deprecated No longer supported */
  paymentDay?: Maybe<Scalars['Float']['output']>;
};

/** Indicates the frequency of dividend payments per business year. */
export enum DividendPolicy {
  Annual = 'ANNUAL',
  /** Dividend paid monthly. */
  Monthly = 'MONTHLY',
  /** According to the company's dividend policy, no dividend distributions are planned. */
  NoDividend = 'NO_DIVIDEND',
  Other = 'OTHER',
  /** Dividend paid quartely. */
  Quarterly = 'QUARTERLY',
  /** Dividend paid semi-annually. */
  SemiAnnual = 'SEMI_ANNUAL'
}

/** Type of earnings for total life (e.g. Fixed/variable bills, graduated interest). */
export enum EarningsWholeTermType {
  /** During the life of the instrument, the actual type of interest changes from fixed to variable. */
  ChangeFromFixedToVariable = 'CHANGE_FROM_FIXED_TO_VARIABLE',
  /** During the life of the instrument, the actual type of interest changes from variable to fixed. */
  ChangeFromVariableToFixed = 'CHANGE_FROM_VARIABLE_TO_FIXED',
  ChangeOfFixedOrOfGraduatedInterest = 'CHANGE_OF_FIXED_OR_OF_GRADUATED_INTEREST',
  /** During the life of the instrument, there is a change in the underlying instrument and/or spread (premium or discount on the lending rate,e.g.0.25% premium added to LIBOR. */
  ChangeOfUnderlying = 'CHANGE_OF_UNDERLYING',
  Other = 'OTHER',
  ValidForWholeTerm = 'VALID_FOR_WHOLE_TERM'
}

export type EndOfDayHistoryItem = {
  __typename?: 'EndOfDayHistoryItem';
  /** The Accrued interest refers to the interest that has accumulated on a fixed-income security but has not yet been paid to the investor. */
  accruedInterest?: Maybe<Scalars['Float']['output']>;
  /** The Close can either be derived from the final transaction conducted during the day or calculated by the provider. While it may not necessarily match the Last, it consistently reflects the official closing price, serving as a reliable measure of the day's concluding value. The price can be adjusted according to corporate action events historically. */
  close?: Maybe<Scalars['Float']['output']>;
  /** The Close Year is the end of the year valuation price determined by SIX. Prices are selected by SIX at the last business day of the year. Subsequent updates valid for the preceding year and reported after 31 December are possible. */
  closeYear?: Maybe<Scalars['Float']['output']>;
  /** The Closing Ask indicates the final/closing ask quote specifically identified as such by the provider (whether the exchange recognizes official closing values for quotes or not, i.e. some exchanges provide final quotes but do not official recognize them as official closing) or final quotes as determined by SIX based on the market practice. Generally, for contributors these will be the end of day quotes, while for exchanges it may be the quotes at the closing bell or at the end of the Trade at Last session. */
  closingAsk?: Maybe<Scalars['Float']['output']>;
  /** The Closing Bid indicates the final/closing bid quote specifically identified as such by the provider (whether the exchange recognizes official closing values for quotes or not, i.e. some exchanges provide final quotes but do not official recognize them as official closing) or final quotes as determined by SIX based on the market practice. Generally, for contributors these will be the end of day quotes, while for exchanges it may be the quotes at the closing bell or at the end of the Trade at Last session. */
  closingBid?: Maybe<Scalars['Float']['output']>;
  /** A Dividend is the distribution of corporate earnings to eligible shareholders. This field represents the latest dividend on ex date. The dividend can be adjusted according to corporate action events historically. */
  dividend?: Maybe<Scalars['Float']['output']>;
  /** A Dividend Yield is the annualized gross yield based on the market price of a share. The dividend amount paid is based on the actual historical regular dividend payments looking back 12 months (trailing dividend method). */
  dividendYield?: Maybe<Scalars['Float']['output']>;
  /** A High shows the intraday price swings, i.e. the highest price reached during the day. The high price enables the investor to directly estimate the daily price swings and the state of the market. The Daily High is a key input for charting. The price can be adjusted according to corporate action events historically. */
  high?: Maybe<Scalars['Float']['output']>;
  /** The Historical 30 Days Volatility refers to the measure of the price volatility of an underlying asset over a specific historical period of 30 days. It calculates the standard deviation of the asset's prices during that period to gauge the level of volatility experienced by the asset. Historical 30 Days Volatility provides a snapshot price fluctuations, allowing investors to assess the short-term volatility characteristics of the asset and make informed decisions based on the observed historical volatility patterns. */
  historicalVolatility30Days?: Maybe<Scalars['Float']['output']>;
  /** The Historical 90 Days Volatility refers to the measure of the price volatility of an underlying asset over a specific historical period of 90 days. It calculates the standard deviation of the asset's prices during that period to gauge the level of volatility experienced by the asset. Historical 90 Days Volatility provides a snapshot price fluctuations, allowing investors to assess the short-term volatility characteristics of the asset and make informed decisions based on the observed historical volatility patterns. */
  historicalVolatility90Days?: Maybe<Scalars['Float']['output']>;
  /** The Historical 180 Days Volatility refers to the measure of the price volatility of an underlying asset over a specific historical period of 180 days. It calculates the standard deviation of the asset's prices during that period to gauge the level of volatility experienced by the asset. Historical 180 Days Volatility provides a snapshot price fluctuations, allowing investors to assess the short-term volatility characteristics of the asset and make informed decisions based on the observed historical volatility patterns. */
  historicalVolatility180Days?: Maybe<Scalars['Float']['output']>;
  /** The Historical 250 Days Volatility refers to the measure of the price volatility of an underlying asset over a specific historical period of 250 days. It calculates the standard deviation of the asset's prices during that period to gauge the level of volatility experienced by the asset. Historical 180 Days Volatility provides a snapshot price fluctuations, allowing investors to assess the short-term volatility characteristics of the asset and make informed decisions based on the observed historical volatility patterns. */
  historicalVolatility250Days?: Maybe<Scalars['Float']['output']>;
  /** The Implied Volatility refers to the market's expectation of the future volatility of an underlying asset. It represents the level of uncertainty or anticipated price fluctuations that market participants believe the asset will experience over a specified period. Higher implied volatility suggests greater expected price swings, while lower implied volatility indicates a calmer or more stable market expectation. */
  impliedVolatility?: Maybe<Scalars['Float']['output']>;
  /**
   * The Last represents the latest price attained during the main trading session when a financial asset was last traded. The price also serves as a reliable indicator of the most recent price for various asset classes, such as Equities, Bonds, Indices, Funds, Currencies, Reference Prices, Derivatives, and more. The price can be adjusted according to corporate action events historically.
   * @deprecated it is delivered as 'close'
   */
  last?: Maybe<Scalars['Float']['output']>;
  /** A Low shows the intraday price swings, i.e. the lowest price reached during the day. The low price enables the investor to directly estimate the daily price swings and the state of the market. The Daily Low is a key input for charting. The price can be adjusted according to corporate action events historically. */
  low?: Maybe<Scalars['Float']['output']>;
  /** The Market Capitalisation refers to the total market value of a company's outstanding shares of stock. */
  marketCapitalisation?: Maybe<Scalars['Float']['output']>;
  /** The Number of Trades is the number of daily transactions during an exchange session. It indicates how many trades are made in a given instrument over a certain period of time. It helps to estimate the liquidity of the particular security and/or detect an unusual activity level on a listing. If no value is available for the current day, the value of the previous generation is delivered. */
  numberOfTrades?: Maybe<Scalars['Float']['output']>;
  /** An Open is associated with the first transaction of the day. It follows immediately after the opening auction (if any) is completed. It is an opening price or first recorded price of the trading day - any value that the provider officially designates as the open. It is not necessarily a transacted price. The price can be adjusted according to corporate action events historically. */
  open?: Maybe<Scalars['Float']['output']>;
  /** An Open Interest is an amount of open derivative contracts that are not closed or delivered on a particular day. It indicates the most active derivative contracts. If the market is not yet closed or/and the embargo time has not yet elapsed, the previous generation value is provided. */
  openInterest?: Maybe<Scalars['Float']['output']>;
  /** The Price Earnings Ratio Estimated is the relationship of the share price to the net profit of the company. It is calculated by dividing the market price of the shares by the estimated earnings per share. If the market is not yet closed or/and the embargo time has not yet elapsed, the previous generation value is provided. */
  priceEarningsRatioEstimated?: Maybe<Scalars['Float']['output']>;
  /** The Price Earnings Ratio Reported is the relationship of the share price to the net profit of the company. It is calculated by dividing the market price of the shares by the reported earnings per share. If the market is not yet closed or/and the embargo time has not yet elapsed, the previous generation value is provided. */
  priceEarningsRatioReported?: Maybe<Scalars['Float']['output']>;
  /** Date for which the End-of-Day History prices are valid. */
  sessionDate: Scalars['LocalDate']['output'];
  /** A Settlement Price is a price at which all the open contracts are settled in cash at the custodian level. This value is disseminated by the provider. It values the derivative's portfolio at the end of the trading day. It is used to calculate the margin requirements on the basis of its value and the provided collateral. It is the most important data attribute for Exchange Traded Derivatives (ETDs). If the market is not yet closed or/and the embargo time has not yet elapsed, the previous generation value is provided. */
  settlementPrice?: Maybe<Scalars['Float']['output']>;
  /** The Total Expense Ratio is a measure used in the financial industry to assess the total cost associated with managing and operating an investment fund, such as a mutual fund or exchange-traded fund (ETF). It represents the percentage of a fund's total assets that is used to cover the expenses incurred in managing the fund, including management fees, administrative costs, custody fees, legal and audit fees, and other operational expenses. The price can be adjusted according to corporate action events historically. */
  totalExpenseRatio?: Maybe<Scalars['Float']['output']>;
  /** The Turnover is calculated by multiplying a daily Volume on the market in units/nominal/contracts and the current price for each traded unit. Its use is similar to that of Volume. In addition, it is also used for inter-market and inter-currency comparison purposes. */
  turnover?: Maybe<Scalars['Float']['output']>;
  /** The Turnover Total is the cumulative turnover on and off market. It is the daily volume in units/nominal/contracts multiplied by the current price of each traded unit. Its use is similar to that of Volume. In addition, it is also used for inter-market and inter-currency comparison purposes. */
  turnoverTotal?: Maybe<Scalars['Float']['output']>;
  /** The Volume is a number of units/nominal/contracts traded on market during a session. It is mainly used for analytical purposes and can be used for time series and historical data or data studies to compare it with the associated price action. The volume can be adjusted according to corporate action events historically. The adjustment factor has to be applied in the opposite direction of the price. E.g. in case of a 2-for-1 split, prices for the securities are being multiplied by the factor 0.5. The volume would be divided by the same factor. */
  volume?: Maybe<Scalars['Float']['output']>;
  /** The Volume Total is the cumulative number of units/nominal/contracts traded on and off a market during a session. It is mainly used for analytical purposes and can be used for time series and historical data or data studies to compare it with the associated price action. The volume can be adjusted according to corporate action events historically. The adjustment factor has to be applied in the opposite direction of the price. E.g. in case of a 2-for-1 split, prices for the securities are being multiplied by the factor 0.5. The volume would be divided by the same factor. */
  volumeTotal?: Maybe<Scalars['Float']['output']>;
  /** The Volume Weighted Average Price (VWAP) is a trading indicator, which averages the ratio between the traded prices and the cumulative traded volume throughout the day. If the market is not yet closed or/and the embargo time has not yet elapsed, the previous generation value is provided. */
  vwap?: Maybe<Scalars['Float']['output']>;
  /** A Yield to Maturity is the internal rate of return (IRR, overall interest rate) earned by the investor who buys the bond today at the market price, assuming that the bond will be held until maturity, and that all coupon and principal payments will be made on schedule. */
  yieldToMaturity?: Maybe<Scalars['Float']['output']>;
};

/** End of Day History Price Adjustment */
export enum EndOfDayPriceAdjustment {
  /** Prices are after the occurrence of corporate action events historically adjusted for the requested period. */
  Adjusted = 'ADJUSTED',
  /** Prices are after the occurrence of corporate action events historically and dividend-adjusted for the requested period. */
  AdjustedAndDividendAdjusted = 'ADJUSTED_AND_DIVIDEND_ADJUSTED',
  /** Prices are not adjusted. */
  Unadjusted = 'UNADJUSTED'
}

export type Entity = {
  __typename?: 'Entity';
  /** Resolution */
  lookup?: Maybe<EntityLookup>;
  /** Status of the response */
  lookupStatus: LookupStatus;
  referenceData?: Maybe<EntityReferenceData>;
  /** The requested entity id used in the request */
  requestedId: Scalars['UserInputId']['output'];
  /** The requested scheme used in the request */
  requestedScheme: EntityScheme;
};

export type EntityBase = {
  __typename?: 'EntityBase';
  /** Country of the legal entity as ISO 3166 alpha-2 code. */
  entityCountry?: Maybe<Scalars['Country']['output']>;
  /** The location (e.g. city or town) of the legal entity. */
  entityLocation?: Maybe<Scalars['String']['output']>;
  /** Legal entity long name. */
  entityLongName?: Maybe<Scalars['String']['output']>;
  /** Legal entity short name. */
  entityShortName?: Maybe<Scalars['String']['output']>;
  /** Status indicating whether the legal entity is inactive (deleted) or active. In case of active legal entities the status may include whether it is "In Liquidation" or "In Foundation". */
  entityStatus?: Maybe<EntityStatus>;
  /** Legal entity classification allocated by SIX Financial Information. Present on all legal entities in the SIX Financial Information database. */
  entityType?: Maybe<EntityType>;
  /** The SIX Financial Information identifier (GK) of the legal entity. */
  gk: Scalars['Gk']['output'];
  /** Name of the legal entity in the main language as ISO 639 alpha-2 code. */
  language?: Maybe<Language>;
  /** The Legal Entity Identifier (LEI) is a 20-digit alphanumeric code to identify a legal entity. The structure is defined in ISO 17442. */
  lei?: Maybe<Scalars['String']['output']>;
};

export type EntityLookup = {
  __typename?: 'EntityLookup';
  /** Legal entity short name. */
  entityShortName: Scalars['String']['output'];
  /** Status indicating whether the legal entity is inactive (deleted) or active. In case of active legal entities the status may include whether it is "In Liquidation" or "In Foundation". */
  entityStatus: EntityStatus;
  /** Legal entity classification allocated by SIX Financial Information. Present on all legal entities in the SIX Financial Information database. */
  entityType: EntityType;
};

export type EntityReferenceData = {
  __typename?: 'EntityReferenceData';
  entityBase?: Maybe<EntityBase>;
};

export enum EntityScheme {
  /** The SIX identification scheme used to uniquely identify entities of any type. */
  Gk = 'GK',
  /** Legal Entity Identifier. */
  Lei = 'LEI'
}

/** The current status of an Entity. */
export enum EntityStatus {
  /** The institution is active and has data in SIX Financial Information. */
  Active = 'ACTIVE',
  /** Liquidation or bankruptcy of a company as per U.S. law. */
  Chapter_7 = 'CHAPTER_7',
  /** Reorganisation as per U.S. law providing that the debtor remains in possession of the business and in control of its operation giving him time to restructure the debt and settle his financial situation. */
  Chapter_11 = 'CHAPTER_11',
  /** SIX Financial Information does not provide any current event data and (currently) there are no active financial instruments linked to the institution in question. The status of the institution is "inactive" and it is not linked to another institution for reference purposes. This status does not imply, however, that the institution has ceased to exist as a legal entity. */
  Inactive = 'INACTIVE',
  /** Bankruptcy proceedings instituted at the request of the creditors or debtors and after judging the legitimacy through the responsible court. */
  InBankruptcyProceedings = 'IN_BANKRUPTCY_PROCEEDINGS',
  InChapter_11Liquidation = 'IN_CHAPTER_11_LIQUIDATION',
  InDebtRestructuringLiquidation = 'IN_DEBT_RESTRUCTURING_LIQUIDATION',
  /** The institution has not yet been registered officially. This only applies to real institutions. */
  InFoundation = 'IN_FOUNDATION',
  /** Dismantling of an institution (company) by liquidating the remaining assets and distributing them to the investors in order of priority. */
  InLiquidation = 'IN_LIQUIDATION',
  Other = 'OTHER',
  /** Right granted to the insolvent but honest debtor to defer payment of debts with the aim of avoiding the seizure of the remaining assets or bankruptcy  (e.g. under administration). */
  UnderAdministration = 'UNDER_ADMINISTRATION'
}

/** The type of Entity. */
export enum EntityType {
  Association = 'ASSOCIATION',
  Branch = 'BRANCH',
  /** All types of corporate bodies and partnerships (in part without legal personality) that form a legal entity and act as such. These also include public organisations which act in the same way as companies. */
  Company = 'COMPANY',
  Foundation = 'FOUNDATION',
  Government = 'GOVERNMENT',
  InvestmentFund = 'INVESTMENT_FUND',
  Other = 'OTHER',
  /** Institution under public law. State or government institution. This can refer to regional administrative bodies or institutions under public law (e.g. Government Agency), provided that they act autonomously but not as companies. */
  PublicCorporation = 'PUBLIC_CORPORATION',
  /** Special Purpose Vehicle / Entity / Insurer (SPV / SPE / SPI) is a legal entity created at the direction of a sponsoring firm (which may also be referred to as the sponsor, originator, seller, or administrator). The sponsor is typically a major bank, finance company, investment bank or insurance company. It can take the form of a corporation, trust, partnership, corporation or a limited liability company. It is a vehicle whose operations are typically limited to the acquisition and financing of specific assets or liabilities. In this respect, a distinction should be drawn between asset securitizations and liability securitizations. Asset securitizations are usually undertaken by banks and finance companies, and typically involve issuing bonds that are backed by the cash flows of income-generating assets (ranging from credit card receivables to residential mortgage loans). Liability securitizations are usually undertaken by insurance companies, and typically involve issuing bonds that assume the risk of a potential insurance liability (ranging from a catastrophic natural event to an unexpected claims level on a certain product type). */
  SpecialPurpose = 'SPECIAL_PURPOSE',
  State = 'STATE'
}

/** Share categories according to holders rights and privileges. */
export enum EquityType {
  /** An ordinary share gives the right to its owner to share in the profits of the company (dividends) and to vote at general meetings of the company. Also includes Company shares and Capital share. */
  CommonStock = 'COMMON_STOCK',
  /** This share provided its holders with large dividend payouts only after all other classes of shareholders are paid. Holders of deferred shares had access to all the remaining profits after all obligations were met. Subordinate to all other classes of common and preferred stock, these shares are last in line when a company goes bankrupt and liquidates all assets. */
  DeferredShare = 'DEFERRED_SHARE',
  /** The employees shares have the same voting rights and rights of dividends as ordinary shares. They are issued under preferential conditions (compared to the regular market) and are subjected to specific conditions of emis-sion. */
  EmployeeShare = 'EMPLOYEE_SHARE',
  /** Beneficial part often given to the founders of a com-pany and usually give rights to only part of the benefits. They are attributed to the founders of a company for their qualities or in remuneration of immaterial contributions (knowledge, relations, etc..) and differ from the other types of shares by one or another advantage. */
  FoundersShare = 'FOUNDERS_SHARE',
  Other = 'OTHER',
  /** Share of a company (e.g. in Belgium) with rights only to dividend or a part of the annual benefit distributed by this one and to the reserve benefits in case of dissolution of the company. Generally emitted in a capital growth action in order to recompense  the new shareholders. Usually attributed to the first subscribers, this kind of shares can sometimes be assimilated to founders’ parts. */
  ParticipatingShareDividend = 'PARTICIPATING_SHARE_DIVIDEND',
  /** Shares which give their holders priority of claim over the holders of other share categories, mainly with regard to the distribution of profits or in the event of the company's liquidation and the exercise of rights. Include also preference shares. */
  PreferredStock = 'PREFERRED_STOCK',
  /** Share of a company with right only to a quote-part of its assets in the event of liquidation; it also gives sometimes right to a surplus dividend. They are distri-buted free of charges to the stockholders of redeemed (repurchased) capital shares. */
  ProfitSharingCertificate = 'PROFIT_SHARING_CERTIFICATE',
  /** Share with special fiscal advantages and reduced withholding taxes (i.e. in Belgium). */
  VvprShare = 'VVPR_SHARE'
}

/** EUSIPA is a pan European organization created to promote the interests of the structured investment products market. The aim of the umbrella association is to coordinate future transparency initiatives at the European level and so create uniform standards in Europe. Through EUSIPA market participants can engage in direct discussions with the decision makers at European level. */
export enum EusipaCode {
  BarrierDiscountCertificates = 'BARRIER_DISCOUNT_CERTIFICATES',
  BarrierReverseConvertibles = 'BARRIER_REVERSE_CONVERTIBLES',
  BarrierReverseConvertibleWithConditionalCoupon = 'BARRIER_REVERSE_CONVERTIBLE_WITH_CONDITIONAL_COUPON',
  BonusCertificatesSvspChInclCappedBonusCert = 'BONUS_CERTIFICATES_SVSP_CH_INCL_CAPPED_BONUS_CERT',
  CapitalProtectionWithCoupon = 'CAPITAL_PROTECTION_WITH_COUPON',
  CapitalProtectionWithKnockOut = 'CAPITAL_PROTECTION_WITH_KNOCK_OUT',
  CappedBonusCertificates = 'CAPPED_BONUS_CERTIFICATES',
  CappedCapitalProteced = 'CAPPED_CAPITAL_PROTECED',
  CappedOutperformanceCertificates = 'CAPPED_OUTPERFORMANCE_CERTIFICATES',
  CertificateWithConditionalCapitalProtectionAndAdditionalCreditRisk = 'CERTIFICATE_WITH_CONDITIONAL_CAPITAL_PROTECTION_AND_ADDITIONAL_CREDIT_RISK',
  ConstantLeverageCertificate = 'CONSTANT_LEVERAGE_CERTIFICATE',
  CreditLinkedNotes = 'CREDIT_LINKED_NOTES',
  CreditLinkedNoteEquityTranche = 'CREDIT_LINKED_NOTE_EQUITY_TRANCHE',
  CreditLinkedNoteLinear = 'CREDIT_LINKED_NOTE_LINEAR',
  CreditLinkedNoteMezzSeniorTranche = 'CREDIT_LINKED_NOTE_MEZZ_SENIOR_TRANCHE',
  DiscountCertificates = 'DISCOUNT_CERTIFICATES',
  DoubleKnockOutWarrants = 'DOUBLE_KNOCK_OUT_WARRANTS',
  ExchangeableCertificates = 'EXCHANGEABLE_CERTIFICATES',
  KnockOutWarrants = 'KNOCK_OUT_WARRANTS',
  MiniFutures = 'MINI_FUTURES',
  MiscellaneousCapitalProtection = 'MISCELLANEOUS_CAPITAL_PROTECTION',
  MiscellaneousConstantLeverageProducts = 'MISCELLANEOUS_CONSTANT_LEVERAGE_PRODUCTS',
  MiscellaneousCreditLinkedNotes = 'MISCELLANEOUS_CREDIT_LINKED_NOTES',
  MiscellaneousLeverageCertificates = 'MISCELLANEOUS_LEVERAGE_CERTIFICATES',
  MiscellaneousLeverageWithoutKnockOut = 'MISCELLANEOUS_LEVERAGE_WITHOUT_KNOCK_OUT',
  MiscellaneousLeverageWithKnockOut = 'MISCELLANEOUS_LEVERAGE_WITH_KNOCK_OUT',
  MiscellaneousParticipation = 'MISCELLANEOUS_PARTICIPATION',
  MiscellaneousYieldEnhancement = 'MISCELLANEOUS_YIELD_ENHANCEMENT',
  OpenEndKnockOutWarrants = 'OPEN_END_KNOCK_OUT_WARRANTS',
  Other = 'OTHER',
  OutperformanceBonusCertificates = 'OUTPERFORMANCE_BONUS_CERTIFICATES',
  OutperformanceCertificatesSvspChInclCappedOutpcert = 'OUTPERFORMANCE_CERTIFICATES_SVSP_CH_INCL_CAPPED_OUTPCERT',
  ParticipationCertificateWithAdditionalCreditRisk = 'PARTICIPATION_CERTIFICATE_WITH_ADDITIONAL_CREDIT_RISK',
  ReverseConvertibles = 'REVERSE_CONVERTIBLES',
  ReverseConvertibleWithConditionalCoupon = 'REVERSE_CONVERTIBLE_WITH_CONDITIONAL_COUPON',
  SpreadWarrants = 'SPREAD_WARRANTS',
  TrackerCertificates = 'TRACKER_CERTIFICATES',
  TwinWinCertificates = 'TWIN_WIN_CERTIFICATES',
  UncappedCapitalProtectionSvspChInclCappedCapprot = 'UNCAPPED_CAPITAL_PROTECTION_SVSP_CH_INCL_CAPPED_CAPPROT',
  VariousProducts = 'VARIOUS_PRODUCTS',
  Warrants = 'WARRANTS',
  YieldEnhancementCertificateWithAdditionalCreditRisk = 'YIELD_ENHANCEMENT_CERTIFICATE_WITH_ADDITIONAL_CREDIT_RISK'
}

/** Kind of exercise practiced, whereupon the following variations come to use. American style: Can be exercised at any time for the whole period - the data "exercise from" and "exercise to" are thus different. European style: Exercise at maturity or expiry. In this case the data "exercise from" and "exercise to" are identical. Bermuda style: Exercise on pre-defined days within an entire period of exercise. */
export enum ExerciseType {
  /** This option can be exercised at any time up to the expiry date. */
  American = 'AMERICAN',
  /** This option can only be exercised on particular days during its duration. */
  Bermuda = 'BERMUDA',
  /** This option can only be exercised on the expiry date. */
  European = 'EUROPEAN',
  Other = 'OTHER'
}

/** Indicates whether an instrument has a fixed final expiry date or none at all */
export enum Expiration {
  ExpirationFixedInAdvance = 'EXPIRATION_FIXED_IN_ADVANCE',
  /** Specific expiration date, but earlier possible. */
  FixedExpirationOrEarlier = 'FIXED_EXPIRATION_OR_EARLIER',
  NoExpirationDate = 'NO_EXPIRATION_DATE',
  Other = 'OTHER'
}

/** Indicates the type of distribution of the security earnings such as periodical, discount or at repayment, etc. */
export enum IncomeType {
  /** Interest income (interest + compound interest) is added to capital and paid out only at maturity. No income will be paid out during the life of the instrument, and all the coupons accumulate and are included in the repayment price. */
  CumulatedIncome = 'CUMULATED_INCOME',
  /** Interest income is anticipated at issuance by granting a discount on issue price (<100 %), e.g. for Zero bonds and GMBF, and no income will be paid out during the life of the instrument. */
  Discount = 'DISCOUNT',
  /** The instrument is issued at below 100% and is paid back at above 100%. */
  DiscountIssueAndPremiumAtRepayment = 'DISCOUNT_ISSUE_AND_PREMIUM_AT_REPAYMENT',
  /** An income coupon is paid out at the end of the maturity period. There is exactly one payment upon maturity. */
  IncomeAtRepayment = 'INCOME_AT_REPAYMENT',
  /** Income may be partly distributed in cash and partly reinvested, i.e. a number of coupons can be paid out and the remaining coupons are reinvested (e.g. investment funds and Belgian bonds). */
  MixedReinvestmentDistribution = 'MIXED_REINVESTMENT_DISTRIBUTION',
  /** The interest schedule includes a period during which no interest is paid out (Zero) and at least one additional period (fixed or variable) during which interest is paid out periodically. */
  MixedZeroPeriodicalPayment = 'MIXED_ZERO_PERIODICAL_PAYMENT',
  Other = 'OTHER',
  /** Total income achieved is periodically distributed (e.g. dividend payments or when all bond coupons are paid out). */
  PeriodicalPayment = 'PERIODICAL_PAYMENT',
  /** May be used for bonds where investors are given the choice to have all coupons paid out (i.e. periodical interest payments) or to have all coupons accumulated until maturity. */
  PeriodicalPaymentOrCumulativeAmount = 'PERIODICAL_PAYMENT_OR_CUMULATIVE_AMOUNT',
  /** Premium added to the repayment price at maturity (repayment price >100%). No income will be paid out during the life of the instrument. */
  PremiumAtRepayment = 'PREMIUM_AT_REPAYMENT',
  /** Income derived from investment is reinvested. The principal goal in mind when choosing the reinvestment vehicle is to achieve a maximum growth of assets. */
  Reinvestment = 'REINVESTMENT',
  /** The interest structure increases or decreases but is always fixed and of no relation to an underlying. */
  StepUpDown = 'STEP_UP_DOWN',
  /** If an entitlement arises from an underlying, then this will also be paid out on the derivative instrument. */
  UnderlyingPayout = 'UNDERLYING_PAYOUT'
}

export type Instrument = {
  __typename?: 'Instrument';
  lookup?: Maybe<InstrumentLookup>;
  /** Status of the response */
  lookupStatus: LookupStatus;
  pgdLookup?: Maybe<PgdLookup>;
  referenceData?: Maybe<InstrumentReferenceData>;
  /** The requested entity id used in the request */
  requestedId: Scalars['UserInputId']['output'];
  /** The requested scheme used in the request */
  requestedScheme: InstrumentScheme;
};

/**
 * The Instrument Base service is designed to provide clients with necessary financial instrument reference data for the requested instruments or listings.
 * The interface grants swift and user-friendly access to a predefined set of key attributes applicable to a broad range of asset classes.
 * Its intuitive nature guarantees that clients possess crucial information for enhancing operational efficiency in maintaining their master reference data.
 */
export type InstrumentBase = {
  __typename?: 'InstrumentBase';
  /** Base cryptocurrency symbol used in currency dealings. */
  baseCryptoSymbol?: Maybe<Scalars['String']['output']>;
  /** Base currency, as specified by SIX, typically follows the ISO 4217 alpha-3 code. For cryptocurrencies, the Cryptocurrency Symbol in Instrument Symbology can be used for reference. */
  baseCurrency?: Maybe<Scalars['Currency']['output']>;
  /** The multiplier is the stated quantity or value to calculate the total contract value based on the quoted price. */
  contractMultiplier?: Maybe<Scalars['Float']['output']>;
  /** Indicates the quantity of underlying instruments or the notional amount of the contract. At issuance, for ETDs on equity this amount is identical with the Contract Multiplier. After an adjustment, the Contract Size can change and may be different to the Contract Multiplier. */
  contractSize?: Maybe<Scalars['Float']['output']>;
  /** Identification used by the exchange to identify the specification of a contract. In some markets also known as Product Code. */
  contractSymbol?: Maybe<Scalars['String']['output']>;
  /** Indicates the type of underlying to which the exchange-traded derivatives relates (e.g. ETD on interest, etc.). */
  contractType?: Maybe<ContractType>;
  /** Type of quantity the Contract Size and Contract Multiplier refer to. */
  contractUnitType?: Maybe<ContractUnitType>;
  /** Current interest rate. */
  currentCouponRate?: Maybe<Scalars['Float']['output']>;
  /** Represents the characteristics of an interest payment made for an instrument. Interest payments are regular payments, their amounts are either fixed or depend on certain reference sizes such as reference interest rates. */
  currentCouponType?: Maybe<CurrentCouponType>;
  /** American style: Can be exercised at any time for the whole period - the data "exercise from" and "exercise until" are thus different. European style: Exercise at maturity or expiry. In this case the data "exercise from" and "exercise until" are identical. Bermuda style: Exercise on pre-defined days within an entire period of exercise. */
  exerciseType?: Maybe<ExerciseType>;
  /** The date by which an option contract is abandoned and becomes worthless unless it is exercised. */
  expirationDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Prefix Instrument classification in textual form. */
  instrumentNamePrefix: Scalars['String']['output'];
  /** Additional instrument type classifications in textual form. */
  instrumentNameSuffix?: Maybe<Scalars['String']['output']>;
  /** A free-form descriptive name of the instrument, assigned by the issuer. E.g. 6 % Reversy on XYZ Ltd. */
  instrumentProductName?: Maybe<Scalars['String']['output']>;
  /** Instrument short name. */
  instrumentShortName: Scalars['String']['output'];
  /** Status indicating whether an instrument is active or not. Provided that the instrument is still active, this may include further information such as "in default" or "In liquidation/dissolution". */
  instrumentStatus: InstrumentStatus;
  /** Instrument classification allocated by SIX Financial Information. The Instrument Type embodies a more granular categorization compared to the Security Type. */
  instrumentType: InstrumentType;
  /** It indicates the smallest denominations. Break-down of debt instrument by their nominal values (in Switzerland usually CHF 1000 and CHF 5000). For trusts the decimal places are indicated here, e.g. ",001" for proportions with fractions of 3 decimal places. */
  instrumentUnitSize?: Maybe<Scalars['Float']['output']>;
  /** Indicates the unit of measurement in which the instrument quantity is expressed: Per instrument or per nominal. For prices, this is the unit in which the instrument is traded. */
  instrumentUnitType?: Maybe<InstrumentUnit>;
  /** The International Securities Identification Number (ISIN) is a universally recognized and standardized code that uniquely identifies a financial instrument.  Its structure is defined in ISO 6166. */
  isin?: Maybe<Scalars['String']['output']>;
  /** Issuer is a legal entity that develops, registers and sells securities to finance its operations. Issuers may be corporations, investment trusts, or domestic or foreign governments. This is the present-day issuer of the financial instrument. */
  issuer?: Maybe<IssuerReference>;
  /** Main language applicable to the financial instrument according to ISO 639 alpha-2 code. It can be different from the issuing company's main language. */
  language?: Maybe<Language>;
  /** Latest possible redemption date provided in the prospectus according to ISO 8601. This applies to all instruments for which only one maturity date was stated. If several dates were provided for the financial instrument (e.g. for ABS / Asset-Backed Securities), i.e. an expected maturity and a legal maturity, then this field will contain the date of the earliest possible maturity (Expected Maturity). */
  maturityDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Indicates whether an instrument has a fixed final expiry date or none at all */
  maturityType?: Maybe<Expiration>;
  /** The market with the largest number of orders to buy and sell for the financial instrument. */
  mostLiquidMarket?: Maybe<MarketReference>;
  /** Nominal amount or par value of an instrument (e.g. 100 for a share with a nominal value of CHF 100). For debt instruments, only the currency but no nominal value is issued. */
  nominalAmount?: Maybe<Scalars['Float']['output']>;
  /** Nominal currency, as specified by SIX, typically follows the ISO 4217 alpha-3 code. For cryptocurrencies, the Cryptocurrency Symbol in Instrument Symbology can be used for reference. */
  nominalCurrency?: Maybe<Scalars['Currency']['output']>;
  /** If the instrument is partly paid-up as opposed to fully paid-up, the currently paid-in amount is recorded here. No entry is made for fully paid-up instruments. */
  nominalPaidUp?: Maybe<Scalars['Float']['output']>;
  /** Price at which the holder of a call option can buy the underlying securities or the holder of a put option can sell. Also referred to as exercise price. Depending on the product type, strike prices define whether an embedded option in the product is "in the money" or not. */
  optionStrikePrice?: Maybe<Scalars['Float']['output']>;
  /** Strike Price Currency, as specified by SIX, typically follows the ISO 4217 alpha-3 code. For cryptocurrencies, the Cryptocurrency Symbol in Instrument Symbology can be used for reference. */
  optionStrikePriceCurrency?: Maybe<Scalars['Currency']['output']>;
  /** Defines the type of the option from an investor's point of view. E.g. right to purchase (call), right to sell (put). */
  optionType?: Maybe<OptionType>;
  /** Security classification allocated by SIX Financial Information.  The Security Type embodies a broader categoriatzion compared to the Instrument Type, specifially tailored for optimal presentation in display applications. */
  securityType: SecurityType;
  /** SIX Financial Information assigns this version number to a contract. After changes in capital or other corporate actions a new version of an option or a future can be created and the version number is increased accordingly. */
  sixVersionNumber?: Maybe<Scalars['Int']['output']>;
  /** Trading cryptocurrency symbol used in currency dealings. */
  tradingCryptoSymbol?: Maybe<Scalars['String']['output']>;
  /** Trading currency, as specified by SIX, typically follows the ISO 4217 alpha-3 code. For cryptocurrencies, the Cryptocurrency Symbol in Instrument Symbology can be used for reference. */
  tradingCurrency?: Maybe<Scalars['Currency']['output']>;
  /** It is the ultimate underlying instrument on which derivative instruments, such as futures and options, are based. For Options on Futures, it would correspond to the underlying of the Future. */
  ultimateUnderlyingInstrument?: Maybe<InstrumentReference>;
  /** It is the direct underlying instrument on which derivative instruments, such as futures and options, are based. */
  underlyingInstrument?: Maybe<InstrumentReference>;
  /** Official national instrument identifier assigned by the National Numbering Agency responsible for Switzerland: SIX Financial Information. */
  valor: Scalars['Valor']['output'];
};

export type InstrumentLookup = {
  __typename?: 'InstrumentLookup';
  /** Instrument short name with up to 19 characters. */
  instrumentShortName: Scalars['String']['output'];
  /** Status indicating whether an instrument is active or not. Provided that the instrument is still active, this may include further information such as "in default" or "In liquidation/dissolution" */
  instrumentStatus: InstrumentStatus;
  /** Instrument classification allocated by SIX Financial Information. The Instrument Type embodies a more granular categorization compared to the Security Type. */
  instrumentType: InstrumentType;
};

/** A short description of the Instrument, useful to create links. */
export type InstrumentReference = {
  __typename?: 'InstrumentReference';
  /** The International Securities Identification Number (ISIN) is a universally recognized and standardized code that uniquely identifies a financial instrument. The structure is defined in ISO 6166. */
  isin?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use shortName */
  name: Scalars['String']['output'];
  /** Instrument short name. */
  shortName: Scalars['String']['output'];
  /** Official national instrument identifier assigned by the National Numbering Agency responsible for Switzerland: SIX Financial Information. */
  valor: Scalars['Valor']['output'];
};

export type InstrumentReferenceData = {
  __typename?: 'InstrumentReferenceData';
  entityBase?: Maybe<EntityBase>;
  instrumentBase?: Maybe<InstrumentBase>;
  /** @deprecated Use InstrumentBase instead. */
  instrumentSummary?: Maybe<InstrumentSummary>;
};

export enum InstrumentScheme {
  /** CUSIP International Numbering System. */
  Cins = 'CINS',
  /** International instrument identifier assigned by either Clearstream or Euroclear. */
  Commoncode = 'COMMONCODE',
  /** Committee on Uniform Security Identification Procedures. */
  Cusip = 'CUSIP',
  /** International Securities Identification Number. */
  Isin = 'ISIN',
  /** Stock Exchange Daily Official List. */
  Sedol = 'SEDOL',
  /**
   * A ticker symbol is an abbreviation used to uniquely identify publicly traded shares of a particular stock
   * on a particular stock market.
   */
  TickerBc = 'TICKER_BC',
  /**
   * The VALOR number is a code which uniquely identifies listed securities and financial instruments in Switzerland, and serves a similar purpose to CUSIP or WKN in the North American or German markets respectively.
   * The VALOR number is incorporated in the Swiss ISIN number.
   */
  Valor = 'VALOR',
  /** Wertpapierkennnummer is a German securities identification code. */
  Wkn = 'WKN'
}

/** Status indicating whether an instrument is active or not. Provided that the instrument is still active, this may include in coded form further information such as "in default". */
export enum InstrumentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  /** Debt instruments where the interest or redemption payments were not made as originally provided for in the prospectus or where payments discontinued. */
  InDefault = 'IN_DEFAULT',
  /** The instrument will be taken back following the sale of the company's or fund's assets and subsequent dissolution/liquidation. */
  InLiquidationDissolution = 'IN_LIQUIDATION_DISSOLUTION',
  NotYetIssued = 'NOT_YET_ISSUED',
  Other = 'OTHER'
}

/**
 * The Instrument Base service is designed to provide clients with necessary financial instrument reference data for the requested instruments or listings.
 * The interface grants swift and user-friendly access to a predefined set of key attributes applicable to a broad range of asset classes.
 * Its intuitive nature guarantees that clients possess crucial information for enhancing operational efficiency in maintaining their master reference data.
 */
export type InstrumentSummary = {
  __typename?: 'InstrumentSummary';
  /**
   * This indicates whether amortizations are provided for. Amortizations can only be triggered by the debtor. These are partial or total repayments which are carried out by means of drawing by lots or purchasing on the market.
   * @deprecated to be moved in another API
   */
  amortization?: Maybe<Scalars['Boolean']['output']>;
  /** Base currency of currency pairs used in currency dealings according to ISO 4217 alpha-3 code.  */
  baseCurrency?: Maybe<Scalars['Currency']['output']>;
  /**
   * Describes the exact value date if payment of a debt instrument falls on a public holiday or weekend.
   * @deprecated to be moved in another API
   */
  businessDayConvention?: Maybe<BusinessDayConvention>;
  /**
   * This indicates whether the debtor (issuer) is free to terminate. This relates to the redemption of part or the whole of the issue.
   * @deprecated to be moved in another API
   */
  callable?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicates whether the instrument is a certificate.
   * @deprecated to be moved in another API
   */
  certificate?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Type of certificate such as ADR or GDR. May also be specific to geographical areas or with mention of voting rights.
   * @deprecated to be moved in another API
   */
  certificateType?: Maybe<CertificateType>;
  /**
   * The Classification of Financial Instruments Code (CFI) is an international instrument classification standard defined by ISO based on standard ISO 10962. The CFI is an alphabetical code of 6 digits, where each one provides specific characteristics.
   * @deprecated to be moved in another API
   */
  cfi?: Maybe<Scalars['String']['output']>;
  /**
   * The Classification of Financial Instruments Code (CFI) SIX represents the CFI derived by SIX for the instrument in the SIX database, for which SIX is not the official authority for assigning the CFI.
   * @deprecated to be moved in another API
   */
  cfiSIX?: Maybe<Scalars['String']['output']>;
  /**
   * Flag indicating if the instrument is combined.
   * @deprecated to be moved in another API
   */
  combinedSecurity?: Maybe<Scalars['Boolean']['output']>;
  /** The multiplier is the stated quantity or value to calculate the total contract value based on the quoted price. */
  contractMultiplier?: Maybe<Scalars['Float']['output']>;
  /** Indicates the quantity of underlying instruments or the notional amount of the contract. At issuance, for ETDs on equity this amount is identical with the Contract Multiplier. After an adjustment, the Contract Size can change and may be different to the Contract Multiplier. */
  contractSize?: Maybe<Scalars['Float']['output']>;
  /** Identification used by the exchange to identify the specification of a contract. In some markets also known as Product Code. */
  contractSymbol?: Maybe<Scalars['String']['output']>;
  /** Indicates the type of underlying to which the exchange-traded derivatives relates (e.g. ETD on interest, etc.). */
  contractType?: Maybe<ContractType>;
  /** Type of quantity the Contract Size and Contract Multiplier refer to. */
  contractUnitType?: Maybe<ContractUnitType>;
  /**
   * This indicates whether the creditor (holder) has the opportunity to convert.
   * @deprecated to be moved in another API
   */
  conversionByHolder?: Maybe<Scalars['Boolean']['output']>;
  /**
   * This indicates whether the debtor (issuer) has the opportunity to convert.
   * @deprecated to be moved in another API
   */
  conversionByIssuer?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Aggregate conversion/exercise period start.
   * @deprecated to be moved in another API
   */
  conversionOrExercisePeriodFrom?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Aggregate conversion/exercise period end.
   * @deprecated to be moved in another API
   */
  conversionOrExercisePeriodUntil?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Indicates if partial of full capitalization of interest would be possible in line with the issue conditions.
   * @deprecated to be moved in another API
   */
  couponCapitalization?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Number of time units with which the coupon is being paid.
   * Examples: For annual distribution: number of time units = 1 and time unit = YEAR; for biennial distribution i.e. every alternate year: number of time units = 2 and time unit = YEAR; for semi-annual distribution i.e. every six months: number of time units = 6 and time unit = MONTH; for monthly distribution i.e. every month: number of time units = 1 and time unit = MONTH.
   * @deprecated to be moved in another API
   */
  couponPaymentFrequency?: Maybe<Scalars['Float']['output']>;
  /**
   * Time unit (e.g. YEAR) to which the Coupon Payment Frequency Number of Time Units refers.
   * Examples: For annual distribution: number of time units = 1 and time unit = YEAR; for biennial distribution i.e. every alternate year: number of time units = 2 and time unit = YEAR; for semi-annual distribution i.e. every six months: number of time units = 6 and time unit = MONTH; for monthly distribution i.e. every month: number of time units = 1 and time unit = MONTH.
   * @deprecated to be moved in another API
   */
  couponPaymentFrequencyTimeUnit?: Maybe<CouponPaymentFrequencyTimeUnit>;
  /**
   * Describes whether or not the payment period is to be adjusted according to the Business Day Convention applied.
   * @deprecated to be moved in another API
   */
  couponPeriodAdjustment?: Maybe<Scalars['Boolean']['output']>;
  /** Current interest rate. */
  currentCouponRate?: Maybe<Scalars['Float']['output']>;
  /** Represents the characteristics of an interest payment made for an instrument. Interest payments are regular payments, their amounts are either fixed or depend on certain reference sizes such as reference interest rates. */
  currentCouponType?: Maybe<CurrentCouponType>;
  /**
   * Date (ISO 8601) from which interest or dividend is calculated.
   * @deprecated to be moved in another API
   */
  datedDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * ISO 20022: Day count convention used for the calculation of interest-bearing days on the corresponding annual basis, e.g. 30/360. Usually the day count convention remains the same throughout the validity period. If for specific periods different conventions apply, they are reported in 'Interest payment schedule' for each period; the most recent convention is always being reported.
   * @deprecated to be moved in another API
   */
  dayCountBasis?: Maybe<MethodOfInterestComputationIndicator>;
  /**
   * dayCountBasis label as described by the ISO 20022.
   * @deprecated to be moved in another API
   */
  dayCountBasisLabel?: Maybe<Scalars['String']['output']>;
  /**
   * Indication of the number of months of which the interest payment is delayed as well as the calendar day of the month on which interest will effectively be paid.
   * @deprecated to be moved in another API
   */
  delayedInterestPayment?: Maybe<DelayedInterestPayment>;
  /**
   * This date indicates when the instrument was set to inactive.
   * @deprecated to be moved in another API
   */
  deletionDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Filled in for inactive instruments (e.g. early redemption, expiry, etc.).
   * @deprecated to be moved in another API
   */
  deletionReason?: Maybe<ReasonForDeletion>;
  /**
   * The date by which an option contract is abandoned and becomes worthless unless it is exercised.
   * @deprecated Use expirationDate
   */
  derivativeExpiryDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Time (ISO 8601) indication for the Expiration Date, when delivered by source.
   * @deprecated to be moved in another API
   */
  derivativeExpiryTime?: Maybe<Scalars['LocalTime']['output']>;
  /**
   * Indicates whether distributions can be obtained in other currencies than the nominal currency.
   * @deprecated to be moved in another API
   */
  distributionsInOtherCurrencies?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicates the frequency of dividend payments per business year.
   * @deprecated to be moved in another API
   */
  dividendPolicy?: Maybe<DividendPolicy>;
  /**
   * Indicates the type of distribution of the security earnings such as periodical, discount or at repayment, etc.
   * @deprecated to be moved in another API
   */
  earningsWholeTermType?: Maybe<EarningsWholeTermType>;
  /**
   * Share categories according to holders rights and privileges.
   * @deprecated to be moved in another API
   */
  equityType?: Maybe<EquityType>;
  /**
   * EUSIPA is a pan European organization created to promote the interests of the structured investment products market. The aim of the umbrella association is to coordinate future transparency initiatives at the European level and so create uniform standards in Europe. Through EUSIPA market participants can engage in direct discussions with the decision makers at European level.
   * @deprecated to be moved in another API
   */
  eusipaCode?: Maybe<EusipaCode>;
  /**
   * The holder has the option to exchange the instrument into an instrument (normally a share) of a different company. (mostly for debt instruments).
   * @deprecated to be moved in another API
   */
  exchangeable?: Maybe<Scalars['Boolean']['output']>;
  /** American style: Can be exercised at any time for the whole period - the data "exercise from" and "exercise until" are thus different. European style: Exercise at maturity or expiry. In this case the data "exercise from" and "exercise until" are identical. Bermuda style: Exercise on pre-defined days within an entire period of exercise. */
  exerciseType?: Maybe<ExerciseType>;
  /**
   * Indicates whether an instrument has a fixed final expiry date or none at all.
   * @deprecated to be moved in another API
   */
  expiration?: Maybe<Expiration>;
  /** The date by which an option contract is abandoned and becomes worthless unless it is exercised. */
  expirationDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * This indicates whether the debtor (issuer) has the opportunity to extend the term.
   * @deprecated to be moved in another API
   */
  extensionByHolder?: Maybe<Scalars['Boolean']['output']>;
  /**
   * This indicates whether the creditor (holder) has the opportunity to extend the term.
   * @deprecated to be moved in another API
   */
  extensionByIssuer?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Date (ISO 8601) of the latest possible redemption date provided in the prospectus. This applies to all instruments for which only one maturity date was stated. If several dates were provided for the financial instrument (e.g. for ABS / Asset-Backed Securities), i.e. an expected maturity and a legal maturity, then this field will contain the date of the earliest possible maturity (Expected Maturity).
   * @deprecated Use maturityDate
   */
  finalMaturityDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Date (ISO 8601) of the very first interest due.
   * @deprecated to be moved in another API
   */
  firstCouponDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Instrument short name according to ISO18774.
   * @deprecated to be moved in another API
   */
  fisn?: Maybe<Scalars['String']['output']>;
  /**
   * Instrument short name generated by SIX Financial Information according to the rules of ISO18774 without 35 character limit.
   * @deprecated to be moved in another API
   */
  fisnSIX?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates whether the instrument belongs to a group of instruments which may be subject to the ICMA regulation 189. According to this rule, an instrument issued by an "ICMA member" usually retains the original name after events like a name change or a merger, whereas the naming of an instrument not subject to this rule will be as published by the responsible stock exchange.
   * @deprecated to be moved in another API
   */
  icmaRegulated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Type of earnings for total life (e.g. Fixed/variable bills, graduated interest).
   * @deprecated to be moved in another API
   */
  incomeType?: Maybe<IncomeType>;
  /**
   * A slow deflation of the security over its duration is avoided by adaption of the coupon and/or the nominal to the current inflation rate.
   * @deprecated to be moved in another API
   */
  inflationProtected?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use 'instrumentShortName' */
  instrumentName: Scalars['String']['output'];
  /** Prefix Instrument classification in textual form. */
  instrumentNamePrefix: Scalars['String']['output'];
  /** Additional instrument type classifications in textual form. */
  instrumentNameSuffix?: Maybe<Scalars['String']['output']>;
  /** A free-form descriptive name of the instrument, assigned by the issuer. E.g. 6 % Reversy on XYZ Ltd. */
  instrumentProductName?: Maybe<Scalars['String']['output']>;
  /** Instrument short name. */
  instrumentShortName: Scalars['String']['output'];
  /** Status indicating whether an instrument is active or not. Provided that the instrument is still active, this may include further information such as "in default" or "In liquidation/dissolution". */
  instrumentStatus: InstrumentStatus;
  /** Instrument classification allocated by SIX Financial Information. The Instrument Type embodies a more granular categorization compared to the Security Type. */
  instrumentType: InstrumentType;
  /**
   * A supplementary instrument type generated by SIX Financial Information.
   * @deprecated to be moved in another API
   */
  instrumentTypeSupplement?: Maybe<InstrumentTypeSupplement>;
  /** It indicates the smallest denominations. Break-down of debt instrument by their nominal values (in Switzerland usually CHF 1000 and CHF 5000). For trusts the decimal places are indicated here, e.g. ",001" for proportions with fractions of 3 decimal places. */
  instrumentUnitSize?: Maybe<Scalars['Float']['output']>;
  /** Indicates the unit of measurement in which the instrument quantity is expressed: Per instrument or per nominal. For prices, this is the unit in which the instrument is traded. */
  instrumentUnitType?: Maybe<InstrumentUnit>;
  /**
   * Denoting ILS like cat bonds, longevity bonds, mortality bonds, industry loss warranties, sidecars, collat. reinsurance/retro, life settlements, embedded value financing.
   * @deprecated to be moved in another API
   */
  insuranceLinked?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Additional investor information.
   * @deprecated to be moved in another API
   */
  investorInfoCode?: Maybe<UnderlyingAsset>;
  /**
   * The first interest payment on an instrument that is more or less than interest payment of typical coupon.
   * A short coupon is when the issuer of an instrument makes a payment to the holders within a shorter interval than is normal for that instrument.
   * A long coupon refers to the interest payment that covers a longer period than the other coupons on an instrument.
   * @deprecated to be moved in another API
   */
  irregularFirstCoupon?: Maybe<IrregularCouponPeriod>;
  /**
   * The last interest payment on an instrument that is more or less than interest payment of typical coupon.
   * A short coupon is when the issuer of an instrument makes a payment to the holders within a shorter interval than is normal for that instrument.
   * A long coupon refers to the interest payment that covers a longer period than the other coupons on an instrument.
   * @deprecated to be moved in another API
   */
  irregularLastCoupon?: Maybe<IrregularCouponPeriod>;
  /** The International Securities Identification Number (ISIN) is a universally recognized and standardized code that uniquely identifies a financial instrument.  Its structure is defined in ISO 6166. */
  isin?: Maybe<Scalars['String']['output']>;
  /**
   * The date (ISO 8601) on which the issue takes place.
   * @deprecated to be moved in another API
   */
  issueDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Issue price.
   * @deprecated to be moved in another API
   */
  issuePrice?: Maybe<Scalars['Float']['output']>;
  /**
   * Issue Price currency according to ISO4217 alpha codes.
   * @deprecated to be moved in another API
   */
  issuePriceCurrency?: Maybe<Scalars['Currency']['output']>;
  /**
   * Original issue amount including possible increases (accumulations) during or after the issue of debt securities. After the issue, there are further instalments (accumulations) which are issued under the same or a different security number. For SIX Financial Information, the listed share is irrelevant for the evaluation of the issued capital. For debt securities (bonds and similar financial instruments), it is the issue amount that is relevant (borrowing amount).
   * @deprecated to be moved in another API
   */
  issuedAmount?: Maybe<Scalars['Float']['output']>;
  /**
   * Issued amount currency according to ISO4217 alpha codes.
   * @deprecated to be moved in another API
   */
  issuedAmountCurrency?: Maybe<Scalars['Currency']['output']>;
  /** Issuer is a legal entity that develops, registers and sells securities to finance its operations. Issuers may be corporations, investment trusts, or domestic or foreign governments. This is the present-day issuer of the financial instrument. */
  issuer?: Maybe<IssuerReference>;
  /** Main language applicable to the financial instrument according to ISO 639 alpha-2 code. It can be different from the issuing company's main language. */
  language?: Maybe<Language>;
  /**
   * Instrument Form indicates whether this instrument is a registered security, bearer security or based on a contract.
   * @deprecated to be moved in another API
   */
  legalForm?: Maybe<LegalForm>;
  /**
   * The dominant value of underlying asset class for all underlyings, which characterises best the ensemble of underlying instruments assigned by SIX Financial Information.
   * @deprecated to be moved in another API
   */
  mainUnderlyingAssetClass?: Maybe<MainUnderlyingAssetClass>;
  /**
   * Market Affiliation Classification.
   * @deprecated to be moved in another API
   */
  marketAffiliation?: Maybe<MazuMarketAffiliation>;
  /** Latest possible redemption date provided in the prospectus according to ISO 8601. This applies to all instruments for which only one maturity date was stated. If several dates were provided for the financial instrument (e.g. for ABS / Asset-Backed Securities), i.e. an expected maturity and a legal maturity, then this field will contain the date of the earliest possible maturity (Expected Maturity). */
  maturityDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Indicates whether an instrument has a fixed final expiry date or none at all */
  maturityType?: Maybe<Expiration>;
  /**
   * Code indicating that the financial instruments in question are not fully monitored by SIX Financial Information.
   * @deprecated to be moved in another API
   */
  monitoringRestriction?: Maybe<MonitoringRestriction>;
  /** The market with the largest number of orders to buy and sell for the financial instrument. */
  mostLiquidMarket?: Maybe<MarketReference>;
  /**
   * List of new instrument identifiers and short names after an instrument transformation became effective.
   * @deprecated to be moved in another API
   */
  newInstruments?: Maybe<Array<Maybe<InstrumentReference>>>;
  /**
   * Nominal or par value of an instrument (e.g. 100 for a share with a nominal value of CHF 100). For debt instruments, only the currency but no nominal value is issued.
   * @deprecated Use nominalAmount
   */
  nominal?: Maybe<Scalars['Float']['output']>;
  /** Nominal amount or par value of an instrument (e.g. 100 for a share with a nominal value of CHF 100). For debt instruments, only the currency but no nominal value is issued. */
  nominalAmount?: Maybe<Scalars['Float']['output']>;
  /** Nominal currency according to ISO 4217 alpha-3 code. */
  nominalCurrency?: Maybe<Scalars['Currency']['output']>;
  /** If the instrument is partly paid-up as opposed to fully paid-up, the currently paid-in amount is recorded here. No entry is made for fully paid-up instruments. */
  nominalPaidUp?: Maybe<Scalars['Float']['output']>;
  /**
   * This indicates whether it is possible to reduce the nominal value (nominal reduction per bond).
   * @deprecated to be moved in another API
   */
  nominalReduction?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Date of inclusion in the database of SIX Financial Information.
   * @deprecated to be moved in another API
   */
  openingDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Defines the type of right (or obligation) of the product from an investor's point of view. E.g. right to purchase (call), right to sell (put) or conversion right. */
  optionType?: Maybe<OptionType>;
  /**
   * An issuer is a legal entity that develops, registers and sells securities to finance its operations.
   * Issuers may be corporations, investment trusts, or domestic or foreign governments.
   * This is the original issuer of the financial instrument.
   * The original issuer will not be adjusted in the event of any subsequent changes such as name change, merger, demerger or reorganisation.
   * The original issuer is only provided if it differs to the present-day issuer.
   * @deprecated to be moved in another API
   */
  originalIssuer?: Maybe<IssuerReference>;
  /**
   * The issued capital reduced by the reserve shares still available and which is in principle completely subscribed and fully or partly paid. These shares are generally considered as good delivery in stock exchange trading. For SIX Financial Information, the listed share is irrelevant for the evaluation of the outstanding capital. For debt securities (bonds and similar financial instruments), the remaining currency is relevant, i.e. the issued instrument capital increased by accumulation and/or reduced by amortizations, redemptions in the market etc.
   * @deprecated to be moved in another API
   */
  outstandingAmount?: Maybe<Scalars['Float']['output']>;
  /**
   * The number of outstanding securities.
   * @deprecated to be moved in another API
   */
  outstandingSecurities?: Maybe<Scalars['Float']['output']>;
  /**
   * Indicates the equity nominal type
   * @deprecated to be moved in another API
   */
  parValueType?: Maybe<ParValueType>;
  /**
   * If the instrument is partly paid as opposed to fully paid-up, the currently paid in amount is recorded here. No entry is made for fully paid-up instruments.
   * @deprecated to be moved in another API
   */
  partlyPaid?: Maybe<Scalars['Float']['output']>;
  /**
   * This indicates whether the instrument is partially paid, i.e. not yet fully paid, and capital calls / subsequent payments are to be expected.
   * @deprecated to be moved in another API
   */
  partlyPaidIssue?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A free-form descriptive name of the instrument, assigned by the issuer, which indicates additional information to the product brand (e.g. Product brand = Reversy / Product name = 6 % Reversy on XYZ Ltd).
   * @deprecated Use instrumentProductName
   */
  productName?: Maybe<Scalars['String']['output']>;
  /**
   * This indicates whether the creditor (holder of the instrument) is free to terminate. This relates to redemption of the whole tranche or issue.
   * @deprecated to be moved in another API
   */
  puttable?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Currency of the redemption price according to ISO4217 alpha codes.
   * @deprecated to be moved in another API
   */
  redemptionPriceCurrency?: Maybe<Scalars['Currency']['output']>;
  /**
   * Value of the repayment of a security expressed as ratio of amounts (such as a treasury note, certificate of deposit, or bond) on or before its maturity date.
   * @deprecated to be moved in another API
   */
  redemptionRatio?: Maybe<Scalars['Float']['output']>;
  /**
   * Indicates whether the instrument provides for payment claims in conjunction with redemptions or amortizations that can be made in several currencies or in another currency than the nominal currency. This applies to fixed payments already specified at the time of issue by the issuer as well as to existing options to obtain the payment in another or in several other currencies. The currency is according to ISO4217 alpha code.
   * @deprecated to be moved in another API
   */
  repaymentsInOtherCurrencies?: Maybe<Scalars['Boolean']['output']>;
  /** Security classification allocated by SIX Financial Information.  The Security Type embodies a broader categoriatzion compared to the Instrument Type, specifially tailored for optimal presentation in display applications. */
  securityType: SecurityType;
  /**
   * This indicates the rank compared with other securities of the same type issued by the same issuer in the case of liquidation.
   * @deprecated to be moved in another API
   */
  seniority?: Maybe<Seniority>;
  /**
   * Indicates the type of bond issuer that applies. May cover countries, banks or financial institutions or any private bodies.
   * @deprecated to be moved in another API
   */
  sixBorrowerCategory?: Maybe<BorrowerCategory>;
  /**
   * Generic term of the fund type (e.g. equity fund, real estate fund, etc.) roughly indicating the fund's asset allocation.
   * @deprecated to be moved in another API
   */
  sixFundType?: Maybe<InvestmentFundType>;
  /**
   * The SIX long name is generated by SIX Financial Information. It consists of the "Issuer Long Name", the "Prefix" and the "Suffix". The "Prefix" is an instrument classification in textual form and the Suffix is an additional instrument type classification in textual form.
   * @deprecated to be moved in another API
   */
  sixLongName?: Maybe<Scalars['String']['output']>;
  /** SIX Financial Information assigns this version number to a contract. After changes in capital or other corporate actions a new version of an option or a future can be created and the version number is increased accordingly. */
  sixVersionNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * Break-down of debt instrument by their nominal values (in Switzerland usually CHF 1000 and CHF 5000). For trusts (type of security 7 and C) the decimal places are indicated here, e.g. ",001" for proportions with fractions of 3 decimal places.
   * @deprecated Use instrumentUnitSize
   */
  smallestDenomination?: Maybe<Scalars['Float']['output']>;
  /**
   * For non-par value shares, this is the computed par value.
   * @deprecated to be moved in another API
   */
  statedValue?: Maybe<Scalars['Float']['output']>;
  /**
   * Currency of the stated value according to ISO4217 alpha codes.
   * @deprecated to be moved in another API
   */
  statedValueCurrency?: Maybe<Scalars['Currency']['output']>;
  /** Price at which the holder of a call option can buy the underlying securities, currencies etc., or the holder of a put option can sell. Also called exercise price. Depending on the product type, strike prices define whether an embedded option in the product is "in the money" or not, the forward price of an embedded "plain forward" or the conversion price of a convertible bond at which the bond can be converted into the underlying. */
  strikePrice?: Maybe<Scalars['Float']['output']>;
  /** Specifies the currency of the Strike Price according to ISO 4217 alpha-3 code. */
  strikePriceCurrency?: Maybe<Scalars['Currency']['output']>;
  /** Trading currency of currency pairs used in currency dealings according to ISO 4217 alpha-3 code.  */
  tradingCurrency?: Maybe<Scalars['Currency']['output']>;
  /** It is the ultimate underlying instrument on which derivative instruments, such as futures and options, are based. For Options on Futures, it would correspond to the underlying of the Future. */
  ultimateUnderlyingInstrument?: Maybe<InstrumentReference>;
  /** It is the direct underlying instrument on which derivative instruments, such as futures and options, are based. */
  underlyingInstrument?: Maybe<InstrumentReference>;
  /**
   * Indicates the unit of measurement in which the instrument quantity is expressed: per instrument or per nominal. For prices, this is the unit in which the instrument is traded.
   * @deprecated Use instrumentUnitType
   */
  unit?: Maybe<InstrumentUnit>;
  /** Official national instrument identifier assigned by the National Numbering Agency responsible for Switzerland: SIX Financial Information. */
  valor: Scalars['Valor']['output'];
};

export type InstrumentSymbology = {
  __typename?: 'InstrumentSymbology';
  /** Official national instrument identifier assigned by the National Numbering Agency responsible for USA: Standard and Poor´s - CUSIP Global Services. The CINS (CUSIP International Numbering System) is used for non-domestic financial instruments. The CINS is 9 digits long and consists of 4 parts: 1. Country Code (1 digit) 2. Issuer Code (5 digits) 3. Issue (2 digits) 4. Check digit (1 digit). */
  cins?: Maybe<Scalars['String']['output']>;
  /** International instrument identifier assigned by either Clearstream or Euroclear. */
  commonCode?: Maybe<Scalars['String']['output']>;
  /** Cryptocurrency Symbol provided by CCData. */
  cryptocurrencySymbol?: Maybe<Scalars['String']['output']>;
  /** Official national instrument identifier assigned by the National Numbering Agency responsible for USA: Standard and Poor´s - CUSIP Global Services or Official national instrument identifier assigned by the National Numbering Agency responsible for Canada: The Canadian Depository for Securities Ltd. The CUSIP is used for financial instruments issued in the US and Canada. The CUSIP is 9 digits long and consists of 4 parts: 1. Country Code (1 digit) 2. Issuer Code (5 digits) 3. Issue (2 digits) 4. Check digit (1 digit). */
  cusip?: Maybe<Scalars['String']['output']>;
  /**
   * The FIGI (Financial Instrument Global Identifier) An identifier is assigned to instruments of all asset classes, is unique to an individual instrument and once
   * issued will not change for an instrument. For equity instruments an identifier is issued per instrument per trading venue.  https://www.openfigi.com/
   */
  figi?: Maybe<Scalars['String']['output']>;
  /** The FIGI (Financial Instrument Global Identifier) on Share Class level  is assigned to Equities and Funds. This enables users to link multiple Composite FIGIs for the same instrument in order to obtain an aggregated view for that instrument across all countries globally. https://www.openfigi.com/ */
  figiShareClass?: Maybe<Scalars['String']['output']>;
  /** Structure of the code in accordance with ISO standard 6166: Nine digit alpha-numerical code assigned by the national numbering agency followed by one check digit. */
  isin?: Maybe<Scalars['String']['output']>;
  /** The securities codes in Japan, the four-digit symbols used to identify publicly traded stocks and other investment products which are listed in Japan.  https://www.jpx.co.jp/english/sicc/code-pr/ */
  japaneseIssueCode?: Maybe<Scalars['String']['output']>;
  /** Official national instrument identifier assigned by the National Numbering Agency responsible for Japan: Securities Identification Code Committee (SICC). https://www.jpx.co.jp/english/sicc/regulations/b5b4pj0000023mqo-att/code_new.pdf */
  japaneseNewSecuritiesCode?: Maybe<Scalars['String']['output']>;
  /** Official national instrument identifier assigned by the National Numbering Agency responsible for the UK: London Stock Exchange. */
  sedol?: Maybe<Scalars['String']['output']>;
  /** Official national instrument identifier assigned by the National Numbering Agency responsible for Switzerland: SIX Financial Information. */
  valor: Scalars['Valor']['output'];
  /** WertPapierKennnummer is an official national instrument identifier assigned by the National Numbering Agency responsible for Germany: Wertpapier-Mitteilungen. */
  wkn?: Maybe<Scalars['String']['output']>;
};

/** Instrument classification allocated by SIX Financial Information. The Instrument Type embodies a more granular categorization compared to the Security Type. */
export enum InstrumentType {
  /**
   * Bonds indicating the same interest payment amount during the entire period or for which the prospectus defines either one interest payment or none at all or for which the exact redemption amount is known upon issuance.
   * Examples: bonds without conversion rights (including fixed interest bonds without conversion rights); Zerobonds (without conversion rights); STRIPS (Separate Trading of Registered Interest and Principal Securities, so called discounted securities); fungible Promissory-Notes; compound instruments consisting of several bonds.
   */
  Bond = 'BOND',
  /** This type of security is assigned to standardised Combined transactions (i.e. transactions made up of at least two separate instruments), e.g. Interest rate SWAPS. This only includes 'simple' types of combined transactions where the contract does not include any special conditions. */
  CombinedTransaction = 'COMBINED_TRANSACTION',
  /** Denotes commodities (example: precious metal reserves). */
  Commodity = 'COMMODITY',
  /** Debt instruments with an option or obligation to convert, generally into equity securities issued by the same institution. */
  ConvertibleBond = 'CONVERTIBLE_BOND',
  /** Denotes national currencies (example: USD by the Federal Reserve Bank). */
  Currency = 'CURRENCY',
  /** Covers all types of shares (incl. the different types of pfd./pref. shares), units and participation certificates. In this context, 'unit' stands for compounds of equity and similar instruments (e.g. Units / consisting of 10 shares + 1 warrant). */
  Equity = 'EQUITY',
  /** Specification of an ETD contract. For each contract specification, individual contracts (series) are issued which can be either options or futures. */
  Etd = 'ETD',
  /** This type of security is assigned to standardised forward contracts with all kinds of instruments, including Report transactions France (standardised forward transactions on shares in the French market). */
  ForwardTransaction = 'FORWARD_TRANSACTION',
  /** Debt instruments with variable interest rates or variable interest amount. */
  Frn = 'FRN',
  /** May only be used for Financial Futures (standardized contracts) and for futures on commodities (e.g. Crude Oil Futures). */
  Future = 'FUTURE',
  /** Denotes an Index (example: Swiss Market Index SMI, STOXX Index, etc.). */
  Index = 'INDEX',
  /** Insurance policy. */
  InsurancePolicy = 'INSURANCE_POLICY',
  /** Interest rate. */
  InterestRate = 'INTEREST_RATE',
  /** Leveraged products such as warrants embody the right to buy (call) or to sell (put) an underlying instrument. Main criteria are: a) their exercise period is defined, and b) they are exercisable. */
  LeveragedProduct = 'LEVERAGED_PRODUCT',
  /** Used for money market instruments such as certificates of deposit, treasury bills, commercial papers, etc. irrespective of the length of their validity period (more or less than 1 year). */
  MoneyMarketInstrument = 'MONEY_MARKET_INSTRUMENT',
  /** Medium Term Note including Bank-issued MTN, German savings bond, savings certificate, collective security number for Banker's Acceptance, etc. Unlike traditional bonds, Bank-issued MTN (cash bonds) are not available only during a specific subscription period, but are issued continuously by the banks and have a maturity or a refinancing profile of over one year. */
  Mtn = 'MTN',
  /** This code may only be used for Traded Options (standardized contracts) e.g. on indices, currencies, futures, commodities and particular securities. */
  Option = 'OPTION',
  /** Other instruments with/without cash-flow. */
  Other = 'OTHER',
  /** This code is used exclusively for REPOs (standardized and interest-bearing contracts based on securities deposited with SIX SIS and assigned as collateral). In a repo (repurchase agreement) the cash taker sells securities to the cash provider while at the same time agreeing to repurchase securities of the same type and quantity at a later date. */
  Repo = 'REPO',
  /** Is used exclusively for REPO baskets i.e. baskets comprising financial instruments of the same quality (e.g. the ten most liquid equities in the Swiss Market Index). */
  RepoBasket = 'REPO_BASKET',
  /** Denotes rights or subscription rights (in connection with capital changes and stock dividends, e.g. in the Netherlands). */
  Right = 'RIGHT',
  /** Investment or deposit saving books. */
  SavingsBook = 'SAVINGS_BOOK',
  /** Structured products are characterized by at least one cash flow stream (principal, income) being dependent up on one or more underlyings. From the economic perspective, they are a combination of a classic investment (e.g. bond, equity) and derivatives. */
  StructuredProduct = 'STRUCTURED_PRODUCT',
  TechnicalCurrency = 'TECHNICAL_CURRENCY',
  /** Denotes an instrument issued by unit trusts or open-end mutual funds based on a 'collective investment contract' and for instruments representing an entitlement to investment foundations. */
  TrustCertFoundation = 'TRUST_CERT_FOUNDATION',
  /** Part in a co-operative. By subscribing a participation certificate the holder becomes a co-partner. Each co-partner has only one (1) voting right at the general meeting, regardless of the amount of subscribed participation certificates. */
  TrustCertShare = 'TRUST_CERT_SHARE',
  /** Investment trust share. */
  TrustShare = 'TRUST_SHARE'
}

/** InstrumentType filters */
export type InstrumentTypeFilters = {
  instrumentType?: InputMaybe<Array<InputMaybe<InstrumentType>>>;
};

/** SIX type of security supplement. */
export enum InstrumentTypeSupplement {
  /** Financial instruments with a par/face value of less than 1000 USD. Baby bonds may represent liabilities or equity capital (security type 0 or 1) and are designed to open the market to small investors. */
  BabyBond = 'BABY_BOND',
  /** Bond/Money market funds with yield calculated by fund management. */
  BondMoneyMarketFundsWithYield = 'BOND_MONEY_MARKET_FUNDS_WITH_YIELD',
  /** Daily contracts have very short life-cycles of 1 or 2 business days. Daily contracts are usually traded only on one business day i.e. they expire on the same day (may not be rolled over) and they are settled in cash. */
  DailyContract = 'DAILY_CONTRACT',
  /** This type of security supplement is assigned to instruments originally captured as type of security 'G' (Dividend-right certificate). */
  DividendRightCertificate = 'DIVIDEND_RIGHT_CERTIFICATE',
  /** Low Exercise Price Option. */
  Lepo = 'LEPO',
  /** Agreement to transfer money from a lender to a borrower and the promise by the borrower to repay the money to the lender and pay an agreed rate of interest on the outstanding amount. */
  Loan = 'LOAN',
  /** Mini-futures enable investors to participate in the performance of an underlying with leverage. Investors in long mini-futures expect the underlying to gain value, while investors in short mini-futures expect it to lose value. The bulk of the investment is provided by the issuer (financing level), with the investors paying a margin. Another feature of mini-futures is their stop-loss barrier, which limits the potential loss on the underlying. This contrasts with conventional futures, for which losses can trigger a margin call. */
  MiniFutures = 'MINI_FUTURES',
  Other = 'OTHER',
  /** A structured financial instrument with special features such as a zero coupon bond that provides for a guarantee of the capital repayment combined with an option strategy which aims at achieving additional payoff (for interest/income payment). In VDF, the strike price of such embedded option strategies is not explicitly delivered and instead, such interest/income payments are stated as 'variable' payments. Hence, none of such interest/income payments is delivered with the interest type 'option-like'. The security supplement type 'X' is assigned to instruments of the type of security 'L', '0', 'Q' und 'V'. The repayment is not dependent on an underlying instrument. Such instruments are typically issued for investment purposes and not for financing purposes of the issuer. */
  StructuredInstrumentCapitalProtected = 'STRUCTURED_INSTRUMENT_CAPITAL_PROTECTED',
  /** TBAs are opened as collective securities. They represent pools which are to be opened later as mortgage-backed securities and are only meant to trade on a generic or to-be-announced basis. Therefore, there is no additional basic data expected for these securities. */
  TbaToBeAnnounced = 'TBA_TO_BE_ANNOUNCED',
  /** In contrast to Monthly contracts, series of Weekly contracts will expire for example on the first, second, fourth or fifth Friday of a calendar month, respectively. If no fifth Friday exists in the month under review, the contract will usually expire in the following month that includes a fifth Friday. The usual contract parameters will remain exactly the same as for Monthly contracts. */
  WeeklyContract = 'WEEKLY_CONTRACT',
  /** Write-down / Off Bonds are financial instruments which are not converted, as is the case with CoCos, but their value is written down instead. Therefore, no additional capital is made available, but the liabilities are reduced as a result of the valuation adjustment. */
  WriteDownOffBond = 'WRITE_DOWN_OFF_BOND',
  /** Write-down bonds with potential write up are financial instruments which are not converted, as is the case with CoCos, but their value is written down instead. Therefore, no additional capital is made available, but the liabilities are reduced as a result of the valuation adjustment. the Bank may in certain circumstances at its full discretion increase the Prevailing Principal Amount of each Note. If the Bank records a positive Net Profit or, to the extent permitted by Applicable Banking Regulations then in force, the bank records a positive Consolidated Net Profit at any time while the Prevailing Principal Amount of the Notes is less than their Initial Principal Amount, the Bank may, at its full discretion and subject to the Maximum Distributable Amount (when the amount of the Write-Up is aggregated together with other distributions of the Bank, not being exceeded thereby, increase the Prevailing Principal Amount of each Note (a Write-Up) up to a maximum of the Initial Principal Amount. */
  WriteDownWithPotentialWriteUp = 'WRITE_DOWN_WITH_POTENTIAL_WRITE_UP'
}

export enum InstrumentUnit {
  /** Nominal value: The price of a security (stocks, shares, bonds etc.) when originally issued. This bears no relation to the market price. Also known as face value or par value. */
  Nominal = 'NOMINAL',
  Other = 'OTHER',
  PieceUnit = 'PIECE_UNIT'
}

export type IntradayHistory = {
  __typename?: 'IntradayHistory';
  /**
   * With IntradayHistorySummary you may request aggregated price and trading activity for a specific period, with fields: open, high, low, last, volume and number of trades. The time series is delivered backwards from the "dateTo". The following considerations apply:
   *
   * | Max. Duration Per Request | Historical Depth | Max. Records Per Request | Default records per request |
   * |:-------------------------:|:----------------:|:------------------------:|:---------------------------:|
   * | 2 days                    | 10 days          | 50000                    | 5000*                       |
   *
   * *default records per request are only applied if no "dateFrom" has been defined.
   */
  summary?: Maybe<Array<Maybe<IntradayHistorySummary>>>;
  /**
   * With the IntradayHistoryTrades you may request all the trades and best quotes at the moment of the trade. The available price fields are: Trade, BestBid and BestAsk. The time series is delivered backwards from the "dateTo". The following considerations apply:
   *
   * | Period            | Max. Duration Per Request | Historical Depth    | Max. Records Per Request | Default records per request |
   * |:-----------------:|:-------------------------:|:-----------------:|:------------------------:|:---------------------------:|
   * |1 sec <= x < 5 min | 2 days                    | 10 days           | 20000                    | 1600*                       |
   * |5 min <= x <= 60min| 30 days                   | 90 days          | 20000                    | 1600*                       |
   *
   * *default records per request are only applied if no "dateFrom" has been defined.
   */
  trades?: Maybe<Array<Maybe<IntradayHistoryTrades>>>;
};


export type IntradayHistorySummaryArgs = {
  filters?: InputMaybe<IntradayHistorySummaryFilter>;
};


export type IntradayHistoryTradesArgs = {
  filters?: InputMaybe<IntradayHistoryTradesFilter>;
};

/** Intraday History Price Adjustment */
export enum IntradayHistoryPriceAdjustment {
  /** Prices are after the occurrence of corporate action events historically adjusted for the requested period. */
  Adjusted = 'ADJUSTED',
  /** Prices are not adjusted. */
  Unadjusted = 'UNADJUSTED'
}

export type IntradayHistorySummary = {
  __typename?: 'IntradayHistorySummary';
  /** A High shows the intraday price swings, i.e. the highest price reached during the day. The high price enables the investor to directly estimate the daily price swings and the state of the market. The Daily High is a key input for charting. */
  high?: Maybe<Scalars['Float']['output']>;
  /** Date and time in ISO-8601 when the interval starts. */
  intervalFrom?: Maybe<Scalars['ZonedDateTime']['output']>;
  /** Date and time in ISO-8601 when the interval ends. */
  intervalTo?: Maybe<Scalars['ZonedDateTime']['output']>;
  /**
   * A Last is the most recent price which, after a successful matching of buy and sell orders, is eligible to update the last trade. The Last Trade is required so that market participants can see the trade prices and estimate the impact of their order and the probability of getting the order fully executed.
   *
   * Furthermore, trades are required for valuation purposes, understanding if an order was executed, understanding the change in the value of a security over time, understanding liquidity and the speed of trading.
   */
  last?: Maybe<Scalars['Float']['output']>;
  /** A Low shows the intraday price swings, i.e. the lowest price reached during the day. The low price enables the investor to directly estimate the daily price swings and the state of the market. The Daily Low is a key input for charting. */
  low?: Maybe<Scalars['Float']['output']>;
  /** The number of trades per interval. */
  numberOfTrades?: Maybe<Scalars['Int']['output']>;
  /** An Open is associated with the first transaction of the day. It follows immediately after the opening auction (if any) is completed. It is an opening price or first recorded price of the trading day - any value that the provider officially designates as the open. It is not necessarily a transacted price. */
  open?: Maybe<Scalars['Float']['output']>;
  /** Volume is the volume on market which is a number of units/nominal/contracts traded on market during a session. It is mainly used for analytical purposes and can be used for time series and historical data or data studies to compare it with the associated price action. */
  volume?: Maybe<Scalars['Float']['output']>;
};

export type IntradayHistorySummaryFilter = {
  /** Start date of the history as local date of the market. If it is missing or earlier than the maximum duration per request from today, the delivery will start with "dateTo" backwards to deliver maximum records. Date to be provided in ISO-8601. */
  dateFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  /** End date (inclusive) of the history as local date of the market. If missing, the date and time of the request will be used. Date to be provided in ISO-8601. */
  dateTo?: InputMaybe<Scalars['LocalDate']['input']>;
  /**
   * Time interval with which intraday historical prices are being delivered. It must be provided as Durations ISO-8601: P[n]Y[n]M[n]DT[n]H[n]M[n]S
   *
   * Currently the smallest possible period interval to request data is seconds (1 second) and the largest is minutes (60 minutes).
   *
   * Possible period intervals:
   *
   * Seconds: "PT1S" (1 sec)
   * Minutes: "PT1M" (1 min); "PT5M" (5min); "PT10M" (10min); "PT15M" (15 min); "PT30M" (30 min); "PT60M" (60 min)
   */
  period?: InputMaybe<Scalars['Duration']['input']>;
  /**
   * UNADJUSTED = Prices are not adjusted.
   * ADJUSTED (default value) = The prices are after the occurrence of corporate action events historically adjusted.
   */
  priceAdjustment?: InputMaybe<IntradayHistoryPriceAdjustment>;
  /** Start time of the history in local time of the market. If it is missing, the time will be set to the default value "00:00:00". Time to be provided in ISO-8601 without timezone. */
  timeFrom?: InputMaybe<Scalars['LocalTime']['input']>;
  /** End time (inclusive) of the history in local time of the market. If missing, the time will be set to the default value "23:59:59". Time to be provided in ISO-8601 without timezone. */
  timeTo?: InputMaybe<Scalars['LocalTime']['input']>;
};

export type IntradayHistoryTrades = {
  __typename?: 'IntradayHistoryTrades';
  /**
   * An Ask (also known as an Offer) is a price at which securities, foreign exchange, or foreign bank notes are offered for sale.
   * The Best Ask is the lowest price offered by a stock's market makers to sell a particular trading instrument. It is the lowest price that an investor is willing to sell an asset for.
   */
  bestAsk?: Maybe<IntradayValueAndSize>;
  /**
   * A Bid is an offer made by a trader, investor or other industry professional to purchase a security.
   * The Best Bid is the highest price offered by a stock's market makers to buy a particular trading instrument. It is the highest price that an investor is willing to pay for an asset.
   */
  bestBid?: Maybe<IntradayValueAndSize>;
  /** Date and time in ISO-8601 of the session. */
  timestamp?: Maybe<Scalars['ZonedDateTime']['output']>;
  /** Trade is a basic economic concept involving the buying and selling of goods and services, with compensation paid by a buyer to a seller, or the exchange of goods or services between parties. In financial markets, trading refers to the buying and selling of securities, such as the purchase of stock on the exchange's floor. */
  trade?: Maybe<IntradayValueAndSize>;
};

export type IntradayHistoryTradesFilter = {
  /** Start date of the history as local date of the market. If it is missing or earlier than the maximum duration per request from today, the delivery will start with "dateTo" backwards to deliver maximum records. */
  dateFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  /** End date (inclusive) of the history as local date of the market. If missing, the date and time of the request will be used. */
  dateTo?: InputMaybe<Scalars['LocalDate']['input']>;
  /**
   * UNADJUSTED = Prices are not adjusted.
   * ADJUSTED (default value) = The prices are after the occurrence of corporate action events historically adjusted.
   */
  priceAdjustment?: InputMaybe<IntradayHistoryPriceAdjustment>;
  /** Start time of the history in local time of the market. If it is missing, the time will be set to the default value "00:00:00". */
  timeFrom?: InputMaybe<Scalars['LocalTime']['input']>;
  /** End time (inclusive) of the history in local time of the market. If missing, the time will be set to the default value "23:59:59". */
  timeTo?: InputMaybe<Scalars['LocalTime']['input']>;
};

/**
 * Intraday Snapshot API is used to capture market data in real time at the point of request without any further updates. It summarizes current market activity and is allowing someone to synchronize with the real-time data and quickly process key information about market movements.
 * It's often being used for technical analysis.
 */
export type IntradaySnapshot = {
  __typename?: 'IntradaySnapshot';
  /** The Accrued interest refers to the interest that has accumulated on a fixed-income security but has not yet been paid to the investor. If no value is available for the current day, the value of the previous day is delivered. */
  accruedInterest?: Maybe<Value>;
  /**
   * The Auction Theoretical Matching Price, determined by the provider, is a price at which the maximum volume of orders can be executed at the time of an auction. The Theoretical Matching Price facilitates price discovery and transparency while helping resolve order imbalances. It shows at what price the trading would start if the order book was opened immediately. It is sometimes required by regulators to implement a smooth (re)opening and is used by investors to stop the point at which the balanced market would be priced.
   * While the Theoretical Matching Price is calculated in all auction types (e.g. opening, intraday, discreet, etc.), it has is an additional significance in the opening and closing auctions:
   * At the end of the Opening Auction the Theoretical Matching Price is used to generate an Open Price.
   * At the end of the Closing Auction the Theoretical Matching Price is used to generate a Close Price.
   * Note that in some markets this price could be called Indicative Match Price, Equilibrium Price, etc. If no value is available for the current day, the value of the previous generation is delivered.
   */
  auctionTheoreticalMatchingPrice?: Maybe<Value>;
  /**
   * An Ask (also known as an Offer) is a price at which securities, foreign exchange, or foreign bank notes are offered for sale.
   * The Best Ask is the lowest price offered by a stock's market makers to sell a particular trading instrument. It is the lowest price that an investor is willing to sell an asset for.
   */
  bestAsk?: Maybe<ValueAndSize>;
  /**
   * A Bid is an offer made by a trader, investor or other industry professional to purchase a security.
   * The Best Bid is the highest price offered by a stock's market makers to buy a particular trading instrument.
   * It is the highest price that an investor is willing to pay for an asset.
   */
  bestBid?: Maybe<ValueAndSize>;
  /** The Break Even Point refers to the point at which the gains or losses from an investment or trade are equal to zero. It is the price or level of an asset at which there is neither profit nor loss. In other words, it is the point where the investor  has recouped their initial investment or reached a balance between costs and gains. If no value is available for the current day, the value of the previous day is delivered. */
  breakEvenPoint?: Maybe<Value>;
  /** The Close can either be derived from the final transaction conducted during the day or calculated by the provider. While it may not necessarily match the Last, it consistently reflects the official closing price, serving as a reliable measure of the day's concluding value. If no value is available for the current day, the value of the previous day is delivered. */
  close?: Maybe<ValueAndSize>;
  /** The Close Year is the end of the year valuation price determined by SIX. Prices are selected by SIX at the last busines day of the year. Subsequent updates valid for the preceding year and reported after 31 December are possible. */
  closeYear?: Maybe<Value>;
  /** The Convexity quantifies how the bond's price  deviates from the linear approximation of duration based on the time to maturity. Positive convexity means that as interest rates decrease, the bond's price increases at an increasing rate, while negative convexity implies that as rates increase, the bond's price decreases at an increasing rate. If no value is available for the current day, the value of the previous day is delivered. */
  convexity?: Maybe<Value>;
  /** The Delta is a measure of an option's sensitivity to changes in the price of the underlying asset. It indicates the expected change in the option price for every 1 currency unit change in the underlying asset. Delta helps traders and investors manage risk and create delta-neutral portfolios to mitigate exposure to price fluctuations. If no value is available for the current day, the value of the previous day is delivered. */
  delta?: Maybe<Value>;
  /** A Dividend Yield is the annualized gross yield based on the market price of a share. The dividend amount paid is based on the actual historical regular dividend payments looking back 12 months (trailing dividend method). If the market is not yet closed or/and the embargo time has not yet elapsed, the previous generation value is provided. */
  dividendYield?: Maybe<Value>;
  /** The Duration represents the weighted average time (in years) it takes for an investor to receive the present value of the bond's cash flows, including coupon payments and the return of principal based on the time to maturity. Duration helps assess the price volatility and interest rate risk of fixed-income investments. Generally, higher-duration securities are more sensitive to interest rate changes, while lower-duration securities are less affected by interest rate movements. If no value is available for the current day, the value of the previous day is delivered. */
  duration?: Maybe<Value>;
  /** The Gamma is a measure of the rate of change in an option's delta in response to changes in the price of the underlying asset. It represents the acceleration of delta. A higher gamma indicates that the delta of an option will change more rapidly in response to small movements in the underlying asset's price, while a lower gamma implies slower changes in delta. Gamma is important for options traders as it helps them assess and manage the risk associated with changes in delta and underlying asset prices. If no value is available for the current day, the value of the previous day is delivered. */
  gamma?: Maybe<Value>;
  /** The Gearing shows the ratio between the price of the underlying security and the price of the option. Also known as simple gearing. If no value is available for the current day, the value of the previous generation is delivered. */
  gearing?: Maybe<Value>;
  /** A High shows the intraday price swings, i.e. the highest price reached during the day. The high price enables the investor to directly estimate the daily price swings and the state of the market. The Daily High is a key input for charting. If no value is available for the current day, the value of the previous day is delivered.     */
  high?: Maybe<ValueAndSize>;
  /** The High 1 Week indicates the highest price a security reached during the last week. It provide an overview over market tops and is used as a high band of history charts in trading. If no value is available for the current day, the value of the generation is delivered. */
  high1Week?: Maybe<Value>;
  /** The High 4 Week indicates the highest price a security reached during the last 4 weeks. It provide an overview over market tops and is used as a high band of history charts in trading. If no value is available for the current day, the value of the generation is delivered. */
  high4Week?: Maybe<Value>;
  /** The High 12 Week indicates the highest price a security reached during the last 12 weeks. It provide an overview over market tops and is used as a high band of history charts in trading. If no value is available for the current day, the value of the generation is delivered. */
  high12Week?: Maybe<Value>;
  /** The High 26 Week indicates the highest price a security reached during the last 26 weeks. It provide an overview over market tops and is used as a high band of history charts in trading. If no value is available for the current day, the value of the generation is delivered. */
  high26Week?: Maybe<Value>;
  /** A 52-Week High indicate the highest price a security reached during the last 52 weeks. It provide an overview over market tops and is used as a high band of history charts in trading. If no value is available for the current day, the value of the previous day is delivered. */
  high52Week?: Maybe<Value>;
  /** The High Static Limit is a provider or SIX calculated upper limit for price movements within a trading day. It is a static limit determined at the start of the trading day. Based on the high static limit market participants can estimate the price level for a possible volatility interruption and place their orders accordingly to profit from price spikes and price volatility. */
  highStaticLimit?: Maybe<Value>;
  /** The High Year To Date indicates the highest price for the calendar year based on the intraday high prices from 1 January to 31 December. If no value is available for the current day, the value of the previous day is delivered. */
  highYearToDate?: Maybe<Value>;
  /** The Historical 30 Days Volatility refers to the measure of the price volatility of an underlying asset over a specific historical period of 30 days. It calculates the standard deviation of the asset's prices during that period to gauge the level of volatility experienced by the asset. Historical 30 Days Volatility provides a snapshot price fluctuations, allowing investors to assess the short-term volatility characteristics of the asset and make informed decisions based on the observed historical volatility patterns. If no value is available for the current day, the value of the previous day is delivered. */
  historicalVolatility30Days?: Maybe<Value>;
  /** The Historical 90 Days Volatility refers to the measure of the price volatility of an underlying asset over a specific historical period of 90 days. It calculates the standard deviation of the asset's prices during that period to gauge the level of volatility experienced by the asset. Historical 90 Days Volatility provides a snapshot price fluctuations, allowing investors to assess the short-term volatility characteristics of the asset and make informed decisions based on the observed historical volatility patterns. If no value is available for the current day, the value of the previous day is delivered. */
  historicalVolatility90Days?: Maybe<Value>;
  /** The Historical 180 Days Volatility refers to the measure of the price volatility of an underlying asset over a specific historical period of 180 days. It calculates the standard deviation of the asset's prices during that period to gauge the level of volatility experienced by the asset. Historical 180 Days Volatility provides a snapshot price fluctuations, allowing investors to assess the short-term volatility characteristics of the asset and make informed decisions based on the observed historical volatility patterns. If no value is available for the current day, the value of the previous day is delivered. */
  historicalVolatility180Days?: Maybe<Value>;
  /** The Historical 250 Days Volatility refers to the measure of the price volatility of an underlying asset over a specific historical period of 250 days. It calculates the standard deviation of the asset's prices during that period to gauge the level of volatility experienced by the asset. Historical 180 Days Volatility provides a snapshot price fluctuations, allowing investors to assess the short-term volatility characteristics of the asset and make informed decisions based on the observed historical volatility patterns. If no value is available for the current day, the value of the previous day is delivered. */
  historicalVolatility250Days?: Maybe<Value>;
  /** The Implied Volatility refers to the market's expectation of the future volatility of an underlying asset. It represents the level of uncertainty or anticipated price fluctuations that market participants believe the asset will experience over a specified period. Higher implied volatility suggests greater expected price swings, while lower implied volatility indicates a calmer or more stable market expectation. If no value is available for the current day, the value of the previous day is delivered. */
  impliedVolatility?: Maybe<Value>;
  /** The Intrinsic Value refers to the inherent value of an option or a security, independent of its market price. It represents tha actual worth of an option or security based on its underlying assets or cash flows. In the case of options, the intrinsic value is the difference between the current price of the underlying asset and the option's strike price, if it is in-the-money. If an option is out-of-the-money, the intrinsic value is zero. If no value is available for the current day, the value of the previous day is delivered. */
  intrinsicValue?: Maybe<Value>;
  /** The Last represents the latest price attained during the main trading session when a financial asset was last traded. The price also serves as a reliable indicator of the most recent price for various asset classes, such as Equities, Bonds, Indices, Funds, Currencies, Reference Prices, Derivatives, and more. If no value is available for the current day, the value of the previous day is delivered. */
  last?: Maybe<ValueAndSize>;
  /** A Low shows the intraday price swings, i.e. the lowest price reached during the day. The low price enables the investor to directly estimate the daily price swings and the state of the market. The Daily Low is a key input for charting. If no value is available for the current day, the value of the previous day is delivered. */
  low?: Maybe<ValueAndSize>;
  /** A Low 1 Week indicates the lowest price a security reached during the last week. It provides an overview over market bottoms and is used as low band of history charts in trading. If no value is available for the current day, the value of the previous generation is delivered. */
  low1Week?: Maybe<Value>;
  /** A Low 4 Week indicates the lowest price a security reached during the last 4 weeks. It provides an overview over market bottoms and is used as low band of history charts in trading. If no value is available for the current day, the value of the previous generation is delivered. */
  low4Week?: Maybe<Value>;
  /** A Low 12 Week indicates the lowest price a security reached during the last 12 weeks. It provides an overview over market bottoms and is used as low band of history charts in trading. If no value is available for the current day, the value of the previous generation is delivered. */
  low12Week?: Maybe<Value>;
  /** A Low 26 Week indicates the lowest price a security reached during the last 26 weeks. It provides an overview over market bottoms and is used as low band of history charts in trading. If no value is available for the current day, the value of the previous generation is delivered. */
  low26Week?: Maybe<Value>;
  /** A 52-Week Low  indicate the lowest price a security reached during the last 52 weeks. They provide an overview over market bottoms and is used as low band of history charts in trading. If no value is available for the current day, the value of the previous day is delivered.     */
  low52Week?: Maybe<Value>;
  /** The Low Static Limit is a provider or SIX calculated lower limit for price movements within a trading day. It is a static limit determined at the start of the trading day. Based on the low static limit market participants can estimate the price level for a possible volatility interruption and place their orders accordingly to profit from price spikes and price volatility. */
  lowStaticLimit?: Maybe<Value>;
  /** The Low Year To Date indicates the lowest price for the calendar year based on the intraday low prices from 1 January to 31 December. If no value is available for the current day, the value of the previous day is delivered. */
  lowYearToDate?: Maybe<Value>;
  /** The Market Capitalisation refers to the total market value of a company's outstanding shares of stock. If the market is not yet closed or/and the embargo time has not yet elapsed, the previous generation value is provided. */
  marketCapitalisation?: Maybe<Value>;
  /** The Mid is a price between the buying and selling price during the same trading session. Since Bids and Asks most of the time are quoted in equal distance from the fair value, a Mid calculation can approximate the fair value of an instrument and be useful while trading less liquid instruments. If no value is available for the current day, the value of the previous generation is delivered. */
  mid?: Maybe<Value>;
  /** The Modified Duration represents an adjusted version of the duration that takes into account the bond's yield-to-maturity. Modified duration quantifies the percentage change in the bond's price for a given change in yield based on the time to maturity. It helps investors assess the potential impact of interest rate fluctuations on bond prices and make informed decisions regarding fixed-income investments. If no value is available for the current day, the value of the previous day is delivered. */
  modifiedDuration?: Maybe<Value>;
  /** The Moneyness refers to the relationship between the current price of an underlying asset and the strike price of an option. It indicates the percentage by which the strike price is above or below the current price of the underlying asset.  It shows if an option is in-the-money, at-the-money, or out-of-the-money. In-the-money options have a strike price favorable to the current price of the underlying asset, while out-of-the-money options have a strike price unfavorable to the current price. Moneyness is a crucial factor in options pricing and trading strategies. If no value is available for the current day, the value of the previous day is delivered. */
  moneyness?: Maybe<Value>;
  /** The Number of Trades is the number of daily transactions during an exchange session. It indicates how many trades are made in a given instrument over a certain period of time. It helps to estimate the liquidity of the particular security and/or detect an unusual activity level on a listing. If no value is available for the current day, the value of the previous generation is delivered. */
  numberOfTrades?: Maybe<Value>;
  /** The Omega represents the percentage change in an option's value with respect to the percentage change in the underlying price and measures the leverage of an options position. A measure for assessing the leverage of options and/or warrants. It indicates the percentage by which the price of a call (put) will increase (decrease) if the price of the underlying security rises by one percent. Also known as effective gearing.  If no value is available for the current day, the value of the previous generation is delivered. */
  omega?: Maybe<Value>;
  /** An Open is associated with the first transaction of the day. It follows immediately after the opening auction (if any) is completed. It is an opening price or first recorded price of the trading day - any value that the provider officially designates as the open. It is not necessarily a transacted price. If no value is available for the current day, the value of the previous day is delivered. */
  open?: Maybe<ValueAndSize>;
  /** An Open Interest is an amount of open derivative contracts that are not closed or delivered on a particular day. It indicates the most active derivative contracts. The Open interest decreases when buyers (or holders) and sellers (or writers) of contracts close out more positions than were opened that day. If no value is available for the current day, the value of the previous day is delivered. */
  openInterest?: Maybe<Value>;
  /** The Percentage Change 5 Days provides the percentage difference in the price of a financial instrument over a period of five trading days. It measures the relative price movement of the instrument over a short-term timeframe. It is calculated with the previous day price of the instrument compared to the closing price six trading days ago. */
  percentageChange5Days?: Maybe<Value>;
  /** The Percentage Change Year To Date provides the percentage difference in the price of a financial instrument from the end of the previous calendar year to the previous day. It provides an indication of the price performance of an instrument. It is calculated with the previous day price compared to the previous year close price of the instrument. */
  percentageChangeYearToDate?: Maybe<Value>;
  /** The Percentage Spread Best Bid Ask is the percentage difference between the best bid and the best ask. It is the cost of executing an immediate trade, as a buyer would have to pay the ask price and a seller would receive the bid price. The narrower the bid-ask spread, the more liquid and competitive the market tends to be. A wider spread can indicate less liquidity and potentially higher trading costs. */
  percentageSpreadBestBidAsk?: Maybe<Value>;
  /** The Performance Year To Date provides the total return performance year-to-date in percentage. It is calculated compared to the previous year close trade and includes dividend reinvestment. If no value is available for the current day, the value of the previous day is delivered. */
  performanceYearToDate?: Maybe<Value>;
  /** The Price Earnings Ratio Estimated is the relationship of the share price to the net profit of the company. It is calculated by dividing the market price of the shares by the estimated earnings per share. If no value is available for the current day, the value of the previous day is delivered. */
  priceEarningsRatioEstimated?: Maybe<Value>;
  /** The Price Earnings Ratio Reported is the relationship of the share price to the net profit of the company. It is calculated by dividing the market price of the shares by the reported earnings per share. If no value is available for the current day, the value of the previous day is delivered. */
  priceEarningsRatioReported?: Maybe<Value>;
  /**
   * The up-to-dateness of price data, also referred to as 'Data Quality Timeliness' or 'License Quality,' is determined by the default priority when no specific quality is chosen by the client in their request. The available quality levels are delivered based on the following order:
   *
   * 1. REAL_TIME
   * 2. DELAYED
   * 3. END_OF_DAY
   * 4. PREVIOUS_DAY
   */
  qualityOfService?: Maybe<QualityOfService>;
  /** The Reported Price signifies the latest recorded price at which a financial asset was traded and reported. While it may align with the Last price, it covers a broader scope by including pre- and post-market sessions, price corrections, off-market trades, and odd lot trades. This comprehensive approach ensures that all transactions throughout the day are included, providing a comprehensive view of the asset's trading activity. If no value is available for the current day, the value of the previous day is delivered. */
  reportedPrice?: Maybe<ValueAndSize>;
  /** The Rho is a measure of the sensitivity of an option's price to changes in interest rates. It represents the expected change in the option price for a 1% change in the risk-free interest rate. Rho is important for options traders and investors as it helps them evaluate the impact of interest rate fluctuations on option prices and make informed decisions regarding their options portfolio. If no value is available for the current day, the value of the previous day is delivered. */
  rho?: Maybe<Value>;
  /**
   * A Settlement Price is a price at which all the open contracts are settled in cash at the custodian level. This value is disseminated by the provider. It values the derivative's portfolio at the end of the trading day. It is used to calculate the margin requirements on the basis of its value and the provided collateral. It is the most important data attribute for Exchange Traded Derivatives (ETDs) and represents the fair market value of a commodity or derivative. The price used for determining a position's daily profit or loss as well as the related margin requirements for the position.
   * Typically, the settlement price is set by determining the weighted average price over a certain period of trading, typically shortly before the close of the market for Options, Futures, Indices. If no value is available for the current day, the value of the previous day is delivered.
   */
  settlementPrice?: Maybe<Value>;
  /** The Spread Best Bid Ask is the absolute difference between the best bid and the best ask. It is the cost of executing an immediate trade, as a buyer would have to pay the ask price and a seller would receive the bid price. The narrower the bid-ask spread, the more liquid and competitive the market tends to be. A wider spread can indicate less liquidity and potentially higher trading costs. */
  spreadBestBidAsk?: Maybe<Value>;
  /** The Theta is a measure of the time decay of an option's value. It represents the rate at which an option's price decreases as time passes, assuming all other factors remain constant. Theta is particularly relevant for options traders and investors as it highlights the diminishing value of an option as it approaches its expiration date. A higher theta implies faster time decay, while a lower theta suggests slower erosion of an option's value over time. If no value is available for the current day, the value of the previous day is delivered. */
  theta?: Maybe<Value>;
  /** The Time To Maturity refers to the remaining length from present day until a financial instrument, such as a bond (in years) or a derivative (in days), reaches its maturity date. If no value is available for the current day, the value of the previous day is delivered. */
  timeToMaturity?: Maybe<Value>;
  /** The Total Expense Ratio is a measure used in the financial industry to assess the total cost associated with managing and operating an investment fund, such as a mutual fund or exchange-traded fund (ETF). It represents the percentage of a fund's total assets that is used to cover the expenses incurred in managing the fund, including management fees, administrative costs, custody fees, legal and audit fees, and other operational expenses. If no value is available for the current day, the value of the previous day is delivered. */
  totalExpenseRatio?: Maybe<Value>;
  /** The Turnover is calculated by multiplying a daily Volume on the market in units/nominal/contracts and the current price for each traded unit. Its use is similar to that of Volume. In addition, it is also used for inter-market and inter-currency comparison purposes. In some markets it is used to measure the inflowing and outflowing of currency units. If no value is available for the current day, the value of the previous day is delivered.     */
  turnover?: Maybe<Value>;
  /** The Turnover Total is the cumulative turnover on and off market. It is the daily volume in units/nominal/contracts multiplied by the current price of each traded unit. Its use is similar to that of Volume. In addition, it is also used for inter-market and inter-currency comparison purposes. In some markets it is used to measure the inflowing and outflowing of currency units. If no value is available for the current day, the value of the previous day is delivered. */
  turnoverTotal?: Maybe<Value>;
  /** The Vega is a measure of an option's sensitivity to changes in implied volatility. It represents the expected change in the option price for a 1% change in the implied volatility of the underlying asset. Vega is used by traders and investors to assess and manage the impact of volatility fluctuations on option prices, as higher volatility typically leads to increased option premiums and vice versa. If no value is available for the current day, the value of the previous day is delivered. */
  vega?: Maybe<Value>;
  /** The Volume is a number of units/nominal/contracts traded on market during a session. It is mainly used for analytical purposes and can be used for time series and historical data or data studies to compare it with the associated price action. If no value is available for the current day, the value of the previous day is delivered.     */
  volume?: Maybe<Value>;
  /** The Volume Total is the cumulative number of units/nominal/contracts traded on and off a market during a session. It is mainly used for analytical purposes and can be used for time series and historical data or data studies to compare it with the associated price action. If no value is available for the current day, the value of the previous day is delivered.     */
  volumeTotal?: Maybe<Value>;
  /** The Volume Weighted Average Price (VWAP) is a trading indicator, which averages the ratio between the traded prices and the cumulative traded volume throughout the day. If no value is available for the current day, the value of the previous day is delivered. */
  vwap?: Maybe<Value>;
  /** The Yield to Call is a financial metric that represents the total return an investor would receive if a callable bond is called or redeemed by the issuer before its scheduled maturity date. It is calculated by considering the bond's current market price, the call price, the remaining time to the call date, and the bond's coupon rate. Exclusively for bonds whose early redemption is expressly possible. Calculation only carried out if the invoice rate is greater than the redemption rate. If no value is available for the current day, the value of the previous day is delivered. */
  yieldToCall?: Maybe<Value>;
  /** A Yield to Maturity is the internal rate of return (IRR, overall interest rate) earned by the investor who buys the bond today at the market price, assuming that the bond will be held until maturity, and that all coupon and principal payments will be made on schedule. If the market is not yet closed or/and the embargo time has not yet elapsed, the previous generation value is provided. */
  yieldToMaturity?: Maybe<Value>;
};

export type IntradayTimeseries = {
  __typename?: 'IntradayTimeseries';
  /**
   * With IntradayTimeseriesSummary you may request aggregated price and trading activity for a specific period, with fields: open, high, low, last, volume and number of trades. The time series is delivered backwards from the "dateTo". The following considerations apply:
   *
   * | Period            | Max. Duration Per Request | Historical Depth    | Max. Records Per Request | Default records per request |
   * |:-----------------:|:-------------------------:|:-----------------:|:------------------------:|:---------------------------:|
   * |1 sec <= x < 5 min | 2 days                    | 45 days           | 20000                    | 1600*                       |
   * |5 min <= x <= 60min| 30 days                   | 180 days          | 20000                    | 1600*                       |
   *
   * *default records per request are only applied if no "dateFrom" has been defined.
   * @deprecated Use intradayHistory
   */
  summary?: Maybe<Array<Maybe<IntradayTimeseriesSummary>>>;
  /**
   * With the IntradayTimeseriesTrades you may request all the trades and best quotes at the moment of the trade. The available price fields are: Trade, BestBid and BestAsk. The time series is delivered backwards from the "dateTo". The following considerations apply:
   *
   * | Max. Duration Per Request | Historical Depth | Max. Records Per Request | Default records per request |
   * |:-------------------------:|:----------------:|:------------------------:|:---------------------------:|
   * | 2 days                    | 45 days          | 50000                    | 5000*                       |
   *
   * *default records per request are only applied if no "dateFrom" has been defined.
   * @deprecated Use intradayHistory
   */
  trades?: Maybe<Array<Maybe<IntradayTimeseriesTrades>>>;
};


export type IntradayTimeseriesSummaryArgs = {
  filters: IntradayTimeseriesSummaryFilter;
};


export type IntradayTimeseriesTradesArgs = {
  filters: IntradayTimeseriesTradesFilter;
};

/** Intraday Timeseries Price Adjustment */
export enum IntradayTimeseriesPriceAdjustment {
  /** Prices are after the occurrence of corporate action events historically adjusted for the requested period. */
  Adjusted = 'ADJUSTED',
  /** Prices are not adjusted. */
  Unadjusted = 'UNADJUSTED'
}

export type IntradayTimeseriesSummary = {
  __typename?: 'IntradayTimeseriesSummary';
  /** A High shows the intraday price swings, i.e. the highest price reached during the day. The high price enables the investor to directly estimate the daily price swings and the state of the market. The Daily High is a key input for charting. */
  high?: Maybe<Scalars['Float']['output']>;
  /** Date and time in ISO-8601 when the interval starts. */
  intervalFrom?: Maybe<Scalars['ZonedDateTime']['output']>;
  /** Date and time in ISO-8601 when the interval ends. */
  intervalTo?: Maybe<Scalars['ZonedDateTime']['output']>;
  /**
   * A Last is the most recent price which, after a successful matching of buy and sell orders, is eligible to update the last trade. The Last Trade is required so that market participants can see the trade prices and estimate the impact of their order and the probability of getting the order fully executed.
   *
   * Furthermore, trades are required for valuation purposes, understanding if an order was executed, understanding the change in the value of a security over time, understanding liquidity and the speed of trading.
   */
  last?: Maybe<Scalars['Float']['output']>;
  /** A Low shows the intraday price swings, i.e. the lowest price reached during the day. The low price enables the investor to directly estimate the daily price swings and the state of the market. The Daily Low is a key input for charting. */
  low?: Maybe<Scalars['Float']['output']>;
  /** The number of trades per interval. */
  numberOfTrades?: Maybe<Scalars['Int']['output']>;
  /** An Open is associated with the first transaction of the day. It follows immediately after the opening auction (if any) is completed. It is an opening price or first recorded price of the trading day - any value that the provider officially designates as the open. It is not necessarily a transacted price. */
  open?: Maybe<Scalars['Float']['output']>;
  /** Volume is the volume on market which is a number of units/nominal/contracts traded on market during a session. It is mainly used for analytical purposes and can be used for time series and historical data or data studies to compare it with the associated price action. */
  volume?: Maybe<Scalars['Float']['output']>;
};

export type IntradayTimeseriesSummaryFilter = {
  /** Start date of the timeseries as local date of the market. If it is missing or earlier than the maximum duration per request from today, the delivery will start with "dateTo" backwards to deliver maximum records. */
  dateFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  /** End date (inclusive) of the timeseries as local date of the market. If missing, the date and time of the request will be used. */
  dateTo?: InputMaybe<Scalars['LocalDate']['input']>;
  /**
   * Time interval with which intraday historical prices are being delivered. It must be provided as Durations ISO-8601: P[n]Y[n]M[n]DT[n]H[n]M[n]S
   *
   * Currently the smallest possible period interval to request data is seconds (1 second) and the largest is minutes (60 minutes).
   *
   * Possible period intervals:
   *
   * Seconds: "PT1S" (1 sec)
   * Minutes: "PT1M" (1 min); "PT5M" (5min); "PT10M" (10min); "PT15M" (15 min); "PT30M" (30 min); "PT60M" (60 min)
   */
  period?: InputMaybe<Scalars['Duration']['input']>;
  /**
   * UNADJUSTED = Prices are not adjusted.
   * ADJUSTED (default value) = The prices are after the occurrence of corporate action events historically adjusted.
   */
  priceAdjustment?: InputMaybe<IntradayTimeseriesPriceAdjustment>;
  /** Start time of the timeseries in local time of the market. If it is missing, the time will be set to the default value "00:00:00". */
  timeFrom?: InputMaybe<Scalars['LocalTime']['input']>;
  /** End time (inclusive) of the timeseries in local time of the market. If missing, the time will be set to the default value "23:59:59". */
  timeTo?: InputMaybe<Scalars['LocalTime']['input']>;
};

export type IntradayTimeseriesTrades = {
  __typename?: 'IntradayTimeseriesTrades';
  /**
   * An Ask (also known as an Offer) is a price at which securities, foreign exchange, or foreign bank notes are offered for sale.
   * The Best Ask is the lowest price offered by a stock's market makers to sell a particular trading instrument. It is the lowest price that an investor is willing to sell an asset for.
   */
  bestAsk?: Maybe<IntradayValueAndSize>;
  /**
   * A Bid is an offer made by a trader, investor or other industry professional to purchase a security.
   * The Best Bid is the highest price offered by a stock's market makers to buy a particular trading instrument. It is the highest price that an investor is willing to pay for an asset.
   */
  bestBid?: Maybe<IntradayValueAndSize>;
  /** Date and time in ISO-8601 of the session. */
  timestamp?: Maybe<Scalars['ZonedDateTime']['output']>;
  /** Trade is a basic economic concept involving the buying and selling of goods and services, with compensation paid by a buyer to a seller, or the exchange of goods or services between parties. In financial markets, trading refers to the buying and selling of securities, such as the purchase of stock on the exchange's floor. */
  trade?: Maybe<IntradayValueAndSize>;
};

export type IntradayTimeseriesTradesFilter = {
  /** Start date of the timeseries as local date of the market. If it is missing or earlier than the maximum duration per request from today, the delivery will start with "dateTo" backwards to deliver maximum records. */
  dateFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  /** End date (inclusive) of the timeseries as local date of the market. If missing, the date and time of the request will be used. */
  dateTo?: InputMaybe<Scalars['LocalDate']['input']>;
  /**
   * UNADJUSTED = Prices are not adjusted.
   * ADJUSTED (default value) = The prices are after the occurrence of corporate action events historically adjusted.
   */
  priceAdjustment?: InputMaybe<IntradayTimeseriesPriceAdjustment>;
  /** Start time of the timeseries in local time of the market. If it is missing, the time will be set to the default value "00:00:00". */
  timeFrom?: InputMaybe<Scalars['LocalTime']['input']>;
  /** End time (inclusive) of the timeseries in local time of the market. If missing, the time will be set to the default value "23:59:59". */
  timeTo?: InputMaybe<Scalars['LocalTime']['input']>;
};

export type IntradayValueAndSize = {
  __typename?: 'IntradayValueAndSize';
  /**
   * A Size associated with a price value represent an amount of units/contracts/nominal offered for sale, demanded for purchase, traded, orders that will be executed at a given price (e.g. in the event of an auction theoretical matching price quantity).
   *
   * The size associated with a quote can directly signal the market participant the ability of the market to absorb their order. Furthermore, it provides an indication of a market imbalance. The Ask Size is required by traders trading data products and those entities interest in intra-day market data values.
   *
   * The size associated with a trade allows a market participant to see the trade volumes and estimate or understand the impact of their own order on the market and the probability of getting it fully executed. In addition, the trade size allows calculation of the Volume Weighted Average Price (VWAP).
   */
  size?: Maybe<Scalars['Float']['output']>;
  /** The Value of the price. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Generic term of the fund type (e.g. equity fund, real estate fund, etc.) roughly indicating the fund's asset allocation. */
export enum InvestmentFundType {
  /** Diversified fund investing worldwide and without any restrictions as to the region or industry in all kinds of security types (i.e. not only in equities and debt instruments). Example: 'Globinvest'. */
  AllroundfundsMixedFunds = 'ALLROUNDFUNDS_MIXED_FUNDS',
  AlternativeFund = 'ALTERNATIVE_FUND',
  /** For Bond fund, refer to code 2. Country funds invest in a specific country. Example: funds investing in US Government bonds. For Regional funds refer to code 11. */
  BondAndCountryRegionalFunds = 'BOND_AND_COUNTRY_REGIONAL_FUNDS',
  /** Equities fund refer to code 1. Bond fund refer to code 2. Country fund refer to investments in a particular geographical region, e.g. Swiss Stock Fund. Regional fund refer to code 11. */
  BondAndEquityCountryAndRegionalFund = 'BOND_AND_EQUITY_COUNTRY_AND_REGIONAL_FUND',
  /** For Bond fund, refer to code 2; for Industry fund refer to code 8. */
  BondAndIndustryFunds = 'BOND_AND_INDUSTRY_FUNDS',
  /** Bond fund refer to code 2. Country fund refer to investments in a particular geographical region, e.g. Swiss Stock Fund. Regional fund refer to code 11. */
  BondSectorCountryAndRegionalFund = 'BOND_SECTOR_COUNTRY_AND_REGIONAL_FUND',
  /** Commodity-Funds - These funds invest in one or more commodity. Funds may focus on a single commodity or take a basket approach. They may gain this exposure through investing in derivative financial instruments linked to the relevant commodity or commodities price, or via direct investment in the commodity or commodities, which is then stored on behalf of the fund. */
  CommodityFund = 'COMMODITY_FUND',
  /** Fund investing in convertible bonds. */
  ConvertibleBondFund = 'CONVERTIBLE_BOND_FUND',
  /** Specialized fund investing in a particular country or region. */
  CountryRegionalFund = 'COUNTRY_REGIONAL_FUND',
  DerivativeFund = 'DERIVATIVE_FUND',
  /** Digital assets that utilize blockchain technology can be described as an immutable, permissionless and often decentralized digital database. Digital asset portfolios will invest the majority of their assets into one or more broadly classified areas including; Decentralized Finance (DeFi) assets, stable coins, currency assets, smart contracts platforms, exchange assets, privacy assets, yield farming, and nonfungible tokens (NFTs) among others. Digital assets are often characterized by two risk style factors momentum and volatility. Portfolios may gain access to digital assets through physical or derivative exposures and incorporate both long only investments and other hedging techniques. To qualify for inclusion, funds in this category must have a material portion of risk coming from digital assets. */
  DigitalAssets = 'DIGITAL_ASSETS',
  /** For Equities or Stock fund refer to code 1. Country funds invest in a specific country (example: Swiss Stock Fund). For Regional funds refer to code 11. */
  EquitiesAndCountryRegionalFund = 'EQUITIES_AND_COUNTRY_REGIONAL_FUND',
  /** For Equities or Stock fund refer to code 1; for Industry fund refer to code 8. */
  EquitiesAndIndustryFund = 'EQUITIES_AND_INDUSTRY_FUND',
  /** Funds that invest in equities (stocks) and have no restrictions nor specific policies regarding countries/regions or sectors/industries. */
  EquitiesFundEquityUnitTrust = 'EQUITIES_FUND_EQUITY_UNIT_TRUST',
  /** Funds that invest in equities and debt instruments. Equities fund refer code 1. Bond fund refer to code 2. */
  EquityBondFund = 'EQUITY_BOND_FUND',
  /** Equities fund refer to code 1. Country fund refer to investments in a particular geographical region, e.g. Swiss Stock Fund. Regional fund refer to code 11. */
  EquitySectorCountryAndRegionalFund = 'EQUITY_SECTOR_COUNTRY_AND_REGIONAL_FUND',
  /** The main objective of Exchange Traded Funds is to replicate the value of a specific index such as the SMI or DAX. ETFs are traded at any time without issue charges, i.e. for the bid/ask price only a spread is calculated. */
  Etf = 'ETF',
  /** Fund investing in fixed-interest securities such as bonds and to a small extent also in equities (e.g. shares resulting from the conversion of a convertible bond). These funds have no restrictions nor specific policies regarding countries/regions or sectors/industries. */
  FixedInterestSecFundBondFund = 'FIXED_INTEREST_SEC_FUND_BOND_FUND',
  /** Fund investing exclusively in units or shares of other funds (example: IOS). Not to be confused with an umbrella fund. */
  FundOfFunds = 'FUND_OF_FUNDS',
  FundOfHedgeFunds = 'FUND_OF_HEDGE_FUNDS',
  /** A private equity fund is a collective investment scheme used for making investments in various equity (and to a lesser extent debt) securities according to one of the investment strategies associated with Private equity (i.e. an asset class consisting of equity securities in operating companies that are not publicly traded on a stock exchange.) Funds of private equity funds invest in different underlying private equity funds. */
  FundOfPrivateEquityFunds = 'FUND_OF_PRIVATE_EQUITY_FUNDS',
  /** A fund that invests in options and futures. */
  FuturesOptionsFunds = 'FUTURES_OPTIONS_FUNDS',
  /** Fund whose purpose is to hedge the stockholder against a downward movement in stock prices (downside protection). */
  GuaranteeFundInsuranceFund = 'GUARANTEE_FUND_INSURANCE_FUND',
  /** Exotic types of mutual funds using hedging techniques, i.e. highly speculative strategies to offset investment risk in order to eliminate the possibility of future loss and to quickly enhance returns, such as both buying and shorting stocks based on a valuation model. Hedge funds apart from stock and bonds also invest in contracts based on currencies, commodities, and interest rates as well as in the corresponding option contracts. */
  HedgeFund = 'HEDGE_FUND',
  /** Fund whose assets allocation is based on a particular index i.e. the financial instruments included in the portfolio are the same as those in the index and accordingly the fund performance is expected to be similar to that of the reference index. */
  IndexFund = 'INDEX_FUND',
  /** Specialized fund investing in a particular industry or sector with promising results. */
  IndustryFund = 'INDUSTRY_FUND',
  /** Fund related to insurance policies managed by insurance companies for their insurance holders. */
  InsuranceFunds = 'INSURANCE_FUNDS',
  /** Confirmation of membership rights in a Swiss investment fund (please refer to Table 238, code 17 Investment foundation). */
  InvestmentFoundationClaim = 'INVESTMENT_FOUNDATION_CLAIM',
  /** Balanced funds invest in a combination of bonds with common and preferred stock in an effort to obtain the highest return consistent with a low-risk strategy. Strategy funds are managed according to the newest findings of the portfolio and capital market theories. According to their yield and risk preferences, investors have the choice of funds with an investment strategy focussing, for example, on income (Income funds: 80% bonds and 20% liquid assets), income/growth (Yield funds: 20% shares, 60 % bonds, 20% liquid assets), growth/ yield (Balanced funds: 40% shares, 40% bonds, 20% liquid assets), or growth (Growth funds: 60% shares, 20% bonds, 20% liquid assets). */
  InvestObjectiveFundBalancedFund = 'INVEST_OBJECTIVE_FUND_BALANCED_FUND',
  /** Money market funds invest only in short-term securities (i.e. in money market instruments such as bankers' acceptances, commercial paper etc.). Currency funds invest in foreign currencies i.e. profits are derived from foreign exchange rate fluctuations. */
  MoneyMarketCurrencyFund = 'MONEY_MARKET_CURRENCY_FUND',
  /** A fund that invests in mortgages. Portfolios of mortgage funds usually consist of mortgages on real estate property. */
  MortgageFund = 'MORTGAGE_FUND',
  Other = 'OTHER',
  /** An old-age-pension funds is established in order to finance retirement benefits. */
  PensionFund = 'PENSION_FUND',
  /** Private Equity Funds are financial investment companies specialised in buy-ins/outs and holding an equity stake in underrated (unquoted) companies. A Private Equity Fund typically holds an equity stake only over a limited period of time (two to five years) and thereafter tries to sell it with profit or place it on a stock exchange. */
  PrivateEquityFund = 'PRIVATE_EQUITY_FUND',
  /** Fund investing in a diverse array of real estate properties i.e. managing a portfolio of real estate (direct ownership or investments) to earn profits for shareholders and with the principal objective of risk optimisation. */
  RealEstateInvestmentFund = 'REAL_ESTATE_INVESTMENT_FUND',
  /** Industry fund refer to code 8. Country fund refer to investments in a particular geographical region, e.g. Swiss Stock Fund. Regional fund refer to code 11. */
  SectorCountryAndRegionalFund = 'SECTOR_COUNTRY_AND_REGIONAL_FUND'
}

/** Irregular first or last coupon */
export enum IrregularCouponPeriod {
  LongCoupon = 'LONG_COUPON',
  Other = 'OTHER',
  ShortCoupon = 'SHORT_COUPON'
}

/** A short description of the Entity, useful to create links. */
export type IssuerReference = {
  __typename?: 'IssuerReference';
  /**
   * The issuer's country of residence as country ISO Code (ISO 3166 ALPHA-2).
   * @deprecated to be moved in another API
   */
  domicile: Scalars['Country']['output'];
  /** The SIX Financial Information identifier (GK) of the legal entity. */
  gk: Scalars['Gk']['output'];
  /** The Legal Entity Identifier (LEI) is a 20-digit alphanumeric code to identify a legal entity. The structure is defined in ISO 17442. */
  lei?: Maybe<Scalars['String']['output']>;
  /** Legal entity long name. */
  longName?: Maybe<Scalars['String']['output']>;
  /**
   * The issuer short name with up to 19 characters.
   * @deprecated use 'shortName'
   */
  name: Scalars['String']['output'];
  /**
   * Sector of the issuer allocated by SIX Financial Information.
   * @deprecated to be moved in another API
   */
  sector?: Maybe<Sector>;
  /** Legal entity short name. */
  shortName?: Maybe<Scalars['String']['output']>;
  /** @deprecated to be moved in another API */
  status?: Maybe<EntityStatus>;
};

/** Supported languages in ISO 639. */
export enum Language {
  /** German */
  De = 'DE',
  /** English */
  En = 'EN',
  /** French */
  Fr = 'FR',
  /** Italian */
  It = 'IT'
}

/** This indicates whether this instrument is a registered security or a bearer security.  */
export enum LegalForm {
  BearerAndOrRegisteredForm = 'BEARER_AND_OR_REGISTERED_FORM',
  BearerForm = 'BEARER_FORM',
  Other = 'OTHER',
  RegisteredForm = 'REGISTERED_FORM'
}

/** A ticker for a listing, as a combination of trading symbol and BC */
export type LiquidListingReference = {
  __typename?: 'LiquidListingReference';
  ticker?: Maybe<Scalars['String']['output']>;
};

export type Listing = {
  __typename?: 'Listing';
  lookup?: Maybe<ListingLookup>;
  /** Status of the response */
  lookupStatus: LookupStatus;
  marketData?: Maybe<ListingMarketData>;
  pgdLookup?: Maybe<PgdLookup>;
  referenceData?: Maybe<ListingReferenceData>;
  /** The requested entity id used in the request */
  requestedId: Scalars['UserInputId']['output'];
  /** The requested scheme used in the request */
  requestedScheme: ListingScheme;
};

/**
 * The Listing Base service is designed to provide clients with necessary reference data for the requested listings.
 * The interface grants swift and user-friendly access to a predefined set of key attributes applicable to a broad range of asset classes.
 * Its intuitive nature guarantees that clients possess crucial information for enhancing operational efficiency in maintaining their master reference data.
 */
export type ListingBase = {
  __typename?: 'ListingBase';
  /** Specifies the computation method of (accrued) interest of the security according to ISO 20022 as raw code. */
  dayCountBasis?: Maybe<MethodOfInterestComputationIndicator>;
  /** Specifies the computation method of (accrued) interest of the security according to ISO 20022 as resolved string label. */
  dayCountBasisLabel?: Maybe<Scalars['String']['output']>;
  /** The financial instrument which is listed. */
  instrument?: Maybe<InstrumentReference>;
  /** Listing Classification in textual form. */
  listingCategory?: Maybe<ListingCategory>;
  /** The trading currency, as specified by SIX, typically follows the ISO 4217 alpha-3 code. For cryptocurrencies, the Cryptocurrency Symbol in Instrument Symbology can be used for reference. */
  listingCurrency?: Maybe<Scalars['Currency']['output']>;
  /** Listing short name with up to 19 characters. */
  listingShortName?: Maybe<Scalars['String']['output']>;
  /** Indicating the current state of the listing, e.g. listing applied for, listing effective, delisted, etc. */
  listingStatus?: Maybe<ListingStatus>;
  /** The market on which the financial instrument is listed. */
  market?: Maybe<MarketReference>;
  /** Indicates the quote type of the price (e.g. whether the amount is a precentage price or not). */
  priceQuoteType?: Maybe<PriceQuoteType>;
  /** Reference to the original price representation. Delivered when the provider delivers the price in other forms than entire unit or in decimals (e.g. price in GBX or fraction). */
  priceRepresentationType?: Maybe<PriceRepresentationType>;
  /** Number of instruments to which the reported trading price refers. */
  priceUnitSize?: Maybe<Scalars['Float']['output']>;
  /** Indicates the unit of measurement in which the Price Unit Size is expressed. */
  priceUnitType?: Maybe<Unit>;
  /** Market Identifier Code (MIC) of the execution venue. It is based on ISO 10383 alphanumeric-4 code and represents a universal method of identifying exchanges, trading platforms, regulated or non-regulated markets and trade reporting facilities as sources of prices and related information. */
  segmentMic?: Maybe<Scalars['String']['output']>;
  /** Symbol used to identify an instrument on a given market for trading purposes. */
  ticker?: Maybe<Scalars['String']['output']>;
  /** Nominal trading applies to financial instruments without a par value, or where the par value or nominal value according to the issue conditions no longer is in use for trading. */
  tradingNominalSize?: Maybe<Scalars['Float']['output']>;
  /** Indicates the current state of the trading, e.g. trading temporarily suspended, not traded, calculated, etc. in coded form. */
  tradingStatus?: Maybe<TradingStatus>;
  /** Indicates the unit of measurement in which the Trading Nominal Size is expressed. */
  tradingUnitType?: Maybe<Unit>;
  /** Indicates the volume unit amount. */
  volumeUnitSize?: Maybe<Scalars['Float']['output']>;
  /** Indicates the unit of measurement in which the Volume Unit Size is expressed. */
  volumeUnitType?: Maybe<Unit>;
};

/** Listing Classification Name */
export enum ListingCategory {
  AbsoluteReturnCertificates = 'ABSOLUTE_RETURN_CERTIFICATES',
  Agencies = 'AGENCIES',
  Aim = 'AIM',
  Aim1 = 'AIM1',
  Aim3 = 'AIM3',
  AimMarketSeatsPlus_1000Nms = 'AIM_MARKET_SEATS_PLUS_1000_NMS',
  AimMarketSeatsPlus_2000Nms = 'AIM_MARKET_SEATS_PLUS_2000_NMS',
  AimNonQuoted = 'AIM_NON_QUOTED',
  AimOnSetsmm = 'AIM_ON_SETSMM',
  AimOnSetsqx_1NonCcp = 'AIM_ON_SETSQX_1_NON_CCP',
  AimOnSetsqx_2NonCcp = 'AIM_ON_SETSQX_2_NON_CCP',
  AimOnSetsqxNonQtdNccp = 'AIM_ON_SETSQX_NON_QTD_NCCP',
  AimOnSetsqxNqCcp = 'AIM_ON_SETSQX_NQ_CCP',
  AimOnSetsq_1Ccp = 'AIM_ON_SETSQ_1_CCP',
  AimOnSetsq_2Ccp = 'AIM_ON_SETSQ_2_CCP',
  AirbagCertificate = 'AIRBAG_CERTIFICATE',
  AlternativFunds = 'ALTERNATIV_FUNDS',
  /** A developing market for small and medium-sized enterprises with a view to stepping up to the main market in the near future. */
  Ambitious = 'AMBITIOUS',
  AnlagefondsInvestmentFunds = 'ANLAGEFONDS_INVESTMENT_FUNDS',
  Arms = 'ARMS',
  AssetBackedSecurities = 'ASSET_BACKED_SECURITIES',
  AssetBackedSecuritiesSubordinates = 'ASSET_BACKED_SECURITIES_SUBORDINATES',
  Banks = 'BANKS',
  BarrierDiscountCertificate = 'BARRIER_DISCOUNT_CERTIFICATE',
  BarrierRangeReverseConvertibles = 'BARRIER_RANGE_REVERSE_CONVERTIBLES',
  BarrierReverseConvertibles = 'BARRIER_REVERSE_CONVERTIBLES',
  BearerShare = 'BEARER_SHARE',
  BitGemEquity = 'BIT_GEM_EQUITY',
  BlueChipsBc46 = 'BLUE_CHIPS_BC46',
  Bonds = 'BONDS',
  BondsPreTrading = 'BONDS_PRE_TRADING',
  BondAClass = 'BOND_A_CLASS',
  BondExWarrant = 'BOND_EX_WARRANT',
  BondFunds = 'BOND_FUNDS',
  BondLinkedNote = 'BOND_LINKED_NOTE',
  BondWithWarrant = 'BOND_WITH_WARRANT',
  BonusAdvance = 'BONUS_ADVANCE',
  BonusCapped = 'BONUS_CAPPED',
  BonusCertificate = 'BONUS_CERTIFICATE',
  BonusCertificatePro = 'BONUS_CERTIFICATE_PRO',
  BonusSpreadNotes = 'BONUS_SPREAD_NOTES',
  Boomer = 'BOOMER',
  Booster = 'BOOSTER',
  BottomUp = 'BOTTOM_UP',
  BuoniDiTesoroPoliennaliBtp = 'BUONI_DI_TESORO_POLIENNALI_BTP',
  BuoniOrdinariComunaliBoc = 'BUONI_ORDINARI_COMUNALI_BOC',
  BuoniOrdinariDelTesoroBot = 'BUONI_ORDINARI_DEL_TESORO_BOT',
  Butterfly = 'BUTTERFLY',
  CantonalBanksFunds = 'CANTONAL_BANKS_FUNDS',
  CapitalProtectionCertificate = 'CAPITAL_PROTECTION_CERTIFICATE',
  CapitalProtectionProductsWithoutCap = 'CAPITAL_PROTECTION_PRODUCTS_WITHOUT_CAP',
  CapitalProtectionProductsWithCap = 'CAPITAL_PROTECTION_PRODUCTS_WITH_CAP',
  CapitalProtectionProductsWithCoupon = 'CAPITAL_PROTECTION_PRODUCTS_WITH_COUPON',
  CapitalProtectionWithDoubleKnockOut = 'CAPITAL_PROTECTION_WITH_DOUBLE_KNOCK_OUT',
  CapitalProtectionWithKnockOut = 'CAPITAL_PROTECTION_WITH_KNOCK_OUT',
  CappedBonusCertificates = 'CAPPED_BONUS_CERTIFICATES',
  CappedOutperformanceCertificate = 'CAPPED_OUTPERFORMANCE_CERTIFICATE',
  CappedWarrant = 'CAPPED_WARRANT',
  CashAndProtectSoftRunner = 'CASH_AND_PROTECT_SOFT_RUNNER',
  Casual = 'CASUAL',
  CertificatiDiCreditoDelTesoroCct = 'CERTIFICATI_DI_CREDITO_DEL_TESORO_CCT',
  CertificatiDiCreditoDelTesoroZeroCouponCtz = 'CERTIFICATI_DI_CREDITO_DEL_TESORO_ZERO_COUPON_CTZ',
  ChemicalsAndCosmeticsMedicalDrugsBiotech = 'CHEMICALS_AND_COSMETICS_MEDICAL_DRUGS_BIOTECH',
  ChemicalsSpecialityFoodCommServices = 'CHEMICALS_SPECIALITY_FOOD_COMM_SERVICES',
  CliquetNotes = 'CLIQUET_NOTES',
  CmosAndStrips = 'CMOS_AND_STRIPS',
  Coins = 'COINS',
  Collar = 'COLLAR',
  CollateralizedLoanObligations = 'COLLATERALIZED_LOAN_OBLIGATIONS',
  Combination = 'COMBINATION',
  Combo = 'COMBO',
  CommercialMbs = 'COMMERCIAL_MBS',
  Commodities = 'COMMODITIES',
  CommodityForwards = 'COMMODITY_FORWARDS',
  CommonShares = 'COMMON_SHARES',
  Condinotes = 'CONDINOTES',
  /** Contingent capital bonds or CoCos, is debt that converts into equity, or loses its value, if the financial institution issuing it breaches a predetermined level of capital. */
  ContingentCapitalBond = 'CONTINGENT_CAPITAL_BOND',
  ContractForDifferenceCfd = 'CONTRACT_FOR_DIFFERENCE_CFD',
  ContractSpecification = 'CONTRACT_SPECIFICATION',
  ConvertiblesIntoUkEquities = 'CONVERTIBLES_INTO_UK_EQUITIES',
  CorporateBondsAndMtns = 'CORPORATE_BONDS_AND_MTNS',
  CorpRetailDebtNr = 'CORP_RETAIL_DEBT_NR',
  CorpRetailDebtTr = 'CORP_RETAIL_DEBT_TR',
  CorpWholesaleDebtNr = 'CORP_WHOLESALE_DEBT_NR',
  CorpWholesaleDebtNu = 'CORP_WHOLESALE_DEBT_NU',
  CorpWholesaleDebtTr = 'CORP_WHOLESALE_DEBT_TR',
  CorpWholesaleDebtTu = 'CORP_WHOLESALE_DEBT_TU',
  CoveredWarrants = 'COVERED_WARRANTS',
  CreditDefaultSwapsCds = 'CREDIT_DEFAULT_SWAPS_CDS',
  CreditLinkedNote = 'CREDIT_LINKED_NOTE',
  CrossCurrencySwapsCcs = 'CROSS_CURRENCY_SWAPS_CCS',
  CurrencyOption = 'CURRENCY_OPTION',
  CushionCertificates = 'CUSHION_CERTIFICATES',
  DailyNotes = 'DAILY_NOTES',
  DailyRangeAccrualNotes = 'DAILY_RANGE_ACCRUAL_NOTES',
  DefenderVoncerts = 'DEFENDER_VONCERTS',
  DefenderVoncores = 'DEFENDER_VONCORES',
  DefenderVontis = 'DEFENDER_VONTIS',
  DefenderVontisWithParticipation = 'DEFENDER_VONTIS_WITH_PARTICIPATION',
  DigitalNotes = 'DIGITAL_NOTES',
  Digits = 'DIGITS',
  DiscountCertificate = 'DISCOUNT_CERTIFICATE',
  DiscountCertificates = 'DISCOUNT_CERTIFICATES',
  DiscountCertificatePlus = 'DISCOUNT_CERTIFICATE_PLUS',
  DiscountCertificatePlusPro = 'DISCOUNT_CERTIFICATE_PLUS_PRO',
  Diverse = 'DIVERSE',
  DomesticBonds = 'DOMESTIC_BONDS',
  DomesticEquities = 'DOMESTIC_EQUITIES',
  DomesticMotTitoliDebito = 'DOMESTIC_MOT_TITOLI_DEBITO',
  DomesticSettledBankingBonds = 'DOMESTIC_SETTLED_BANKING_BONDS',
  DomesticSettledCertificates = 'DOMESTIC_SETTLED_CERTIFICATES',
  DomesticSettledCorporateFinancialSupraEmergingOtherBonds = 'DOMESTIC_SETTLED_CORPORATE_FINANCIAL_SUPRA_EMERGING_OTHER_BONDS',
  DomesticSettledGoviesAndSovereign = 'DOMESTIC_SETTLED_GOVIES_AND_SOVEREIGN',
  DoubleIceUnits = 'DOUBLE_ICE_UNITS',
  DoubleReverseConvertible = 'DOUBLE_REVERSE_CONVERTIBLE',
  DualCurrencyBond = 'DUAL_CURRENCY_BOND',
  DualCurrencyConvertibleBond = 'DUAL_CURRENCY_CONVERTIBLE_BOND',
  DusPools = 'DUS_POOLS',
  DynamicLeverageVoncoresVectis = 'DYNAMIC_LEVERAGE_VONCORES_VECTIS',
  DynamicVoncerts = 'DYNAMIC_VONCERTS',
  DynamicVoncoresRollingDiscountCertificates = 'DYNAMIC_VONCORES_ROLLING_DISCOUNT_CERTIFICATES',
  Eidgenossen = 'EIDGENOSSEN',
  EmergingMarkets = 'EMERGING_MARKETS',
  EmploymentIndex = 'EMPLOYMENT_INDEX',
  EmploymentTelecomsRetailersConstructionBuilding = 'EMPLOYMENT_TELECOMS_RETAILERS_CONSTRUCTION_BUILDING',
  EngineeringElectronicsMedprodIndustrialsSemis = 'ENGINEERING_ELECTRONICS_MEDPROD_INDUSTRIALS_SEMIS',
  Equities = 'EQUITIES',
  EquitiesProvisionalAdmission = 'EQUITIES_PROVISIONAL_ADMISSION',
  EquityCertificates = 'EQUITY_CERTIFICATES',
  EquityForwards = 'EQUITY_FORWARDS',
  EquityFunds = 'EQUITY_FUNDS',
  EquityRangeAccrualNotes = 'EQUITY_RANGE_ACCRUAL_NOTES',
  EquityThemaFunds = 'EQUITY_THEMA_FUNDS',
  EquityValueFunds = 'EQUITY_VALUE_FUNDS',
  EtfsEuroclearBkSettlMulticur = 'ETFS_EUROCLEAR_BK_SETTL_MULTICUR',
  EtfsEuroclearBankSettlement = 'ETFS__EUROCLEAR_BANK_SETTLEMENT',
  EtlxEquities = 'ETLX_EQUITIES',
  EurmLiquidEquitNonUkDutch = 'EURM_LIQUID_EQUIT_NON_UK_DUTCH',
  Eurobonds = 'EUROBONDS',
  EuronextGrowthMilan = 'EURONEXT_GROWTH_MILAN',
  ExchangeableCertificates = 'EXCHANGEABLE_CERTIFICATES',
  ExchangeableUnits = 'EXCHANGEABLE_UNITS',
  ExchangeCertificate = 'EXCHANGE_CERTIFICATE',
  ExchangeNetAssetValues = 'EXCHANGE_NET_ASSET_VALUES',
  ExchangeRates = 'EXCHANGE_RATES',
  ExchangeRatesBanknotes = 'EXCHANGE_RATES_BANKNOTES',
  ExchangeTradedCommodities = 'EXCHANGE_TRADED_COMMODITIES',
  ExchangeTradedCommoditiesMtf = 'EXCHANGE_TRADED_COMMODITIES_MTF',
  ExchangeTradedCommoditiesMultiCurrency = 'EXCHANGE_TRADED_COMMODITIES_MULTI_CURRENCY',
  ExchangeTradedFunds = 'EXCHANGE_TRADED_FUNDS',
  ExchangeTradedFundsMtf = 'EXCHANGE_TRADED_FUNDS_MTF',
  ExchangeTradedFundsMulticurrency = 'EXCHANGE_TRADED_FUNDS_MULTICURRENCY',
  /** Exchange Traded Managed Funds (ETMFs) are an SEC-approved investment structure traded on an exchange that do not require daily portfolio management disclosure. They will function as a cross between open-end mutual funds and exchange-traded funds (ETFs). The exchange will use NAV-based trading model for ETMF. */
  ExchangeTradedManagedFunds = 'EXCHANGE_TRADED_MANAGED_FUNDS',
  ExchangeTradedProducts = 'EXCHANGE_TRADED_PRODUCTS',
  ExchangeTradedStructuredFunds = 'EXCHANGE_TRADED_STRUCTURED_FUNDS',
  ExchRegIntMktPricedEod = 'EXCH_REG_INT_MKT_PRICED_EOD',
  ExchRegIntMktQuotedCont = 'EXCH_REG_INT_MKT_QUOTED_CONT',
  ExoticStructuredInstruments = 'EXOTIC_STRUCTURED_INSTRUMENTS',
  ExpressCertificate = 'EXPRESS_CERTIFICATE',
  Extramot = 'EXTRAMOT',
  /** ExtraMOT PRO3 is a bond segment of Borsa Italiana dedicated to unlisted companies with ambitious growth plans. */
  ExtramotPro3 = 'EXTRAMOT_PRO3',
  E_1StSection = 'E_1ST_SECTION',
  E_2NdSection = 'E_2ND_SECTION',
  E_2RegulatedMarket = 'E_2_REGULATED_MARKET',
  E_100PercentCapitalGuaranteed = 'E_100PERCENT_CAPITAL_GUARANTEED',
  FaktorZertifikate = 'FAKTOR_ZERTIFIKATE',
  FixedIncomeStructured = 'FIXED_INCOME_STRUCTURED',
  Floaters = 'FLOATERS',
  FlooredFloaters = 'FLOORED_FLOATERS',
  ForeignBonds = 'FOREIGN_BONDS',
  ForeignEconomicIndicator = 'FOREIGN_ECONOMIC_INDICATOR',
  ForeignEquities = 'FOREIGN_EQUITIES',
  ForeignInterestPaymentSecurity = 'FOREIGN_INTEREST_PAYMENT_SECURITY',
  ForeignNotListedFundsOptions = 'FOREIGN_NOT_LISTED_FUNDS_OPTIONS',
  ForeignSettledBankingBonds = 'FOREIGN_SETTLED_BANKING_BONDS',
  ForeignSettledBondProfessional = 'FOREIGN_SETTLED_BOND_PROFESSIONAL',
  ForeignSettledCertificates = 'FOREIGN_SETTLED_CERTIFICATES',
  ForeignSettledCorporateFinancialSupraEmergingOtherBonds = 'FOREIGN_SETTLED_CORPORATE_FINANCIAL_SUPRA_EMERGING_OTHER_BONDS',
  ForeignSettledGoviesAndSovereign = 'FOREIGN_SETTLED_GOVIES_AND_SOVEREIGN',
  ForeignSettledProfessionalRequest = 'FOREIGN_SETTLED_PROFESSIONAL_REQUEST',
  ForeignUnderlying = 'FOREIGN_UNDERLYING',
  ForwardRateAgreementFra = 'FORWARD_RATE_AGREEMENT_FRA',
  FundsOfHedgeFund = 'FUNDS_OF_HEDGE_FUND',
  FurtherCapitalProtectionProducts = 'FURTHER_CAPITAL_PROTECTION_PRODUCTS',
  FurtherLeverageProducts = 'FURTHER_LEVERAGE_PRODUCTS',
  FurtherYieldOptimisationProducts = 'FURTHER_YIELD_OPTIMISATION_PRODUCTS',
  Futures = 'FUTURES',
  FuturesOptions = 'FUTURES_OPTIONS',
  FuturesSpreads = 'FUTURES_SPREADS',
  FuturesUnderlying = 'FUTURES_UNDERLYING',
  FxForwards = 'FX_FORWARDS',
  FxOutright = 'FX_OUTRIGHT',
  Gilts = 'GILTS',
  GlobalDepositaryReceipts = 'GLOBAL_DEPOSITARY_RECEIPTS',
  GlobalRatesSwissGovernmentBonds = 'GLOBAL_RATES_SWISS_GOVERNMENT_BONDS',
  GlobalRatesSwissGreyMarket = 'GLOBAL_RATES_SWISS_GREY_MARKET',
  GratificationCertificate = 'GRATIFICATION_CERTIFICATE',
  GreyMarket = 'GREY_MARKET',
  /** A market for companies that have a business plan to realize their high growth potential, the progress of which is timely and appropriately disclosed, and have obtained a certain level of market value, but at the same time, have a relatively higher risk from the viewpoint of business performance and a market for institutional and general investors investing in. */
  GrowthMarket = 'GROWTH_MARKET',
  GuaranteedAlternativeInvestmentNotes = 'GUARANTEED_ALTERNATIVE_INVESTMENT_NOTES',
  HartToValueInstruments = 'HART_TO_VALUE_INSTRUMENTS',
  HedgeFunds = 'HEDGE_FUNDS',
  HighYields = 'HIGH_YIELDS',
  IceUnits = 'ICE_UNITS',
  Index = 'INDEX',
  Indexanleihen = 'INDEXANLEIHEN',
  IndexAndParticipationCertificate = 'INDEX_AND_PARTICIPATION_CERTIFICATE',
  IndexTracker = 'INDEX_TRACKER',
  IndustrieFinanz = 'INDUSTRIE_FINANZ',
  InflationDerivatives = 'INFLATION_DERIVATIVES',
  InflationIndex = 'INFLATION_INDEX',
  InformalCurrencyRates = 'INFORMAL_CURRENCY_RATES',
  Insurances = 'INSURANCES',
  InterestOnlyInverses = 'INTEREST_ONLY_INVERSES',
  InterestRates = 'INTEREST_RATES',
  InterestRateOptions = 'INTEREST_RATE_OPTIONS',
  InterestRateOptionsCapsFloors = 'INTEREST_RATE_OPTIONS_CAPS_FLOORS',
  InterestRateOptionFwdCapsFloors = 'INTEREST_RATE_OPTION_FWD_CAPS_FLOORS',
  InterestRateSwaps = 'INTEREST_RATE_SWAPS',
  InterestRateVolatilities = 'INTEREST_RATE_VOLATILITIES',
  IntermediationProducts = 'INTERMEDIATION_PRODUCTS',
  InternationalBoardSgx = 'INTERNATIONAL_BOARD_SGX',
  InternationalCorporatesAndOtherBonds = 'INTERNATIONAL_CORPORATES_AND_OTHER_BONDS',
  InternatBulletinBoardIsdReg = 'INTERNAT_BULLETIN_BOARD_ISD_REG',
  InternatBulletinBoardNonIsdReg = 'INTERNAT_BULLETIN_BOARD_NON_ISD_REG',
  InternatRetailService = 'INTERNAT_RETAIL_SERVICE',
  InternatRetailServiceIsdReg = 'INTERNAT_RETAIL_SERVICE_ISD_REG',
  InternatRetailServiceNonIsdReg = 'INTERNAT_RETAIL_SERVICE_NON_ISD_REG',
  IntlOrderBook = 'INTL_ORDER_BOOK',
  IntlOrderBookNonIsdReg = 'INTL_ORDER_BOOK_NON_ISD_REG',
  InvestmentCertificates = 'INVESTMENT_CERTIFICATES',
  InvestmentProducts = 'INVESTMENT_PRODUCTS',
  IobeIntlOrderBookCleared = 'IOBE_INTL_ORDER_BOOK_CLEARED',
  JbArt = 'JB_ART',
  KnockInProduct = 'KNOCK_IN_PRODUCT',
  KnockOutProductWithoutStopLoss = 'KNOCK_OUT_PRODUCT_WITHOUT_STOP_LOSS',
  KnockOutProductWithStopLoss = 'KNOCK_OUT_PRODUCT_WITH_STOP_LOSS',
  Leman = 'LEMAN',
  LemanDefensif = 'LEMAN_DEFENSIF',
  LemanDefensifWorstOf = 'LEMAN_DEFENSIF_WORST_OF',
  LeverageCertificates = 'LEVERAGE_CERTIFICATES',
  LeverageDefenderVontis = 'LEVERAGE_DEFENDER_VONTIS',
  LeverageRangeDefenderVontis = 'LEVERAGE_RANGE_DEFENDER_VONTIS',
  LseNonQuoted = 'LSE_NON_QUOTED',
  LseSet0 = 'LSE_SET0',
  LseSet1 = 'LSE_SET1',
  LseSet2 = 'LSE_SET2',
  LseSet3 = 'LSE_SET3',
  MacroEconomicIndicator = 'MACRO_ECONOMIC_INDICATOR',
  /** Market for companies which have stable and growing businesses with consistent financial track records. */
  MainMarket = 'MAIN_MARKET',
  ManagedRiskVoncerts = 'MANAGED_RISK_VONCERTS',
  MbsPassthroughs = 'MBS_PASSTHROUGHS',
  MercatoTelematicoDelleEuroObbligazioniEuromot = 'MERCATO_TELEMATICO_DELLE_EURO_OBBLIGAZIONI_EUROMOT',
  MiniFutures = 'MINI_FUTURES',
  MiscellaneousPrimaryListedNonQuoted = 'MISCELLANEOUS_PRIMARY_LISTED_NON_QUOTED',
  MivInvestmentCompanies = 'MIV_INVESTMENT_COMPANIES',
  MivRealEstateInvestmentCompanies = 'MIV_REAL_ESTATE_INVESTMENT_COMPANIES',
  MivSivSpecialVehiclesInstruments = 'MIV_SIV_SPECIAL_VEHICLES_INSTRUMENTS',
  MoneymarketFunds = 'MONEYMARKET_FUNDS',
  MoneyMarket = 'MONEY_MARKET',
  MoneyMarketNotes = 'MONEY_MARKET_NOTES',
  MoneyMarketPapers = 'MONEY_MARKET_PAPERS',
  MtaInstrumentsBc46 = 'MTA_INSTRUMENTS_BC46',
  MtfClasse_3 = 'MTF_CLASSE_3',
  MtfClasse_4 = 'MTF_CLASSE_4',
  MultiDefenderVoncerts = 'MULTI_DEFENDER_VONCERTS',
  MultiDefenderVoncores = 'MULTI_DEFENDER_VONCORES',
  MultiDefenderVontis = 'MULTI_DEFENDER_VONTIS',
  MultiDefenderVontisMitPartizipation = 'MULTI_DEFENDER_VONTIS_MIT_PARTIZIPATION',
  MultiDefenderVontisPlus = 'MULTI_DEFENDER_VONTIS_PLUS',
  MultiDefenderVontisWithLookback = 'MULTI_DEFENDER_VONTIS_WITH_LOOKBACK',
  MultiRangeUnits = 'MULTI_RANGE_UNITS',
  MunicipalBonds = 'MUNICIPAL_BONDS',
  Na = 'NA',
  NachhaltigkeitsFunds = 'NACHHALTIGKEITS_FUNDS',
  NasdaqCapitalMarket = 'NASDAQ_CAPITAL_MARKET',
  NasdaqGlobalMarket = 'NASDAQ_GLOBAL_MARKET',
  NasdaqGlobalSelectMarket = 'NASDAQ_GLOBAL_SELECT_MARKET',
  NationalProductIndicator = 'NATIONAL_PRODUCT_INDICATOR',
  NetherlandSets = 'NETHERLAND_SETS',
  NewIssues = 'NEW_ISSUES',
  NewMarketStocks = 'NEW_MARKET_STOCKS',
  /** A market for companies aiming for growth while gaining a certain market evaluation, with timely and appropriate disclosure of business plans and progress with an eye on future step-ups. */
  NextMarket = 'NEXT_MARKET',
  NichtKotierteBanken = 'NICHT_KOTIERTE_BANKEN',
  NonUcitsEtfs = 'NON_UCITS_ETFS',
  NonUcitsEtfsMultiCurrency = 'NON_UCITS_ETFS_MULTI_CURRENCY',
  NoTier = 'NO_TIER',
  OfficialExchangeRates = 'OFFICIAL_EXCHANGE_RATES',
  OpenMarket = 'OPEN_MARKET',
  OperUnits = 'OPER_UNITS',
  Options = 'OPTIONS',
  OrderBookCorporateBonds = 'ORDER_BOOK_CORPORATE_BONDS',
  OrderBookGilts = 'ORDER_BOOK_GILTS',
  OtcbbOnly = 'OTCBB_ONLY',
  OtcbbPinkSheetsDuallyQuoted = 'OTCBB_PINK_SHEETS_DUALLY_QUOTED',
  OtcqxInternationalPremierqx = 'OTCQX_INTERNATIONAL_PREMIERQX',
  OtcqxInternationalPrimeqx = 'OTCQX_INTERNATIONAL_PRIMEQX',
  OtcqxPremierqx = 'OTCQX_PREMIERQX',
  OtcqxPrimeqx = 'OTCQX_PRIMEQX',
  OtcBellevue = 'OTC_BELLEVUE',
  OtcSarasin = 'OTC_SARASIN',
  OtcUbsAm = 'OTC_UBS_AM',
  OtcVontobel = 'OTC_VONTOBEL',
  Other = 'OTHER',
  OutperformanceBonusCertificate = 'OUTPERFORMANCE_BONUS_CERTIFICATE',
  OutperformanceCertificate = 'OUTPERFORMANCE_CERTIFICATE',
  OverTheCounter = 'OVER_THE_COUNTER',
  PartialProtectionCertificate = 'PARTIAL_PROTECTION_CERTIFICATE',
  ParticipationCertificate = 'PARTICIPATION_CERTIFICATE',
  PinkSheetsCurrent = 'PINK_SHEETS_CURRENT',
  PinkSheetsDoNotAssignCategory = 'PINK_SHEETS_DO_NOT_ASSIGN_CATEGORY',
  PinkSheetsLimited = 'PINK_SHEETS_LIMITED',
  PinkSheetsNoInformation = 'PINK_SHEETS_NO_INFORMATION',
  PlainTurbo = 'PLAIN_TURBO',
  PlainVanillaWarrants = 'PLAIN_VANILLA_WARRANTS',
  PlusIndicationOfInterest = 'PLUS_INDICATION_OF_INTEREST',
  PlusListed = 'PLUS_LISTED',
  PlusListedMtf = 'PLUS_LISTED_MTF',
  PlusMarketEurope = 'PLUS_MARKET_EUROPE',
  PlusPrimary = 'PLUS_PRIMARY',
  PlusSecondaryListed = 'PLUS_SECONDARY_LISTED',
  PlusSecondaryUnlisted = 'PLUS_SECONDARY_UNLISTED',
  PortfolioFunds = 'PORTFOLIO_FUNDS',
  Prealp = 'PREALP',
  PreciousMetals = 'PRECIOUS_METALS',
  /** A market for companies that have a high market reputation based on an excellent earnings base and financial condition and can be continuously held by many investors including individual investors. */
  PremierMarket = 'PREMIER_MARKET',
  PrimaryMarketStructuredProducts = 'PRIMARY_MARKET_STRUCTURED_PRODUCTS',
  /** A market for companies whose market capitalization (liquidity) is large enough to attract investments from many institutional investors, that also have a high quality of corporate governance, as well as a commitment to sustainable growth and medium-to-long term improvement of corporate value with a focus on constructive dialogue with investors, and a market for those institutional and general investors investing in such companies. */
  PrimeMarket = 'PRIME_MARKET',
  PrivatePlacement = 'PRIVATE_PLACEMENT',
  ProfMktContExchReg = 'PROF_MKT_CONT_EXCH_REG',
  ProfMktEodExchReg = 'PROF_MKT_EOD_EXCH_REG',
  ProfMktGreenContExchReg = 'PROF_MKT_GREEN_CONT_EXCH_REG',
  ProfMktGreenEodExchReg = 'PROF_MKT_GREEN_EOD_EXCH_REG',
  Proper = 'PROPER',
  Protec = 'PROTEC',
  ProtectIndexanleihen = 'PROTECT_INDEXANLEIHEN',
  ProtectMultiIndexanleihen = 'PROTECT_MULTI_INDEXANLEIHEN',
  Protein = 'PROTEIN',
  ProMarket = 'PRO_MARKET',
  ProMultiDefenderVontis = 'PRO_MULTI_DEFENDER_VONTIS',
  ProUnits = 'PRO_UNITS',
  PublicSectorDebtNr = 'PUBLIC_SECTOR_DEBT_NR',
  PublicSectorDebtTr = 'PUBLIC_SECTOR_DEBT_TR',
  PublicTransports = 'PUBLIC_TRANSPORTS',
  QuadQuintupleIce = 'QUAD_QUINTUPLE_ICE',
  QuotedWholsaleRegulatedMarket = 'QUOTED_WHOLSALE_REGULATED_MARKET',
  /** Market for companies which have promising and unique businesses, especially regional small and medium companies. */
  QBoard = 'Q_BOARD',
  RangeDefenderVontis = 'RANGE_DEFENDER_VONTIS',
  RangeNotes = 'RANGE_NOTES',
  RangeVontis = 'RANGE_VONTIS',
  RealEstateInvestmentFund = 'REAL_ESTATE_INVESTMENT_FUND',
  ReferenceEntitiyCertificatesWithConditionalCapitalProtection = 'REFERENCE_ENTITIY_CERTIFICATES_WITH_CONDITIONAL_CAPITAL_PROTECTION',
  ReferenceEntitiyCertificatesWithParticipation = 'REFERENCE_ENTITIY_CERTIFICATES_WITH_PARTICIPATION',
  ReferenceEntitiyCertificatesWithYieldEnhancement = 'REFERENCE_ENTITIY_CERTIFICATES_WITH_YIELD_ENHANCEMENT',
  RegisteredShare = 'REGISTERED_SHARE',
  RegulatedMarked = 'REGULATED_MARKED',
  RegMktGreenPricedEod = 'REG_MKT_GREEN_PRICED_EOD',
  RegMktGreenQuotedCont = 'REG_MKT_GREEN_QUOTED_CONT',
  RegMktPricedEod = 'REG_MKT_PRICED_EOD',
  RegMktQuotedCont = 'REG_MKT_QUOTED_CONT',
  RelativeValueLongCertificates = 'RELATIVE_VALUE_LONG_CERTIFICATES',
  RemainingEurmNonLiquidEquit = 'REMAINING_EURM_NON_LIQUID_EQUIT',
  Repo = 'REPO',
  ReturnOfCertForPurposeOfRedemption = 'RETURN_OF_CERT_FOR_PURPOSE_OF_REDEMPTION',
  ReverseConvertibles = 'REVERSE_CONVERTIBLES',
  ReverseConvertiblePlus = 'REVERSE_CONVERTIBLE_PLUS',
  ReverseConvertiblePlusPro = 'REVERSE_CONVERTIBLE_PLUS_PRO',
  Rights = 'RIGHTS',
  RiskReversal = 'RISK_REVERSAL',
  Runner = 'RUNNER',
  Sarafloor = 'SARAFLOOR',
  Sarasailboost = 'SARASAILBOOST',
  Sarasailcoupon = 'SARASAILCOUPON',
  Sarasaildiscount = 'SARASAILDISCOUNT',
  Sarasailrainbow = 'SARASAILRAINBOW',
  Saratailoredcom = 'SARATAILOREDCOM',
  Saratailoredeq = 'SARATAILOREDEQ',
  Saratailoredfl = 'SARATAILOREDFL',
  Saratailoredhyb = 'SARATAILOREDHYB',
  Sarawarrants = 'SARAWARRANTS',
  Sarazertbonus = 'SARAZERTBONUS',
  Sarazertoutperf = 'SARAZERTOUTPERF',
  Sarazerttracker = 'SARAZERTTRACKER',
  SbaPools = 'SBA_POOLS',
  Schuldendarlehen = 'SCHULDENDARLEHEN',
  SdxBond = 'SDX_BOND',
  SdxEquity = 'SDX_EQUITY',
  Seaq = 'SEAQ',
  Seaq1 = 'SEAQ1',
  SeatsMarket = 'SEATS_MARKET',
  SeatsNonQuoted = 'SEATS_NON_QUOTED',
  SeatsQuoted = 'SEATS_QUOTED',
  SecondaryTradedFunds = 'SECONDARY_TRADED_FUNDS',
  /** The professional segment, addressed to professional investors, is designed to meet the listing needs of a diversified pool of issuers. */
  SegmentoProfessionale = 'SEGMENTO_PROFESSIONALE',
  Setsmm = 'SETSMM',
  Setsmm2 = 'SETSMM2',
  SetsmmTr = 'SETSMM_TR',
  Setsqx_3QtdCcp = 'SETSQX_3_QTD_CCP',
  Setsqx_3QtdNonCcp = 'SETSQX_3_QTD_NON_CCP',
  Setsqx_4NonQtdCcp = 'SETSQX_4_NON_QTD_CCP',
  Setsqx_4NonQtdNonCcp = 'SETSQX_4_NON_QTD_NON_CCP',
  SetsqxHighGrowthSegmentCcp = 'SETSQX_HIGH_GROWTH_SEGMENT_CCP',
  SetsqxHighGrowthSegmentNonCcp = 'SETSQX_HIGH_GROWTH_SEGMENT_NON_CCP',
  SetsqxSpecialistFundMarketCcp = 'SETSQX_SPECIALIST_FUND_MARKET_CCP',
  SetsqxSpecialistFundMarketNonQuotedNonCcp = 'SETSQX_SPECIALIST_FUND_MARKET_NON_QUOTED_NON_CCP',
  SetsqxSpecialistFundMarketQuotedNonCcp = 'SETSQX_SPECIALIST_FUND_MARKET_QUOTED_NON_CCP',
  SetsHighGrowthSegment = 'SETS_HIGH_GROWTH_SEGMENT',
  SetsSpecialistFundMarket = 'SETS_SPECIALIST_FUND_MARKET',
  ShareholdersWarrant = 'SHAREHOLDERS_WARRANT',
  SharkUnits = 'SHARK_UNITS',
  ShortCertificates = 'SHORT_CERTIFICATES',
  SmartTurbo = 'SMART_TURBO',
  Smi = 'SMI',
  SoftRunner = 'SOFT_RUNNER',
  SoftRunnerDoubleCoupon = 'SOFT_RUNNER_DOUBLE_COUPON',
  SoftRunnerWorstOf = 'SOFT_RUNNER_WORST_OF',
  Sponsored = 'SPONSORED',
  Spread = 'SPREAD',
  SpreadMultiDefenderVontis = 'SPREAD_MULTI_DEFENDER_VONTIS',
  SpreadWarrant = 'SPREAD_WARRANT',
  SprinterWarrantsTurbo = 'SPRINTER_WARRANTS_TURBO',
  SprintCertificate = 'SPRINT_CERTIFICATE',
  StandardClasse_1 = 'STANDARD_CLASSE_1',
  StandardClasse_2 = 'STANDARD_CLASSE_2',
  /** A market for companies that have a base-line, standard level of market capitalization (liquidity) representing an appropriate investment opportunity as a public company, have a basic corporate governance structure as a listed company, and that are committed to sustainable growth and medium-to-long term enhancement of corporate value, and a market for institutional and general investors investing in such companies. */
  StandardMarket = 'STANDARD_MARKET',
  StarBc46 = 'STAR_BC46',
  StepCertificate = 'STEP_CERTIFICATE',
  StepCerts = 'STEP_CERTS',
  StepUpVoncerts = 'STEP_UP_VONCERTS',
  SterlingBonds = 'STERLING_BONDS',
  Straddle = 'STRADDLE',
  Strangle = 'STRANGLE',
  StructuredProducts = 'STRUCTURED_PRODUCTS',
  StructuredProductsBonds = 'STRUCTURED_PRODUCTS_BONDS',
  StructuredProductsCertificates = 'STRUCTURED_PRODUCTS_CERTIFICATES',
  StructuredProductsCommodities = 'STRUCTURED_PRODUCTS_COMMODITIES',
  StructuredProductsForex = 'STRUCTURED_PRODUCTS_FOREX',
  StructuredProductsWarrants = 'STRUCTURED_PRODUCTS_WARRANTS',
  SukukExchReg = 'SUKUK_EXCH_REG',
  SukukRegMkt = 'SUKUK_REG_MKT',
  Swaps = 'SWAPS',
  Swaption = 'SWAPTION',
  SwapNotes = 'SWAP_NOTES',
  /** A triple-A rated covered bond issued by "Pfandbriefbank schweizerischer Hypothekarinstitute AG" and collateralized by property mortgages. */
  SwissPfandbrief = 'SWISS_PFANDBRIEF',
  SwissSmallAndMidcaps = 'SWISS_SMALL_AND_MIDCAPS',
  SyntheticInstrumentsBaskets_2NdLinesharesEtc = 'SYNTHETIC_INSTRUMENTS_BASKETS_2ND_LINESHARES_ETC',
  TaylorMade = 'TAYLOR_MADE',
  TechnicalInstruments = 'TECHNICAL_INSTRUMENTS',
  ThemesStrategyBasketCertificate = 'THEMES_STRATEGY_BASKET_CERTIFICATE',
  TopPerformer = 'TOP_PERFORMER',
  TopUnits = 'TOP_UNITS',
  TouchdownWarrants = 'TOUCHDOWN_WARRANTS',
  ToyUnits = 'TOY_UNITS',
  TrackerCertificate = 'TRACKER_CERTIFICATE',
  TrackerCertificates = 'TRACKER_CERTIFICATES',
  TrackerPlus = 'TRACKER_PLUS',
  Treasuries = 'TREASURIES',
  TriggerIceUnits = 'TRIGGER_ICE_UNITS',
  TripleIceUnits = 'TRIPLE_ICE_UNITS',
  TseMothers = 'TSE_MOTHERS',
  TurboCertificate = 'TURBO_CERTIFICATE',
  TwinWinCertificate = 'TWIN_WIN_CERTIFICATE',
  UndefinedStructuredProduct = 'UNDEFINED_STRUCTURED_PRODUCT',
  UnitsSpez = 'UNITS_SPEZ',
  UnlimitedFx = 'UNLIMITED_FX',
  UnlimitedTurboCertificate = 'UNLIMITED_TURBO_CERTIFICATE',
  VariousCertificates = 'VARIOUS_CERTIFICATES',
  VariousLeverageWithoutKnockOut = 'VARIOUS_LEVERAGE_WITHOUT_KNOCK_OUT',
  VariousLeverageWithKnockOut = 'VARIOUS_LEVERAGE_WITH_KNOCK_OUT',
  VariousParticipationProducts = 'VARIOUS_PARTICIPATION_PRODUCTS',
  VariousWarrants = 'VARIOUS_WARRANTS',
  VisionsGoldEquityFundsAdamant = 'VISIONS_GOLD_EQUITY_FUNDS_ADAMANT',
  Voncashs = 'VONCASHS',
  Voncerts = 'VONCERTS',
  VoncertsOpenEndPlus = 'VONCERTS_OPEN_END_PLUS',
  VoncertsPlus = 'VONCERTS_PLUS',
  VoncertsSpez = 'VONCERTS_SPEZ',
  VoncoresDiscountCertificates = 'VONCORES_DISCOUNT_CERTIFICATES',
  VoncoresSpez = 'VONCORES_SPEZ',
  Vonpeps = 'VONPEPS',
  VonpepsSpez = 'VONPEPS_SPEZ',
  Vontifloors = 'VONTIFLOORS',
  Vontis = 'VONTIS',
  VontisSpez = 'VONTIS_SPEZ',
  VontobelAbsoluteIncomeNotes = 'VONTOBEL_ABSOLUTE_INCOME_NOTES',
  VontobelBonusIncomeNotes = 'VONTOBEL_BONUS_INCOME_NOTES',
  VontobelCappedUnits = 'VONTOBEL_CAPPED_UNITS',
  VontobelExchangeableNotes = 'VONTOBEL_EXCHANGEABLE_NOTES',
  VontobelUnits = 'VONTOBEL_UNITS',
  Vontts = 'VONTTS',
  VonttsSpez = 'VONTTS_SPEZ',
  VorsorgeFunds = 'VORSORGE_FUNDS',
  WarrantsOnCertificates = 'WARRANTS_ON_CERTIFICATES',
  WarrantOfBond = 'WARRANT_OF_BOND',
  WarrantOnCommodity = 'WARRANT_ON_COMMODITY',
  WarrantOnCurrency = 'WARRANT_ON_CURRENCY',
  WarrantOnInterestRate = 'WARRANT_ON_INTEREST_RATE',
  WarrantSpez = 'WARRANT_SPEZ',
  WholeLoanMortgagesSubordinates = 'WHOLE_LOAN_MORTGAGES_SUBORDINATES',
  WinWin = 'WIN_WIN',
  ZeroCouponCurves = 'ZERO_COUPON_CURVES',
  ZkbFunds = 'ZKB_FUNDS',
  ZkbIndex = 'ZKB_INDEX',
  ZkbVisionsFunds = 'ZKB_VISIONS_FUNDS',
  ZkbWarrants = 'ZKB_WARRANTS'
}

export type ListingLookup = {
  __typename?: 'ListingLookup';
  /** The trading currency, as specified by SIX, typically follows the ISO 4217 alpha-3 code. For cryptocurrencies, the Cryptocurrency Symbol in Instrument Symbology can be used for reference. */
  listingCurrency: Scalars['Currency']['output'];
  /**
   * Listing short name with up to 19 characters.
   * @deprecated Use listingShortName, removed since version '2024-01-01'
   */
  listingName: Scalars['String']['output'];
  /** Listing short name with up to 19 characters. */
  listingShortName: Scalars['String']['output'];
  /** Indicating the current state of the listing, e.g. listing applied for, listing effective, delisted, etc. */
  listingStatus: ListingStatus;
  /**
   * Market short name with up to 19 characters.
   * @deprecated Use marketShortName, removed since version '2024-01-01'
   */
  marketName: Scalars['String']['output'];
  /** The market short name where the instrument is listed with up to 19 characters. */
  marketShortName: Scalars['String']['output'];
};

export type ListingMarketData = {
  __typename?: 'ListingMarketData';
  /** End Of Day History. */
  endOfDayHistory?: Maybe<Array<EndOfDayHistoryItem>>;
  /**
   * Intraday History APIs are used to capture historic intervalized trade market data during a specified time range without further updates. It summarizes market activity and is allowing someone to synchronize with the intraday price data and quickly process key information about market movements. It's often being used for technical analysis and chartering features.
   *
   * There are two distinct Intraday History endpoints and the request period starts from the specified date ("dateTo") backwards:
   *
   * IntradayHistoryTrades: Retrieve historical intraday trade data, including all trades and best quotes at the moment of the trade, for up to 10 days. Each API request can retrieve data for a maximum of 2 consecutive days of trade history
   * IntradayHistorySummary:  Retrieve aggregated price and trading activity data for a specified time period. The data includes the price fields open, high, low, last price, volume, and the number of trades. The data retrieval limitations are as follows:
   * If the requested time period is less than 5 minutes, each API request can retrieve data for a maximum of 2 consecutive days, with historical data range up to 10 days
   * If the requested time period equals or exceeds 5 minutes, each API request can retrieve data for a maximum of 30 consecutive days, allowing access to historical data range up to 90 days
   */
  intradayHistory?: Maybe<IntradayHistory>;
  intradaySnapshot?: Maybe<IntradaySnapshot>;
  /**
   * Intraday Timeseries
   * @deprecated Use intradayHistory
   */
  intradayTimeseries?: Maybe<IntradayTimeseries>;
};


export type ListingMarketDataEndOfDayHistoryArgs = {
  filters: PriceFilter;
};


export type ListingMarketDataIntradaySnapshotArgs = {
  qualityOfService?: InputMaybe<QualityOfService>;
};

export type ListingReferenceData = {
  __typename?: 'ListingReferenceData';
  entityBase?: Maybe<EntityBase>;
  instrumentBase?: Maybe<InstrumentBase>;
  /** @deprecated Use InstrumentBase instead. */
  instrumentSummary?: Maybe<InstrumentSummary>;
  instrumentSymbology?: Maybe<InstrumentSymbology>;
  listingBase?: Maybe<ListingBase>;
  listingSymbology?: Maybe<ListingSymbology>;
  marketBase?: Maybe<MarketBase>;
};

/** Listing scheme for all listings in SIX. */
export enum ListingScheme {
  CinsBc = 'CINS_BC',
  CommoncodeBc = 'COMMONCODE_BC',
  CusipBc = 'CUSIP_BC',
  IsinBc = 'ISIN_BC',
  SedolBc = 'SEDOL_BC',
  /**
   * A ticker symbol is an abbreviation used to uniquely identify publicly traded shares of a particular stock
   * on a particular stock market.
   */
  TickerBc = 'TICKER_BC',
  /** This is the primary key of listings in SIX. */
  ValorBc = 'VALOR_BC',
  WknBc = 'WKN_BC'
}

/** Indicates the current state of the listing, e.g. listing applied for, listing effective, delisted, etc. in coded form. */
export enum ListingStatus {
  /** Admission to trading is generally instigated by a participant. The consent of the issuer is not required, and there are no obligations on the issuer. */
  AdmittedToTrading = 'ADMITTED_TO_TRADING',
  /** Admission to trading has been applied for by the issuer. */
  Applied = 'APPLIED',
  /** The financial instrument is delisted according to the exchange's rules. */
  DelistedByExchange = 'DELISTED_BY_EXCHANGE',
  /** A listing always takes place at the request of the issuer (respectively its recognized representative) and involves certain obligations on the issuer at the time of initial listing and in maintaining the listing. */
  Listed = 'LISTED',
  /** Securities that are listed on this market place do receive quotes but cannot be traded on this market place. */
  ListingNoTrading = 'LISTING_NO_TRADING',
  /** A market without a trade execution (i.e. only reported/off exchange trades, quotes, no trade matching). */
  NotListed = 'NOT_LISTED',
  /** The financial instrument is listed on a regulated market. */
  OfficialListingAccToRegulatoryAuthority = 'OFFICIAL_LISTING_ACC_TO_REGULATORY_AUTHORITY',
  Other = 'OTHER',
  /** The security was listed only provisionally on the trading place. */
  Provisional = 'PROVISIONAL',
  Suspended = 'SUSPENDED',
  /** The financial instrument is unofficially listed according to the exchange's rules. */
  UnofficiallyListedAccordingToExchange = 'UNOFFICIALLY_LISTED_ACCORDING_TO_EXCHANGE',
  /** Denominates a listing generated by SIX Financial Information. As no stock exchange quotation is available it is displayed as a virtual listing. A typical example of use are Futures that are copied to the Underlying in order to display continuous Futures time series. */
  VirtualListingDerivedValuesOnly = 'VIRTUAL_LISTING_DERIVED_VALUES_ONLY',
  /** Short form of 'when, as, and if issued' referring to a transaction made conditionally because the security, although authorised, has not yet been issued. */
  WhenIssued = 'WHEN_ISSUED',
  Withdrawn = 'WITHDRAWN'
}

export type ListingSymbology = {
  __typename?: 'ListingSymbology';
  /**
   * A listing identifier used for traded options and futures in line with the ESMA's requirements. The Alternative Instrument Identifier (AII) is composed of six elements.:
   * - The ISO 10383 Market Identifier Code (MIC) of the regulated market where the derivative is traded
   * - The Exchange Product Code - the code assigned to the derivative contract showing the underlying instrument by the regulated market where it is traded
   * - Derivative Type - identifying whether the derivative is an option or a future
   * - Put/Call Identifier - mandatory where the derivative is an option
   * - Expiry Date - exercise date/maturity date of the derivative
   * - Strike Price - mandatory where the derivative is an option
   */
  alternativeInstrumentIdentifier?: Maybe<Scalars['String']['output']>;
  /** Allocated by Bloomberg, the Financial Instrument Global Identifier (FIGI) Exchange Level code is a unique identifier of financial instruments that can be assigned to instruments including equities, options, derivatives, futures, corporate and government bonds, municipals, currencies, and mortgage products. For equity instruments an identifier is issued per instrument per trading venue. */
  figi?: Maybe<Scalars['String']['output']>;
  /** The intrument identifier allocated by Bloomberg, the Financial Instrument Global Identifier (FIGI) Country Composite enables users to link multiple FIGIs at the trading venue level within the same country or market in order to obtain an aggregated view for an instrument within that country or market. */
  figiComposite?: Maybe<Scalars['String']['output']>;
  /** Listing identification as used by the source (trading place or data provider) on said trading place which is linked to the identification of a financial instrument for price updates. */
  listingSymbol?: Maybe<Scalars['String']['output']>;
  /** Stock Exchange Daily Official List (SEDOL) code is assigned by the London Stock Exchange for listings within a market in a specific country or region. */
  sedol?: Maybe<Scalars['String']['output']>;
  /** Symbol generated with an algorithm defined by SIX Financial Information. */
  sixSymbol?: Maybe<Scalars['String']['output']>;
  /** Symbol used to identify an instrument on a given market for trading purposes. It is the symbol commonly used by traders on a specific listing to identify an instrument. */
  ticker?: Maybe<Scalars['String']['output']>;
};

/** Lookup status: this is the driver to make decision about outcome of the lookup */
export enum LookupStatus {
  Found = 'FOUND',
  NotAuthorized = 'NOT_AUTHORIZED',
  NotFound = 'NOT_FOUND',
  /** Provided Id does not contain required BC or MIC part */
  NotValidId = 'NOT_VALID_ID'
}

/** no description provided. */
export enum MifidiiInvestmentFirmCode {
  /** An investment firm, a market operator or a data reporting service provider authorised in accordance with Directive 2014/65/EU. */
  MifidIiInvestmentFirm = 'MIFID_II_INVESTMENT_FIRM',
  Other = 'OTHER'
}

/** The dominant value of Underlying asset class for all underlyings, which characterises best the ensemble of underlying instruments. */
export enum MainUnderlyingAssetClass {
  AgricultureForestryFishing = 'AGRICULTURE_FORESTRY_FISHING',
  AlternativeInvestments = 'ALTERNATIVE_INVESTMENTS',
  Bonds = 'BONDS',
  Commodities = 'COMMODITIES',
  Derivatives = 'DERIVATIVES',
  Energy = 'ENERGY',
  Equities = 'EQUITIES',
  Forex = 'FOREX',
  Industry = 'INDUSTRY',
  InflationRate = 'INFLATION_RATE',
  InterestRateEgLibor = 'INTEREST_RATE_EG_LIBOR',
  LiquidityMoneyMarket = 'LIQUIDITY_MONEY_MARKET',
  Metals = 'METALS',
  /** Various categories of instruments (such as equity and debt) are the underlying assets for the derivative. */
  Mixed = 'MIXED',
  Mortgage = 'MORTGAGE',
  Other = 'OTHER',
  PreciousMetals = 'PRECIOUS_METALS',
  Rating = 'RATING',
  RealEstate = 'REAL_ESTATE',
  Services = 'SERVICES'
}

export type Market = {
  __typename?: 'Market';
  lookup?: Maybe<MarketLookup>;
  /** status of the response */
  lookupStatus: LookupStatus;
  referenceData?: Maybe<MarketReferenceData>;
  /** The requested entity id used in the request */
  requestedId: Scalars['UserInputId']['output'];
  /** The requested scheme used in the request */
  requestedScheme: MarketScheme;
};

/**
 * The Market Base service is designed to provide clients with necessary market reference data for the requested markets or listings.
 * The interface grants swift and user-friendly access to a predefined set of key attributes applicable to various types of price sources.
 * Its intuitive nature guarantees that clients possess crucial information for enhancing operational efficiency in maintaining their master reference data.
 */
export type MarketBase = {
  __typename?: 'MarketBase';
  /**
   * Bourse Code (BC) of the market.
   * It represents the SIX Financial Information identifier for exchanges, trading platforms, regulated or non-regulated markets and trade reporting facilities
   * as sources of prices and related information.
   */
  bc: Scalars['Bc']['output'];
  /** Language of the market names according to ISO 639 alpha-2 code. */
  language?: Maybe<Language>;
  /** Country code delivered as ISO 3166 alpha-2 code. */
  marketCountry?: Maybe<Scalars['Country']['output']>;
  /** Market long name. */
  marketLongName?: Maybe<Scalars['String']['output']>;
  /** Market short name. */
  marketShortName?: Maybe<Scalars['String']['output']>;
  /** Status Indicating whether a market is active or not. */
  marketStatus?: Maybe<MarketStatus>;
  /** SIX Financial Information alphabetical code composed of up to 4 letters identifying exchanges, trading platforms, regulated or non-regulated markets and trade reporting facilities as sources of prices and related information. */
  marketSymbol?: Maybe<Scalars['String']['output']>;
  /** Market classification allocated by SIX Financial Information. Present on all markets in the SIX Financial Information database. */
  marketType?: Maybe<MarketType>;
  /**
   * Market Identifier Code (MIC) of the market.
   * It is based on ISO 10383 alphanumeric-4 code and represents a universal method of identifying exchanges, trading platforms, regulated or non-regulated markets and trade reporting facilities
   * as sources of prices and related information.
   */
  mic?: Maybe<Scalars['String']['output']>;
  /**  Type of Market Identifier Code (MIC) according ISO 10383. */
  micType?: Maybe<MicType>;
};

/** To display name, type and status of a market */
export type MarketLookup = {
  __typename?: 'MarketLookup';
  /** Market short name. */
  marketShortName: Scalars['String']['output'];
  /** Status Indicating whether a market is active or not. */
  marketStatus: MarketStatus;
  /** Market classification allocated by SIX Financial Information. Present on all markets in the SIX Financial Information database. */
  marketType: MarketType;
};

/** A short description of the Market, useful to create links or other follow up requests. */
export type MarketReference = {
  __typename?: 'MarketReference';
  /** Bourse Code (BC) of the market. It represents the SIX Financial Information identifier for exchanges, trading platforms, regulated or non-regulated markets and trade reporting facilities as sources of prices and related information. */
  bc: Scalars['Bc']['output'];
  /** Market long name. */
  longName: Scalars['String']['output'];
  /** Market Identifier Code (MIC) of the market. It is based on ISO 10383 alphanumeric-4 code and represents a universal method of identifying exchanges, trading platforms, regulated or non-regulated markets and trade reporting facilities as sources of prices and related information. */
  mic?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use shortName */
  name: Scalars['String']['output'];
  /** Market short name. */
  shortName: Scalars['String']['output'];
};

export type MarketReferenceData = {
  __typename?: 'MarketReferenceData';
  marketBase?: Maybe<MarketBase>;
};

export enum MarketScheme {
  /** Bourse Code of the stock exchange. This is a primary key in SIX Financial Information. */
  Bc = 'BC'
}

export type MarketSession = {
  __typename?: 'MarketSession';
  day?: Maybe<DayOfWeek>;
};

/** The current status of a Market. */
export enum MarketStatus {
  /** As soon as an institution has been opened in the system, its status is automatically set at 'active'. */
  Active = 'ACTIVE',
  /**
   * SIX Financial Information does not provide any current event data and (currently) there are no active financial
   * instruments linked to this stock exchange in question and it is not linked to another institution for reference purposes.
   * This status does not imply, however, that the institution has ceased to exist as a legal entity.
   *
   * Additionally, it indicates that the institution in question is an existing stock exchange which, however,
   * does not include any links to financial instruments (i.e. no listing and price information)
   * and no pertinent activities (suspension of trading, stock market holiday etc.) are currently reported by SIX Financial Information.
   * *To give an example*: the stock exchange code is referenced in a structured product to ensure the monitoring of barriers.
   */
  Inactive = 'INACTIVE',
  /** Any other status. */
  Other = 'OTHER',
  /** For this stock exchange an active MIC code exists but no prices are provided. */
  ReferenceOnly = 'REFERENCE_ONLY'
}

/** Type of market, according to SIX. */
export enum MarketType {
  /** Price information provider, which is not an official exchange but is a direct source of the information, such as systematic internaliser, market maker or broker of securities, commodities or futures and options, asset managers (e.g. of mutual funds), evaluated price providers, contributors. */
  DirectPriceInformationProviderContributor = 'DIRECT_PRICE_INFORMATION_PROVIDER_CONTRIBUTOR',
  /** Price information provider (supplier) without taking an active part in the trade, considered an indirect (third party) source of the information. Examples include aggregators of information from direct sources (e.g. TRADING_PLACE_MARKET and DIRECT_PRICE_INFORMATION_PROVIDER) and price reporting venues. */
  IndirectPriceInformationProvider = 'INDIRECT_PRICE_INFORMATION_PROVIDER',
  /** Institution providing news within the news service of SIX Financial Information. */
  NewsAgency = 'NEWS_AGENCY',
  Other = 'OTHER',
  /** SIX aggregated or calculated data, as well as technical codes used for SIX internal purposes. */
  SixManagedPriceInformation = 'SIX_MANAGED_PRICE_INFORMATION',
  /** An organized market where tradable financial instruments (such as equity, bonds, commodities, foreign exchange transactions, crypto currencies, exchange traded derivates (ETDs), etc.) are bought and sold. Note: If an exchange (with a MIC) is calculating and disseminating index data, it will also receive this code. */
  TradingPlaceMarket = 'TRADING_PLACE_MARKET'
}

export enum MazuMarketAffiliation {
  /** US-dollar denominated bonds issued by emerging markets, particularly those in Latin America, and collateralized by US Treasury zero-coupon bonds. */
  BradyBonds = 'BRADY_BONDS',
  /** Bonds issued as Yankee, Samurai, Shogun or Daiymo. */
  DomesticForeignIssuer = 'DOMESTIC_FOREIGN_ISSUER',
  /** A Eurobond is a debt security that is  - issued in international markets (= contrary to domestic market),  - denominated in a Eurocurrency (= a form of money held or traded outside the country in whose currency its value is stated) and  - underwritten and sold by an international syndicate of financial corporations (= international group of banks). */
  Eurobond = 'EUROBOND',
  /** Euro Medium Term Notes combine characteristics of a Eurobond and a Medium Term Note. Therefore, Euro Medium Term Notes are:  - A debt security issued in international markets (= contrary to domestic market),  - denominated in a Eurocurrency (= a form of money held or traded outside the country in whose currency its value is stated),  - underwritten and sold by an international syndicate of financial corporations (= international group of banks) and - issued under a shelf registration program. */
  EuroMediumTermNoteEmtn = 'EURO_MEDIUM_TERM_NOTE_EMTN',
  /** A Euro Structured Instrument is a security that is - captured under security type 6 (income is option-like or redemption is dependent on one or several underlyings), - issued in international markets (= contrary to domestic market), - denominated in a Eurocurrency (= a form of money held or traded outside the country in whose currency its value is stated) and  - underwritten and sold by an international syndicate of financial corporations (=  international group of banks). */
  EuroStructuredInstrument = 'EURO_STRUCTURED_INSTRUMENT',
  /** Bond with placement not only on the Euromarket but also on the domestic market (e.g. France). */
  GlobalBondGlb = 'GLOBAL_BOND_GLB',
  IslamicBonds = 'ISLAMIC_BONDS',
  /** Under shelf registrations, issuers register securities that may be sold for a specific period after the effective date of the registration without the requirement of another registration statement each time new offerings are made. Debt securities issued under such a shelf registration program are designated as Medium Term Notes. */
  MediumTermNoteMtn = 'MEDIUM_TERM_NOTE_MTN',
  /** An Offshore RMB instrument (e.g. Dim Sum Bond), also known as Offshore RMB Instrument, is a security issued outside mainland China. The primary market for Offshore RMB Instruments is Hong Kong, but there exist other markets as well. An offshore RMB Instrument is denominated in CNH which stands for Renminbi (RMB) held or traded outside mainland China, not be confounded with CNY which represents the domestic Yuan. An Offshore RMB Instrument is usually underwritten and sold by an international syndicate of financial corporations. */
  OffshoreRmbInstrument = 'OFFSHORE_RMB_INSTRUMENT',
  Other = 'OTHER',
  /** Medium-term securities (normally with a term of 5-7 years) issued by foreign debtors in CHF and with a minimum denomination of CHF10'000.-. SFNT are not listed at a stock exchange. */
  SwissFrancNoteSfnt = 'SWISS_FRANC_NOTE_SFNT'
}

export type Message = {
  __typename?: 'Message';
  /** The Accrued interest refers to the interest that has accumulated on a fixed-income security but has not yet been paid to the investor. If no value is available for the current day, the value of the previous day is delivered. */
  accruedInterest?: Maybe<Value>;
  /**
   * The Auction Theoretical Matching Price, determined by the provider, is a price at which the maximum volume of orders can be executed at the time of an auction. The Theoretical Matching Price facilitates price discovery and transparency while helping resolve order imbalances. It shows at what price the trading would start if the order book was opened immediately. It is sometimes required by regulators to implement a smooth (re)opening and is used by investors to stop the point at which the balanced market would be priced.
   * While the Theoretical Matching Price is calculated in all auction types (e.g. opening, intraday, discreet, etc.), it has is an additional significance in the opening and closing auctions:
   * At the end of the Opening Auction the Theoretical Matching Price is used to generate an Open Price.
   * At the end of the Closing Auction the Theoretical Matching Price is used to generate a Close Price.
   * Note that in some markets this price could be called Indicative Match Price, Equilibrium Price, etc. If no value is available for the current day, the value of the previous generation is delivered.
   */
  auctionTheoreticalMatchingPrice?: Maybe<Value>;
  /**
   * An Ask (also known as an Offer) is a price at which securities, foreign exchange, or foreign bank notes are offered for sale.
   * The Best Ask is the lowest price offered by a stock's market makers to sell a particular trading instrument. It is the lowest price that an investor is willing to sell an asset for.
   */
  bestAsk?: Maybe<ValueAndSize>;
  /**
   * A Bid is an offer made by a trader, investor or other industry professional to purchase a security.
   * The Best Bid is the highest price offered by a stock's market makers to buy a particular trading instrument. It is the highest price that an investor is willing to pay for an asset.
   */
  bestBid?: Maybe<ValueAndSize>;
  /** The Break Even Point refers to the point at which the gains or losses from an investment or trade are equal to zero. It is the price or level of an asset at which there is neither profit nor loss. In other words, it is the point where the investor  has recouped their initial investment or reached a balance between costs and gains. If no value is available for the current day, the value of the previous day is delivered. */
  breakEvenPoint?: Maybe<Value>;
  /** The Close can either be derived from the final transaction conducted during the day or calculated by the provider. While it may not necessarily match the Last, it consistently reflects the official closing price, serving as a reliable measure of the day's concluding value. If no value is available for the current day, the value of the previous day is delivered. */
  close?: Maybe<ValueAndSize>;
  /** The Close Year is the end of the year valuation price determined by SIX. Prices are selected by SIX at the last busines day of the year. Subsequent updates valid for the preceding year and reported after 31 December are possible. */
  closeYear?: Maybe<Value>;
  /** The Convexity quantifies how the bond's price  deviates from the linear approximation of duration based on the time to maturity. Positive convexity means that as interest rates decrease, the bond's price increases at an increasing rate, while negative convexity implies that as rates increase, the bond's price decreases at an increasing rate. If no value is available for the current day, the value of the previous day is delivered. */
  convexity?: Maybe<Value>;
  /**
   * (DEPRECATED) The cumulated volume of exchange during the trading session.
   * @deprecated use 'volume' field
   */
  cumulatedVolume?: Maybe<Value>;
  /** The Delta is a measure of an option's sensitivity to changes in the price of the underlying asset. It indicates the expected change in the option price for every 1 currency unit change in the underlying asset. Delta helps traders and investors manage risk and create delta-neutral portfolios to mitigate exposure to price fluctuations. If no value is available for the current day, the value of the previous day is delivered. */
  delta?: Maybe<Value>;
  /** A Dividend Yield is the annualized gross yield based on the market price of a share. The dividend amount paid is based on the actual historical regular dividend payments looking back 12 months (trailing dividend method). If no value is available for the current day, the value of the previous day is delivered. */
  dividendYield?: Maybe<Value>;
  /** The Duration represents the weighted average time (in years) it takes for an investor to receive the present value of the bond's cash flows, including coupon payments and the return of principal based on the time to maturity. Duration helps assess the price volatility and interest rate risk of fixed-income investments. Generally, higher-duration securities are more sensitive to interest rate changes, while lower-duration securities are less affected by interest rate movements. If no value is available for the current day, the value of the previous day is delivered. */
  duration?: Maybe<Value>;
  /** The Gamma is a measure of the rate of change in an option's delta in response to changes in the price of the underlying asset. It represents the acceleration of delta. A higher gamma indicates that the delta of an option will change more rapidly in response to small movements in the underlying asset's price, while a lower gamma implies slower changes in delta. Gamma is important for options traders as it helps them assess and manage the risk associated with changes in delta and underlying asset prices. If no value is available for the current day, the value of the previous day is delivered. */
  gamma?: Maybe<Value>;
  /** The Gearing shows the ratio between the price of the underlying security and the price of the option. Also known as simple gearing. If no value is available for the current day, the value of the previous generation is delivered. */
  gearing?: Maybe<Value>;
  /** A High shows the intraday price swings, i.e. the highest price reached during the day. The high price enables the investor to directly estimate the daily price swings and the state of the market. The Daily High is a key input for charting. If no value is available for the current day, the value of the previous day is delivered. */
  high?: Maybe<ValueAndSize>;
  /** The High 1 Week indicates the highest price a security reached during the last week. It provide an overview over market tops and is used as a high band of history charts in trading. If no value is available for the current day, the value of the generation is delivered. */
  high1Week?: Maybe<Value>;
  /** The High 4 Week indicates the highest price a security reached during the last 4 weeks. It provide an overview over market tops and is used as a high band of history charts in trading. If no value is available for the current day, the value of the generation is delivered. */
  high4Week?: Maybe<Value>;
  /** The High 12 Week indicates the highest price a security reached during the last 12 weeks. It provide an overview over market tops and is used as a high band of history charts in trading. If no value is available for the current day, the value of the generation is delivered. */
  high12Week?: Maybe<Value>;
  /** The High 26 Week indicates the highest price a security reached during the last 26 weeks. It provide an overview over market tops and is used as a high band of history charts in trading. If no value is available for the current day, the value of the generation is delivered. */
  high26Week?: Maybe<Value>;
  /** A 52-Week High indicate the highest price a security reached during the last 52 weeks. It provide an overview over market tops and is used as a high band of history charts in trading. If no value is available for the current day, the value of the previous day is delivered. */
  high52Week?: Maybe<Value>;
  /** The High Static Limit is a provider or SIX calculated upper limit for price movements within a trading day. It is a static limit determined at the start of the trading day. Based on the high static limit market participants can estimate the price level for a possible volatility interruption and place their orders accordingly to profit from price spikes and price volatility. */
  highStaticLimit?: Maybe<Value>;
  /** The High Year To Date indicates the highest price for the calendar year based on the intraday high prices from 1 January to 31 December. If no value is available for the current day, the value of the previous day is delivered. */
  highYearToDate?: Maybe<Value>;
  /** The Historical 30 Days Volatility refers to the measure of the price volatility of an underlying asset over a specific historical period of 30 days. It calculates the standard deviation of the asset's prices during that period to gauge the level of volatility experienced by the asset. Historical 30 Days Volatility provides a snapshot price fluctuations, allowing investors to assess the short-term volatility characteristics of the asset and make informed decisions based on the observed historical volatility patterns. If no value is available for the current day, the value of the previous day is delivered. */
  historicalVolatility30Days?: Maybe<Value>;
  /** The Historical 90 Days Volatility refers to the measure of the price volatility of an underlying asset over a specific historical period of 90 days. It calculates the standard deviation of the asset's prices during that period to gauge the level of volatility experienced by the asset. Historical 90 Days Volatility provides a snapshot price fluctuations, allowing investors to assess the short-term volatility characteristics of the asset and make informed decisions based on the observed historical volatility patterns. If no value is available for the current day, the value of the previous day is delivered. */
  historicalVolatility90Days?: Maybe<Value>;
  /** The Historical 180 Days Volatility refers to the measure of the price volatility of an underlying asset over a specific historical period of 180 days. It calculates the standard deviation of the asset's prices during that period to gauge the level of volatility experienced by the asset. Historical 180 Days Volatility provides a snapshot price fluctuations, allowing investors to assess the short-term volatility characteristics of the asset and make informed decisions based on the observed historical volatility patterns. If no value is available for the current day, the value of the previous day is delivered. */
  historicalVolatility180Days?: Maybe<Value>;
  /** The Historical 250 Days Volatility refers to the measure of the price volatility of an underlying asset over a specific historical period of 250 days. It calculates the standard deviation of the asset's prices during that period to gauge the level of volatility experienced by the asset. Historical 180 Days Volatility provides a snapshot price fluctuations, allowing investors to assess the short-term volatility characteristics of the asset and make informed decisions based on the observed historical volatility patterns. If no value is available for the current day, the value of the previous day is delivered. */
  historicalVolatility250Days?: Maybe<Value>;
  /** The Implied Volatility refers to the market's expectation of the future volatility of an underlying asset. It represents the level of uncertainty or anticipated price fluctuations that market participants believe the asset will experience over a specified period. Higher implied volatility suggests greater expected price swings, while lower implied volatility indicates a calmer or more stable market expectation. If no value is available for the current day, the value of the previous day is delivered. */
  impliedVolatility?: Maybe<Value>;
  /** The Intrinsic Value refers to the inherent value of an option or a security, independent of its market price. It represents tha actual worth of an option or security based on its underlying assets or cash flows. In the case of options, the intrinsic value is the difference between the current price of the underlying asset and the option's strike price, if it is in-the-money. If an option is out-of-the-money, the intrinsic value is zero. If no value is available for the current day, the value of the previous day is delivered. */
  intrinsicValue?: Maybe<Value>;
  /** The Last represents the latest price attained during the main trading session when a financial asset was last traded. The price also serves as a reliable indicator of the most recent price for various asset classes, such as Equities, Bonds, Indices, Funds, Currencies, Reference Prices, Derivatives, and more. If no value is available for the current day, the value of the previous day is delivered. */
  last?: Maybe<ValueAndSize>;
  /** Lookup data for this listing. */
  lookup?: Maybe<ListingLookup>;
  /** A Low shows the intraday price swings, i.e. the lowest price reached during the day. The low price enables the investor to directly estimate the daily price swings and the state of the market. The Daily Low is a key input for charting. If no value is available for the current day, the value of the previous day is delivered. */
  low?: Maybe<ValueAndSize>;
  /** A Low 1 Week indicates the lowest price a security reached during the last week. It provides an overview over market bottoms and is used as low band of history charts in trading. If no value is available for the current day, the value of the previous generation is delivered. */
  low1Week?: Maybe<Value>;
  /** A Low 4 Week indicates the lowest price a security reached during the last 4 weeks. It provides an overview over market bottoms and is used as low band of history charts in trading. If no value is available for the current day, the value of the previous generation is delivered. */
  low4Week?: Maybe<Value>;
  /** A Low 12 Week indicates the lowest price a security reached during the last 12 weeks. It provides an overview over market bottoms and is used as low band of history charts in trading. If no value is available for the current day, the value of the previous generation is delivered. */
  low12Week?: Maybe<Value>;
  /** A Low 26 Week indicates the lowest price a security reached during the last 26 weeks. It provides an overview over market bottoms and is used as low band of history charts in trading. If no value is available for the current day, the value of the previous generation is delivered. */
  low26Week?: Maybe<Value>;
  /** A 52-Week Low  indicate the lowest price a security reached during the last 52 weeks. They provide an overview over market bottoms and is used as low band of history charts in trading. If no value is available for the current day, the value of the previous day is delivered. */
  low52Week?: Maybe<Value>;
  /** The Low Static Limit is a provider or SIX calculated lower limit for price movements within a trading day. It is a static limit determined at the start of the trading day. Based on the low static limit market participants can estimate the price level for a possible volatility interruption and place their orders accordingly to profit from price spikes and price volatility. */
  lowStaticLimit?: Maybe<Value>;
  /** The Low Year To Date indicates the lowest price for the calendar year based on the intraday low prices from 1 January to 31 December. If no value is available for the current day, the value of the previous day is delivered. */
  lowYearToDate?: Maybe<Value>;
  /** The Market Capitalisation refers to the total market value of a company's outstanding shares of stock. If no value is available for the current day, the value of the previous day is delivered. */
  marketCapitalisation?: Maybe<Value>;
  /** The Mid is a price between the buying and selling price during the same trading session. Since Bids and Asks most of the time are quoted in equal distance from the fair value, a Mid calculation can approximate the fair value of an instrument and be useful while trading less liquid instruments. If no value is available for the current day, the value of the previous generation is delivered. */
  mid?: Maybe<Value>;
  /** The Modified Duration represents an adjusted version of the duration that takes into account the bond's yield-to-maturity. Modified duration quantifies the percentage change in the bond's price for a given change in yield based on the time to maturity. It helps investors assess the potential impact of interest rate fluctuations on bond prices and make informed decisions regarding fixed-income investments. If no value is available for the current day, the value of the previous day is delivered. */
  modifiedDuration?: Maybe<Value>;
  /** The Moneyness refers to the relationship between the current price of an underlying asset and the strike price of an option. It indicates the percentage by which the strike price is above or below the current price of the underlying asset.  It shows if an option is in-the-money, at-the-money, or out-of-the-money. In-the-money options have a strike price favorable to the current price of the underlying asset, while out-of-the-money options have a strike price unfavorable to the current price. Moneyness is a crucial factor in options pricing and trading strategies. If no value is available for the current day, the value of the previous day is delivered. */
  moneyness?: Maybe<Value>;
  /** The Number of Trades is the number of daily transactions during an exchange session. It indicates how many trades are made in a given instrument over a certain period of time. It helps to estimate the liquidity of the particular security and/or detect an unusual activity level on a listing. If no value is available for the current day, the value of the previous generation is delivered. */
  numberOfTrades?: Maybe<Value>;
  /** The Omega represents the percentage change in an option's value with respect to the percentage change in the underlying price and measures the leverage of an options position. A measure for assessing the leverage of options and/or warrants. It indicates the percentage by which the price of a call (put) will increase (decrease) if the price of the underlying security rises by one percent. Also known as effective gearing.  If no value is available for the current day, the value of the previous generation is delivered. */
  omega?: Maybe<Value>;
  /** An Open is associated with the first transaction of the day. It follows immediately after the opening auction (if any) is completed. It is an opening price or first recorded price of the trading day - any value that the provider officially designates as the open. It is not necessarily a transacted price. If no value is available for the current day, the value of the previous day is delivered. */
  open?: Maybe<ValueAndSize>;
  /** An Open Interest is an amount of open derivative contracts that are not closed or delivered on a particular day. It indicates the most active derivative contracts. The Open interest decreases when buyers (or holders) and sellers (or writers) of contracts close out more positions than were opened that day. If no value is available for the current day, the value of the previous day is delivered. */
  openInterest?: Maybe<Value>;
  /** The Percentage Change 5 Days provides the percentage difference in the price of a financial instrument over a period of five trading days. It measures the relative price movement of the instrument over a short-term timeframe. It is calculated with the previous day price of the instrument compared to the closing price six trading days ago. */
  percentageChange5Days?: Maybe<Value>;
  /** The Percentage Change Year To Date provides the percentage difference in the price of a financial instrument from the end of the previous calendar year to the previous day. It provides an indication of the price performance of an instrument. It is calculated with the previous day price compared to the previous year close price of the instrument. */
  percentageChangeYearToDate?: Maybe<Value>;
  /** The Percentage Spread Best Bid Ask is the percentage difference between the best bid and the best ask. It is the cost of executing an immediate trade, as a buyer would have to pay the ask price and a seller would receive the bid price. The narrower the bid-ask spread, the more liquid and competitive the market tends to be. A wider spread can indicate less liquidity and potentially higher trading costs. */
  percentageSpreadBestBidAsk?: Maybe<Value>;
  /** The Performance Year To Date provides the total return performance year-to-date in percentage. It is calculated compared to the previous year close trade and includes dividend reinvestment. If no value is available for the current day, the value of the previous day is delivered. */
  performanceYearToDate?: Maybe<Value>;
  /** The Price Earnings Ratio Estimated is the relationship of the share price to the net profit of the company. It is calculated by dividing the market price of the shares by the estimated earnings per share. If no value is available for the current day, the value of the previous day is delivered. */
  priceEarningsRatioEstimated?: Maybe<Value>;
  /** The Price Earnings Ratio Reported is the relationship of the share price to the net profit of the company. It is calculated by dividing the market price of the shares by the reported earnings per share. If no value is available for the current day, the value of the previous day is delivered. */
  priceEarningsRatioReported?: Maybe<Value>;
  /**
   * The up-to-dateness of price data, also referred to as 'Data Quality Timeliness' or 'License Quality,' is determined by the default priority when no specific quality is chosen by the client in their request. The available quality levels are delivered based on the following order:
   *
   * 1. REAL_TIME
   * 2. DELAYED
   * 3. END_OF_DAY
   * 4. PREVIOUS_DAY
   */
  qualityOfService?: Maybe<QualityOfService>;
  /** The Reported Price signifies the latest recorded price at which a financial asset was traded and reported. While it may align with the Last price, it covers a broader scope by including pre- and post-market sessions, price corrections, off-market trades, and odd lot trades. This comprehensive approach ensures that all transactions throughout the day are included, providing a comprehensive view of the asset's trading activity. If no value is available for the current day, the value of the previous day is delivered. */
  reportedPrice?: Maybe<ValueAndSize>;
  requestedId: Scalars['UserInputId']['output'];
  requestedScheme: ListingScheme;
  /** The Rho is a measure of the sensitivity of an option's price to changes in interest rates. It represents the expected change in the option price for a 1% change in the risk-free interest rate. Rho is important for options traders and investors as it helps them evaluate the impact of interest rate fluctuations on option prices and make informed decisions regarding their options portfolio. If no value is available for the current day, the value of the previous day is delivered. */
  rho?: Maybe<Value>;
  /**
   * A Settlement Price is a price at which all the open contracts are settled in cash at the custodian level. This value is disseminated by the provider. It values the derivative's portfolio at the end of the trading day. It is used to calculate the margin requirements on the basis of its value and the provided collateral. It is the most important data attribute for Exchange Traded Derivatives (ETDs) and represents the fair market value of a commodity or derivative. The price used for determining a position's daily profit or loss as well as the related margin requirements for the position.
   * Typically, the settlement price is set by determining the weighted average price over a certain period of trading, typically shortly before the close of the market for Options, Futures, Indices. If no value is available for the current day, the value of the previous day is delivered.
   */
  settlementPrice?: Maybe<Value>;
  /** The Spread Best Bid Ask is the absolute difference between the best bid and the best ask. It is the cost of executing an immediate trade, as a buyer would have to pay the ask price and a seller would receive the bid price. The narrower the bid-ask spread, the more liquid and competitive the market tends to be. A wider spread can indicate less liquidity and potentially higher trading costs. */
  spreadBestBidAsk?: Maybe<Value>;
  streamId: Scalars['ID']['output'];
  /** The Theta is a measure of the time decay of an option's value. It represents the rate at which an option's price decreases as time passes, assuming all other factors remain constant. Theta is particularly relevant for options traders and investors as it highlights the diminishing value of an option as it approaches its expiration date. A higher theta implies faster time decay, while a lower theta suggests slower erosion of an option's value over time. If no value is available for the current day, the value of the previous day is delivered. */
  theta?: Maybe<Value>;
  /** The Time To Maturity refers to the remaining length from present day until a financial instrument, such as a bond (in years) or a derivative (in days), reaches its maturity date. If no value is available for the current day, the value of the previous day is delivered. */
  timeToMaturity?: Maybe<Value>;
  /** The Total Expense Ratio is a measure used in the financial industry to assess the total cost associated with managing and operating an investment fund, such as a mutual fund or exchange-traded fund (ETF). It represents the percentage of a fund's total assets that is used to cover the expenses incurred in managing the fund, including management fees, administrative costs, custody fees, legal and audit fees, and other operational expenses. If no value is available for the current day, the value of the previous day is delivered. */
  totalExpenseRatio?: Maybe<Value>;
  /** The Turnover is calculated by multiplying a daily Volume on the market in units/nominal/contracts and the current price for each traded unit. Its use is similar to that of Volume. In addition, it is also used for inter-market and inter-currency comparison purposes. In some markets it is used to measure the inflowing and outflowing of currency units. If no value is available for the current day, the value of the previous day is delivered. */
  turnover?: Maybe<Value>;
  /** The Turnover Total is the cumulative turnover on and off market. It is the daily volume in units/nominal/contracts multiplied by the current price of each traded unit. Its use is similar to that of Volume. In addition, it is also used for inter-market and inter-currency comparison purposes. In some markets it is used to measure the inflowing and outflowing of currency units. If no value is available for the current day, the value of the previous day is delivered. */
  turnoverTotal?: Maybe<Value>;
  type: MessageType;
  /** The Vega is a measure of an option's sensitivity to changes in implied volatility. It represents the expected change in the option price for a 1% change in the implied volatility of the underlying asset. Vega is used by traders and investors to assess and manage the impact of volatility fluctuations on option prices, as higher volatility typically leads to increased option premiums and vice versa. If no value is available for the current day, the value of the previous day is delivered. */
  vega?: Maybe<Value>;
  /** The Volume is a number of units/nominal/contracts traded on market during a session. It is mainly used for analytical purposes and can be used for time series and historical data or data studies to compare it with the associated price action. If no value is available for the current day, the value of the previous day is delivered. */
  volume?: Maybe<Value>;
  /** The Volume Total is the cumulative number of units/nominal/contracts traded on and off a market during a session. It is mainly used for analytical purposes and can be used for time series and historical data or data studies to compare it with the associated price action. If no value is available for the current day, the value of the previous day is delivered. */
  volumeTotal?: Maybe<Value>;
  /** The Volume Weighted Average Price (VWAP) is a trading indicator, which averages the ratio between the traded prices and the cumulative traded volume throughout the day. If no value is available for the current day, the value of the previous day is delivered. */
  vwap?: Maybe<Value>;
  /** The Yield to Call is a financial metric that represents the total return an investor would receive if a callable bond is called or redeemed by the issuer before its scheduled maturity date. It is calculated by considering the bond's current market price, the call price, the remaining time to the call date, and the bond's coupon rate. Exclusively for bonds whose early redemption is expressly possible. Calculation only carried out if the invoice rate is greater than the redemption rate. If no value is available for the current day, the value of the previous day is delivered. */
  yieldToCall?: Maybe<Value>;
  /** A Yield to Maturity is the internal rate of return (IRR, overall interest rate) earned by the investor who buys the bond today at the market price, assuming that the bond will be held until maturity, and that all coupon and principal payments will be made on schedule. If no value is available for the current day, the value of the previous day is delivered. */
  yieldToMaturity?: Maybe<Value>;
};

export enum MessageType {
  Error = 'ERROR',
  Start = 'START',
  Stop = 'STOP',
  Update = 'UPDATE'
}

/** ISO 20022 as described by https://www.iso20022.org/15022/uhb/mt564-72-field-22f.htm */
export enum MethodOfInterestComputationIndicator {
  /**
   * 30/360 (ISDA) or 30/360 (American Basic Rule):
   * Method whereby interest is calculated based on a 30-day month in a way similar to the 30/360 (basic rule) and a 365-day year. Accrued interest to a value date on the last day of a month shall be the same as to the 30th calendar day of the same month, except for February. This means that a 31st is assumed to be the 30th and the 28 Feb (or 29 Feb for a leap year) is assumed to be the 28th (or 29th).
   */
  A001 = 'A001',
  /**
   * 30/365:
   *
   * Method whereby interest is calculated based on a 30-day month in a way similar to the 30/360 (basic rule) and a 365-day year. Accrued interest to a value date on the last day of a month shall be the same as to the 30th calendar day of the same month, except for February. This means that a 31st is assumed to be the 30th and the 28 Feb (or 29 Feb for a leap year) is assumed to be the 28th (or 29th).
   */
  A002 = 'A002',
  /**
   * 30/Actual:
   *
   * Method whereby interest is calculated based on a 30-day month in a way similar to the 30/360 (basic rule) and the assumed number of days in a year in a way similar to the Actual/Actual (ICMA). Accrued interest to a value date on the last day of a month shall be the same as to the 30th calendar day of the same month, except for February. This means that the 31st is assumed to be the 30th and 28 Feb (or 29 Feb for a leap year) is assumed to be the 28th (or 29th). The assumed number of days in a year is computed as the actual number of days in the coupon period multiplied by the number of interest payments in the year.
   */
  A003 = 'A003',
  /**
   * Actual/360:
   *
   * Method whereby interest is calculated based on the actual number of accrued days in the interest period and a 360-day year.
   */
  A004 = 'A004',
  /**
   * Actual/365 (Fixed):
   *
   * Method whereby interest is calculated based on the actual number of accrued days in the interest period and a 365-day year.
   */
  A005 = 'A005',
  /**
   * Actual/Actual (ICMA):
   *
   * Method whereby interest is calculated based on the actual number of accrued days and the assumed number of days in a year, that is, the actual number of days in the coupon period multiplied by the number of interest payments in the year. If the coupon period is irregular (first or last coupon), it is extended or split into quasi-interest periods that have the length of a regular coupon period and the computation is operated separately on each quasi-interest period and the intermediate results are summed up.
   */
  A006 = 'A006',
  /**
   * 30E/360 or Eurobond basis:
   *
   * Method whereby interest is calculated based on a 30-day month and a 360-day year. Accrued interest to a value date on the last day of a month shall be the same as to the 30th calendar day of the same month. This means that the 31st is assumed to be the 30th and the 28 Feb (or 29 Feb for a leap year) is assumed to be equivalent to 30 Feb. However, if the last day of the maturity coupon period is the last day of February, it will not be assumed to be the 30th. It is a variation of the 30/360 (ICMA) method commonly used for eurobonds. The usage of this variation is only relevant when the coupon periods are scheduled to end on the last day of the month.
   */
  A007 = 'A007',
  /**
   * Actual/Actual (ISDA):
   *
   * Method whereby interest is calculated based on the actual number of accrued days of the interest period that fall (falling on a normal year, year) divided by 365, added to the actual number of days of the interest period that fall (falling on a leap year, year) divided by 366.
   */
  A008 = 'A008',
  /**
   * Actual/365L or Actual/Actual (basic rule):
   *
   * Method whereby interest is calculated based on the actual number of accrued days and a 365-day year (if the coupon payment date is NOT in a leap year) or a 366-day year (if the coupon payment date is in a leap year).
   */
  A009 = 'A009',
  /**
   * Actual/Actual (AFB):
   *
   * Method whereby interest is calculated based on the actual number of accrued days and a 366-day year (if 29 Feb falls in the coupon period) or a 365-day year (if 29 Feb does not fall in the coupon period). If a coupon period is longer than one year, it is split by repetitively separating full year subperiods counting backwards from the end of the coupon period (a year backwards from 28 Feb being 29 Feb, if it exists). The first of the subperiods starts on the start date of the accrued interest period and thus is possibly shorter than a year. Then the interest computation is operated separately on each subperiod and the intermediate results are summed up.
   */
  A010 = 'A010',
  /**
   * 30/360 (ICMA) or 30/360 (basic rule):
   *
   * Method whereby interest is calculated based on a 30-day month and a 360-day year. Accrued interest to a value date on the last day of a month shall be the same as to the 30th calendar day of the same month, except for February. This means that the 31st is assumed to be the 30th and 28 Feb (or 29 Feb for a leap year) is assumed to be the 28th (or 29th). It is the most commonly used 30/360 method for non-US straight and convertible bonds issued before 1 January 1999.
   */
  A011 = 'A011',
  /**
   * 30E2/360 or Eurobond basis model 2:
   *
   * Method whereby interest is calculated based on a 30-day month and a 360-day year. Accrued interest to a value date on the last day of a month shall be the same as to the 30th calendar day of the same month, except for the last day of February whose day of the month value shall be adapted to the value of the first day of the interest period if the latter is higher and if the period is one of a regular schedule. This means that the 31st is assumed to be the 30th and 28 Feb of a non-leap year is assumed to be equivalent to 29 Feb when the first day of the interest period is the 29th, or to 30 Feb when the first day of the interest period is the 30th or the 31st. The 29th day of February in a leap year is assumed to be equivalent to 30 Feb when the first day of the interest period is the 30th or the 31st. Similarly, if the coupon period starts on the last day of February, it is assumed to produce only one day of interest in February as if it was starting on 30 Feb when the end of the period is the 30th or the 31st, or two days of interest in February when the end of the period is the 29th, or three days of interest in February when it is 28 Feb of a non-leap year and the end of the period is before the 29th.
   */
  A012 = 'A012',
  /**
   * 30E3/360 or Eurobond basis model 3:
   *
   * Method whereby interest is calculated based on a 30-day month and a 360-day year. Accrued interest to a value date on the last day of a month shall be the same as to the 30th calendar day of the same month. This means that the 31st is assumed to be the 30th and 28 Feb (or 29 Feb for a leap year) is assumed to be equivalent to 30 Feb. It is a variation of the 30E/360 (or Eurobond basis) method where the last day of February is always assumed to be the 30th, even if it is the last day of the maturity coupon period.
   */
  A013 = 'A013',
  /**
   * Actual/365NL or Actual/365 No Leap:
   *
   * Method whereby interest is calculated based on the actual number of accrued days in the interest period, excluding any leap day from the count, and a 365-day year.
   */
  A014 = 'A014',
  /**
   * NARRATIVE:
   * Other method than A001-A014.
   */
  Narr = 'NARR',
  /** Used for unexpected values */
  Other = 'OTHER'
}

/** E125 Market Identifier Code Type */
export enum MicType {
  /** Entity operating an exchange/market/trade reporting facility in a specific market/country (Operating/Exchange Level MIC according to ISO 10383). */
  Operating = 'OPERATING',
  Other = 'OTHER',
  /** "Section of an exchange/market/trade reporting facility that specialises in one or more specific instruments or that is regulated differently (Segment MIC according to ISO 10383). NOTE 1: A market segment MIC can only be registered if an operating/exchange MIC already exists. NOTE 2: It is not required to have a MIC registered for all segments of a market, only for those segments that need to be identified." */
  Segment = 'SEGMENT'
}

/** Code indicating that the financial instruments in question are not fully monitored by SIX Financial Information. */
export enum MonitoringRestriction {
  /** All outstanding securities are held by the issuer, and they confirmed that the issue has been withdrawn prematurely. The security will be inactivated within few days. */
  AllSecuritiesHeldByTheIssuerRepurchasedAndDeleted = 'ALL_SECURITIES_HELD_BY_THE_ISSUER_REPURCHASED_AND_DELETED',
  /** All outstanding securities are held by the issuer, and they confirmed that the issue has been withdrawn prematurely. The security remains active. */
  AllSecuritiesHeldByTheIssuerRepurchasedRemainActive = 'ALL_SECURITIES_HELD_BY_THE_ISSUER_REPURCHASED_REMAIN_ACTIVE',
  /** The instrument is not actively monitored as it is not required according to the applicant of this instrument. Lifecycle events will not be actively sourced / published. */
  ApplicantDoesNotRequireActiveMonitoring = 'APPLICANT_DOES_NOT_REQUIRE_ACTIVE_MONITORING',
  /** This instrument was opened with limited data by SIX, mainly for the purpose of assigning an NSIN or ISIN. This instrument will no longer or not be actively monitored, more data will only be added if provided on a best effort term. */
  BasicOpeningBySix = 'BASIC_OPENING_BY_SIX',
  /** This instrument was opened with limited data on customer request, mainly for the purpose of assigning an NSIN or ISIN. This instrument will no longer or not be actively monitored, more data will only be added if provided on a best effort term. */
  BasicOpeningOnCustomerRequest = 'BASIC_OPENING_ON_CUSTOMER_REQUEST',
  /** The company that issued this instrument explicitly stated that no lifecycle events shall be published on this instrument. Therefore, no active maintenance of reference data is done on that instrument. */
  CompanyObjectsPublicationOfEvents = 'COMPANY_OBJECTS_PUBLICATION_OF_EVENTS',
  /** Inactivation of EUWAX, opened with code 25. */
  InactivationBasicOpeningBySix = 'INACTIVATION_BASIC_OPENING_BY_SIX',
  InstrumentNotSpecificallyMonitored = 'INSTRUMENT_NOT_SPECIFICALLY_MONITORED',
  /** Full reference data information is currently not available. The instrument has already been actively monitored for a while but without success. Therefore, this instrument will only be monitored with low frequency going forward. */
  InstrumentUnderLowFrequencyMonitoring = 'INSTRUMENT_UNDER_LOW_FREQUENCY_MONITORING',
  IssuerDoesNotDisseminateProspectus = 'ISSUER_DOES_NOT_DISSEMINATE_PROSPECTUS',
  /** No further information available (private placements, exotic instruments etc.). Therefore, the instrument will no longer be actively monitored and no more reference data will be added. */
  NoFurtherInformationAvailable = 'NO_FURTHER_INFORMATION_AVAILABLE',
  /** For processing reasons, only provisional basic data has been opened. The instrument is under active monitoring for one month and futher reference data is expected to become available. */
  OpeningAsPreliminaryIssues = 'OPENING_AS_PRELIMINARY_ISSUES',
  Other = 'OTHER',
  /** Some reference data is missing. The instrument is under active monitoring for one month and futher reference data is expected to become available. More data will be added as soon as possible. */
  ReferenceDataWillStillBeCompleted = 'REFERENCE_DATA_WILL_STILL_BE_COMPLETED',
  /** A structured financial instrument has reached the maturity or expiry date, with the possible repayment cash flow details (TKXRD) being known. However, SIX has no information as to which of the eligible cash flows will apply. The instrument will be inactivated two days after the code has been entered. */
  RepaymentDueNoFixingInformationReceived = 'REPAYMENT_DUE_NO_FIXING_INFORMATION_RECEIVED',
  /** A structured financial instrument has reached maturity or expiry date, but no repayment conditions are known (TKXRD). The instrument will be inactivated one day after the code has been entered. */
  RepaymentDueTermsOfRepaymentNotAvailable = 'REPAYMENT_DUE_TERMS_OF_REPAYMENT_NOT_AVAILABLE',
  /** This value is exclusively used for internal processing of non-listed Italian Bonds which are implemented by the Monte Titoli/Borsa Italiana feed. */
  RestrictedDeliveryItaly = 'RESTRICTED_DELIVERY_ITALY',
  TaxableCertificateChLiNotApplicable = 'TAXABLE_CERTIFICATE_CH_LI_NOT_APPLICABLE'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Close a specific stream, referenced by its ID. */
  closeStream: Array<Message>;
};


export type MutationCloseStreamArgs = {
  streamId: Scalars['ID']['input'];
};

/** Free-text instrument search response. */
export type OldSearchInstrumentHit = {
  __typename?: 'OldSearchInstrumentHit';
  /** A list of descriptions outlining the reasons why a particular search term led to a corresponding match. These highlights provide insights into the contextual relevance of the result. */
  highlights: Array<OldSearchInstrumentResponseHighlight>;
  /** The outcome of a successful search, denoting a result that corresponds to the provided search term. A hit provides basic reference data to identify the result. */
  hit?: Maybe<InstrumentBase>;
  /** A numerical value ranging from 0 to 1, representing the degree of correlation between the search term and a given result. A perfect match results in a score of 1, offering a standardized measure of relevance. */
  normalizedScore: Scalars['Float']['output'];
  /** The client-provided text input used to initiate a search operation. */
  searchTerm: Scalars['UserInputText']['output'];
};

/** The highlight of the hit (i.e. why we have this result) */
export type OldSearchInstrumentResponseHighlight = {
  __typename?: 'OldSearchInstrumentResponseHighlight';
  /** Human readable description of the match. */
  description: SearchInstrumentDescription;
};

/** Describes the type of right (or obligation) of the product from an investor's point of view. */
export enum OptionType {
  Call = 'CALL',
  Other = 'OTHER',
  Put = 'PUT'
}

/** Instrument Type, Instrument Short Name and Instrument Long Name allocated in 'Produit Généralisé de Diffusion' (PGD). */
export type PgdLookup = {
  __typename?: 'PGDLookup';
  /** PGD Instrument long name (30 alphanumerical characters) according to Agence Française de Codification (AFC). */
  pgdInstrumentLongName?: Maybe<Scalars['String']['output']>;
  /** PGD Instrument short name (18 alphanumerical characters) according to Agence Française de Codification (AFC). */
  pgdInstrumentShortName?: Maybe<Scalars['String']['output']>;
  /**
   * Instrument classification allocated by PGD. Present on all instruments in the SIX PGD database.
   * This 3-digit code is defined in the official PGD reference table 'BB06TR : TYPE DE VALEUR PAR CODE'.
   */
  pgdInstrumentType?: Maybe<Scalars['String']['output']>;
};

/** Represents the part of a company, that an equity instrument (share) embodies. */
export enum ParValueType {
  /** The share  or participation certificate has a fixed nominal/par value (amount of money in a particular currency). */
  FixedParValue = 'FIXED_PAR_VALUE',
  NotAvailable = 'NOT_AVAILABLE',
  /** No-par share in its proper meaning. */
  NoParValue = 'NO_PAR_VALUE',
  Other = 'OTHER'
}

/** EOD Prices filters: period and price adjustments */
export type PriceFilter = {
  /** The starting time of the query. */
  dateFrom: Scalars['LocalDate']['input'];
  /** The ending point in time of the query. If not specified, the default is "today". */
  dateTo?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Whether or not to historically and or dividend adjust the prices. If not specified, it defaults to ADJUSTED. */
  priceAdjustment?: InputMaybe<EndOfDayPriceAdjustment>;
};

/** Indicates whether the amount is a percentage price or not. */
export enum PriceQuoteType {
  Other = 'OTHER',
  /** Price in percent. */
  PercentagePrice = 'PERCENTAGE_PRICE',
  /** The price is delivered in “percent” and has been adjusted by the factor. */
  PercentagePriceIncludingFactor = 'PERCENTAGE_PRICE_INCLUDING_FACTOR',
  /** The price is delivered in "percent" and must be multiplied with the "factor" (e.g. amortisations or inflation protection). */
  PercentagePriceMultipliedByFactor = 'PERCENTAGE_PRICE_MULTIPLIED_BY_FACTOR',
  /** The price is delivered in “percent” and has been corrected by the not liberated part of the “nominal” in percent. */
  PercentagePriceNonPaidPartCorrectedInPercent = 'PERCENTAGE_PRICE_NON_PAID_PART_CORRECTED_IN_PERCENT',
  /** The price is delivered in "percent" and is corrected by the not liberated part of the "nominal". */
  PercPriceNonPaidPartCorrected = 'PERC_PRICE_NON_PAID_PART_CORRECTED',
  /** Price in units. */
  PriceInUnits = 'PRICE_IN_UNITS',
  /** The price is delivered  in "units" and is corrected by the not liberated part of the nominal. */
  UnitPriceNonPaidPartcorrected = 'UNIT_PRICE_NON_PAID_PARTCORRECTED',
  /** Volatility-Quoted options allow submission of orders in terms of volatility instead of price. */
  Volatility = 'VOLATILITY',
  /** Yield. */
  Yield = 'YIELD'
}

/** Reference to the original price representation. Delivered when the provider delivers the price in other forms than entire unit or in decimals (e.g. price in GBX or fraction). */
export enum PriceRepresentationType {
  CurrencyMinorUnit = 'CURRENCY_MINOR_UNIT',
  Other = 'OTHER'
}

/**
 * The up-to-dateness of price data, also referred to as 'Data Quality Timeliness' or 'License Quality,' is determined by the default priority when no specific quality is chosen by the client in their request. The available quality levels are delivered based on the following order:
 *
 * 1. REAL_TIME
 * 2. DELAYED
 * 3. END_OF_DAY
 * 4. PREVIOUS_DAY
 */
export enum QualityOfService {
  Delayed = 'DELAYED',
  EndOfDay = 'END_OF_DAY',
  PreviousDay = 'PREVIOUS_DAY',
  RealTime = 'REAL_TIME'
}

export type Query = {
  __typename?: 'Query';
  /**
   * Get data for entity by various identifier schemes.
   *
   * NB: order of response is guaranteed to be as the input "ids"
   */
  entities: Array<Entity>;
  /**
   * Get data for instrument by various identifier schemes.
   *
   * NB: order of response is guaranteed to be as the input "ids"
   */
  instruments: Array<Instrument>;
  /**
   * Get data for listings by various identifier schemes.
   *
   * NB: order of response is guaranteed to be as the input "ids"
   */
  listings: Array<Listing>;
  /**
   * Get data for markets by various identifier schemes.
   *
   * NB: order of response is guaranteed to be as the input "ids"
   */
  markets: Array<Market>;
  /**
   * Search instruments by free-text names, by identifiers, by listing symbol and by trading symbols.
   *
   * Parameter **size** limits the number of hits to be returned. Maximum value is 30.
   * @deprecated use 'search/freeTextSearch/instruments' endpoint
   */
  searchInstruments: Array<OldSearchInstrumentHit>;
};


export type QueryEntitiesArgs = {
  ids: Array<Scalars['UserInputId']['input']>;
  preferredCountryFormat?: InputMaybe<CountryFormat>;
  preferredLanguage?: InputMaybe<Language>;
  queryId?: InputMaybe<Scalars['ID']['input']>;
  scheme: EntityScheme;
};


export type QueryInstrumentsArgs = {
  ids: Array<Scalars['UserInputId']['input']>;
  preferredCountryFormat?: InputMaybe<CountryFormat>;
  preferredLanguage?: InputMaybe<Language>;
  queryId?: InputMaybe<Scalars['ID']['input']>;
  scheme: InstrumentScheme;
};


export type QueryListingsArgs = {
  ids: Array<Scalars['UserInputId']['input']>;
  preferredCountryFormat?: InputMaybe<CountryFormat>;
  preferredLanguage?: InputMaybe<Language>;
  queryId?: InputMaybe<Scalars['ID']['input']>;
  scheme: ListingScheme;
};


export type QueryMarketsArgs = {
  ids: Array<Scalars['UserInputId']['input']>;
  preferredCountryFormat?: InputMaybe<CountryFormat>;
  preferredLanguage?: InputMaybe<Language>;
  queryId?: InputMaybe<Scalars['ID']['input']>;
  scheme: MarketScheme;
};


export type QuerySearchInstrumentsArgs = {
  filters?: InputMaybe<InstrumentTypeFilters>;
  preferredCountryFormat?: InputMaybe<CountryFormat>;
  preferredLanguage?: InputMaybe<Language>;
  query: Scalars['UserInputText']['input'];
  queryId?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** This should be never used by the client but it cannot be removed from the schema because it is needed at run-time. */
export enum QuoteType {
  /**  Keep it sorted by name, with IntelliJ -> select the lines -> Edit -> Sort Lines */
  AccruedInterest = 'ACCRUED_INTEREST',
  AuctionTheoreticalMatchingPrice = 'AUCTION_THEORETICAL_MATCHING_PRICE',
  BestAsk = 'BEST_ASK',
  BestBid = 'BEST_BID',
  BreakEvenPoint = 'BREAK_EVEN_POINT',
  Close = 'CLOSE',
  CloseYear = 'CLOSE_YEAR',
  Convexity = 'CONVEXITY',
  Delta = 'DELTA',
  DividendYield = 'DIVIDEND_YIELD',
  Duration = 'DURATION',
  Gamma = 'GAMMA',
  Gearing = 'GEARING',
  High = 'HIGH',
  High_1Week = 'HIGH_1_WEEK',
  High_4Week = 'HIGH_4_WEEK',
  High_12Week = 'HIGH_12_WEEK',
  High_26Week = 'HIGH_26_WEEK',
  High_52Week = 'HIGH_52_WEEK',
  HighStaticLimit = 'HIGH_STATIC_LIMIT',
  HighYearToDate = 'HIGH_YEAR_TO_DATE',
  HistoricalVolatility_30Days = 'HISTORICAL_VOLATILITY_30_DAYS',
  HistoricalVolatility_90Days = 'HISTORICAL_VOLATILITY_90_DAYS',
  HistoricalVolatility_180Days = 'HISTORICAL_VOLATILITY_180_DAYS',
  HistoricalVolatility_250Days = 'HISTORICAL_VOLATILITY_250_DAYS',
  ImpliedVolatility = 'IMPLIED_VOLATILITY',
  IntrinsicValue = 'INTRINSIC_VALUE',
  Last = 'LAST',
  Low = 'LOW',
  Low_1Week = 'LOW_1_WEEK',
  Low_4Week = 'LOW_4_WEEK',
  Low_12Week = 'LOW_12_WEEK',
  Low_26Week = 'LOW_26_WEEK',
  Low_52Week = 'LOW_52_WEEK',
  LowStaticLimit = 'LOW_STATIC_LIMIT',
  LowYearToDate = 'LOW_YEAR_TO_DATE',
  MarketCapitalisation = 'MARKET_CAPITALISATION',
  Mid = 'MID',
  ModifiedDuration = 'MODIFIED_DURATION',
  Moneyness = 'MONEYNESS',
  NumberOfTrades = 'NUMBER_OF_TRADES',
  Omega = 'OMEGA',
  Open = 'OPEN',
  OpenInterest = 'OPEN_INTEREST',
  OrderBook = 'ORDER_BOOK',
  PercentageChange_5Days = 'PERCENTAGE_CHANGE_5_DAYS',
  PercentageChangeYearToDate = 'PERCENTAGE_CHANGE_YEAR_TO_DATE',
  PercentageSpreadBestBidAsk = 'PERCENTAGE_SPREAD_BEST_BID_ASK',
  PerformanceYearToDate = 'PERFORMANCE_YEAR_TO_DATE',
  PriceEarningsRatioEstimated = 'PRICE_EARNINGS_RATIO_ESTIMATED',
  PriceEarningsRatioReported = 'PRICE_EARNINGS_RATIO_REPORTED',
  ReportedPrice = 'REPORTED_PRICE',
  Rho = 'RHO',
  SettlementPrice = 'SETTLEMENT_PRICE',
  SpreadBestBidAsk = 'SPREAD_BEST_BID_ASK',
  Theta = 'THETA',
  TimeToMaturity = 'TIME_TO_MATURITY',
  TotalExpenseRatio = 'TOTAL_EXPENSE_RATIO',
  Turnover = 'TURNOVER',
  TurnoverTotal = 'TURNOVER_TOTAL',
  Vega = 'VEGA',
  Volume = 'VOLUME',
  VolumeTotal = 'VOLUME_TOTAL',
  Vwap = 'VWAP',
  YieldToCall = 'YIELD_TO_CALL',
  YieldToMaturity = 'YIELD_TO_MATURITY'
}

/** Filled in for inactive instruments (e.g. early redemption, expiry, etc.).  */
export enum ReasonForDeletion {
  Amortization = 'AMORTIZATION',
  Assimilation = 'ASSIMILATION',
  CallInOfClaims = 'CALL_IN_OF_CLAIMS',
  CapitalReduction = 'CAPITAL_REDUCTION',
  CapitalRepayment = 'CAPITAL_REPAYMENT',
  ChangeOfDomicile = 'CHANGE_OF_DOMICILE',
  ChangeOfLegalForm = 'CHANGE_OF_LEGAL_FORM',
  /** Indicates that SIX Financial Information will link the existing listing to another exchange code (BCN) upon an official announcement from the exchange. To ensure uninterrupted price quotes, an instrument that was selected within VDFS indicating the appropriate exchange code must be reallocated to the new exchange code. */
  ChangeOfMarketPlace = 'CHANGE_OF_MARKET_PLACE',
  ChangeOfName = 'CHANGE_OF_NAME',
  ChangeOfNominalValue = 'CHANGE_OF_NOMINAL_VALUE',
  /** The trading currency has been changed upon an official announcement by the exchange. Prices have already been delivered in the former currency. */
  ChangeOfTradingCurrency = 'CHANGE_OF_TRADING_CURRENCY',
  ConsolidationInUnits = 'CONSOLIDATION_IN_UNITS',
  ConversionExercise = 'CONVERSION_EXERCISE',
  /** Correction of the market place due to an incorrect announcement. No trading has occured. An instrument that was selected within VDFS indicating the appropriate exchange code must be reallocated to the new exchange code. */
  CorrectionOfMarketPlace = 'CORRECTION_OF_MARKET_PLACE',
  /** Correction of the trading currency. No prices have been delivered in this currency. */
  CorrectionOfTradingCurrency = 'CORRECTION_OF_TRADING_CURRENCY',
  Demerger = 'DEMERGER',
  DissolutionOfCompany = 'DISSOLUTION_OF_COMPANY',
  EarlyRedemption = 'EARLY_REDEMPTION',
  EtdContractSpecPendingForDeletion = 'ETD_CONTRACT_SPEC_PENDING_FOR_DELETION',
  EtdDeletionDueToAdjustment = 'ETD_DELETION_DUE_TO_ADJUSTMENT',
  EtdDeletionWithoutAdjustment = 'ETD_DELETION_WITHOUT_ADJUSTMENT',
  Exchange = 'EXCHANGE',
  ExchangeOffer = 'EXCHANGE_OFFER',
  InvalidationStopping = 'INVALIDATION_STOPPING',
  IssueWithdrawn = 'ISSUE_WITHDRAWN',
  /** The instrument has reached or exceeded the set knock-out price and hence is inactive. */
  KnockedOut = 'KNOCKED_OUT',
  LegalProceedingsTrial = 'LEGAL_PROCEEDINGS_TRIAL',
  Maturity = 'MATURITY',
  Merger = 'MERGER',
  ObsoleteEtdContractSpec = 'OBSOLETE_ETD_CONTRACT_SPEC',
  Offer = 'OFFER',
  Other = 'OTHER',
  ProvocativeDeletion = 'PROVOCATIVE_DELETION',
  Rectification = 'RECTIFICATION',
  Reorganisation = 'REORGANISATION',
  RepurchaseOfOwnSecurities = 'REPURCHASE_OF_OWN_SECURITIES',
  ReverseSplit = 'REVERSE_SPLIT',
  SeparationOfUnits = 'SEPARATION_OF_UNITS',
  Split = 'SPLIT'
}

export enum SearchInstrumentDescription {
  AustrianNumber = 'AUSTRIAN_NUMBER',
  BelgianNumber = 'BELGIAN_NUMBER',
  Cins = 'CINS',
  CommonCode = 'COMMON_CODE',
  Cusip = 'CUSIP',
  DanishNumber = 'DANISH_NUMBER',
  DutchNumber = 'DUTCH_NUMBER',
  Figi = 'FIGI',
  FigiComposite = 'FIGI_COMPOSITE',
  FigiShareClass = 'FIGI_SHARE_CLASS',
  FrenchRgaCode = 'FRENCH_RGA_CODE',
  HongKongIssueNumber = 'HONG_KONG_ISSUE_NUMBER',
  InstrumentNamePrefix = 'INSTRUMENT_NAME_PREFIX',
  InstrumentNameSuffix = 'INSTRUMENT_NAME_SUFFIX',
  InstrumentProductName = 'INSTRUMENT_PRODUCT_NAME',
  InstrumentShortName = 'INSTRUMENT_SHORT_NAME',
  Isin = 'ISIN',
  IssuerLongName = 'ISSUER_LONG_NAME',
  ItalianNumber = 'ITALIAN_NUMBER',
  JapaneseIssueCode = 'JAPANESE_ISSUE_CODE',
  JapaneseNewSecuritiesCode = 'JAPANESE_NEW_SECURITIES_CODE',
  ListingSymbol = 'LISTING_SYMBOL',
  LuxembourgNumber = 'LUXEMBOURG_NUMBER',
  NorwegianNumber = 'NORWEGIAN_NUMBER',
  Other = 'OTHER',
  PortugueseNumber = 'PORTUGUESE_NUMBER',
  Sedol = 'SEDOL',
  Sicovam = 'SICOVAM',
  SixSymbol = 'SIX_SYMBOL',
  SouthKoreanNumber = 'SOUTH_KOREAN_NUMBER',
  SwedishNumber = 'SWEDISH_NUMBER',
  Ticker = 'TICKER',
  Valor = 'VALOR',
  Wkn = 'WKN'
}

/** Sector code allocated by SIX Financial Information. */
export enum Sector {
  /** Aircraft and spacecraft production,  arm industry. */
  AeronauticAndAstronauticIndustry = 'AERONAUTIC_AND_ASTRONAUTIC_INDUSTRY',
  /** Plant cultivation, plantations, livestock husbandry (excludes zoological gardens and homes for animals). */
  AgricultureAndFishery = 'AGRICULTURE_AND_FISHERY',
  /** Receipt and appropriation of money, aiming at something else than the compulsory insurance, pension funds, central banks and savings banks Broker. */
  BanksAndOtherCreditInstitutions = 'BANKS_AND_OTHER_CREDIT_INSTITUTIONS',
  /** Biochemical research and production, genetics, biotechnology. */
  Biotechnology = 'BIOTECHNOLOGY',
  /** Quarrying and processing of stone  for the building industry; Production, trade & import of: panes of glass, ceramic products, cement, lime, plaster, concrete, products out of concrete, plaster & cement; Further products out of non-metallic minerals, prefabricated building material, construction elements, extension elements, civil engineering, installation, extension industry, metal constructions (smithery), construction commodities (also of synthetics). */
  BuildingMaterialsAndBuildingIndustry = 'BUILDING_MATERIALS_AND_BUILDING_INDUSTRY',
  /** Cantons, federal states, 'Bundeslaender', provinces, counties, local authorities, etc. */
  CantonsFederalStatesProvincesEtc = 'CANTONS_FEDERAL_STATES_PROVINCES_ETC',
  /** Production, trade & import of basic chemical products; Agro-chemical products: artificial colours, printing ink and cementation, paint in its pigment form; Others, such as , film-, computer- and audiotapes,  chemical fibres. */
  Chemicals = 'CHEMICALS',
  CitiesMunicipalAuthorities = 'CITIES_MUNICIPAL_AUTHORITIES',
  /** Production, trade & import of appliances for data processing. */
  ComputerHardwareAndNetworking = 'COMPUTER_HARDWARE_AND_NETWORKING',
  CountriesAndCentralGovernments = 'COUNTRIES_AND_CENTRAL_GOVERNMENTS',
  /** Production, trade & import of devices for energy production and energy distribution; Production, trade & import of electrical  consumer goods, electrical household appliances, such as  washing machines and dishwashers, vacuum cleaners, fridges and freezers, cookers, driers etc. */
  ElectricalAppliancesAndComponents = 'ELECTRICAL_APPLIANCES_AND_COMPONENTS',
  /** Development, production, trade & import of semiconductors &   electronic components (circuit boards, electronic chips);  Entertainment electronics (radio, TV..) , GPS, appliances for data  storage. */
  ElectronicsAndSemiconductors = 'ELECTRONICS_AND_SEMICONDUCTORS',
  /** Energy supply; Gas supply; Long-distance heating; Water supply. */
  EnergyAndWaterSupply = 'ENERGY_AND_WATER_SUPPLY',
  /** Car dump, shredder, waste disposal. */
  EnvironmentalServicesAndRecycling = 'ENVIRONMENTAL_SERVICES_AND_RECYCLING',
  /** Conglomerates and diversified investment companies. */
  FinancialInvestmentAndOtherDiversifiedComp = 'FINANCIAL_INVESTMENT_AND_OTHER_DIVERSIFIED_COMP',
  /** Butchering,  processing, trade and import of fish and meat; Processing, trade, import & conservation of fruit, vegetables and milk; Production of vegetal/ animal oils and grease, pasta, sugar, sweets, spices; Production, trade & import of non-alcoholic beverages;. */
  FoodAndSoftDrinks = 'FOOD_AND_SOFT_DRINKS',
  /** Handling and processing of wood; saw mills, wood impregnation, manufacture, trade & import of cork products and wickerwork, cardboard and paper industry, production of mechanical pulp, paper, cardboard and pasteboard; Production of goods out of paper, cardboard and pasteboard (excludes packaging). */
  ForestryPaperAndForestProducts = 'FORESTRY_PAPER_AND_FOREST_PRODUCTS',
  /** Publishing industry; Publishing houses for books, newspapers, sound storage media (CD, etc); Miscellaneous Publishing companies (Calendars, postcards, etc.); Printing industry; Finishing of printing products; Setting and reproduction; Fast printing and copy services; Advertising agencies, radio, TV. */
  GraphicsPublishingAndPrintingMedia = 'GRAPHICS_PUBLISHING_AND_PRINTING_MEDIA',
  /** Education (schools); Hospitals, foster homes, clinics, medical doctors, dentists, children's homes, old people's homes, nurseries; Prisons; Non-profit cooperatives. */
  HealthcareAndSocialServices = 'HEALTHCARE_AND_SOCIAL_SERVICES',
  /** Insurance industry Life insurance Pension fund Miscellaneous insurance companies. */
  InsuranceCompanies = 'INSURANCE_COMPANIES',
  /** Internet companies, software developers and  business consultancies in this area. */
  InternetSoftwareAndItServices = 'INTERNET_SOFTWARE_AND_IT_SERVICES',
  InvestmentOrPensionFundsTrusts = 'INVESTMENT_OR_PENSION_FUNDS_TRUSTS',
  /** Hotels; Other lodging facilities; Restaurants, coffee houses, guild houses, bars, canteens and caterer; Casinos, carneys; Zoological gardens, etc.; Sport Centres, Fitness Centres, etc. */
  LodgingAndCateringIndLeisureFacilities = 'LODGING_AND_CATERING_IND_LEISURE_FACILITIES',
  /** Production, trade & import of: Machinery for the production and the utilisation  of mechanical energy (excludes motors for aircraft and vehicles); Agricultural machinery; Machine-tools; Miscellaneous machinery for  specific use (Metal production, building machinery, food, processing of textiles etc.); Household appliances (not electrical); Production, trade & import of metal products, such as: Metal tanks, heaters,  steam boilers; Forges, presses, cutters, etc.; Surface refinement; mechanics; Tools, locks; Miscellaneous metal goods, such as rivets, chains, screws. */
  MechanicalEngineeringAndIndustrialEquip = 'MECHANICAL_ENGINEERING_AND_INDUSTRIAL_EQUIP',
  /** Extraction of coal, peat and ore, extraction of rocks and soils, miscellaneous mining, production and initial processing of iron and steel, foundries. */
  MiningCoalAndSteel = 'MINING_COAL_AND_STEEL',
  /** Production, trade & import of: Household goods; Leisure articles; Sports equipment; Musical instruments; Ceramics, china; Products out of plastic. */
  MiscellaneousConsumerGoods = 'MISCELLANEOUS_CONSUMER_GOODS',
  /** Lobbies and other unions; Personal services;  Services for companies (consulting); Research and development; Stock markets. */
  MiscellaneousServices = 'MISCELLANEOUS_SERVICES',
  /** Trading companies and wholesale trade, reselling of  single goods to retail traders; Activity of wholesale traders, export and import companies (not sectoral); Retailer cooperative, broker for goods and raw material, etc. */
  MiscellaneousTradingCompanies = 'MISCELLANEOUS_TRADING_COMPANIES',
  /** Mortgage and funding institutions, MBS = Mortgage backed securities ABS = Asset backed securities Mortgage bond institutions, issue institutions: Special institutions  for the issue of mortgage bonds and the provision of long-term credits to the associated bank. Financing fund: Specialised  hypothecary creditors who issue mortgage-backed bonds (MBS).  The REMICs are guaranteed by the  government agencies (GNMA, FHLMC and FNMA). These are called Pass-through certificates and Pay-through bonds, such as the CMOs. Conduits (like commercial banks) also issue Asset-backed bonds, such as CARs, CLEOS, FRENDs and PARRs In the UK, The Mortgage Corp. plc and The Household Mortgage Corp. plc are specialised on this field. Special institutions for the issue of mortgage bonds and for the  provision of long-term credits to the associated banks. In Switzerland: Associations of regional banks, communities and towns, which open the issue market for their customers. On behalf of the client, the issue institutions issue bonds under their own name, however, for account of the member banks or communities who have a share of the bond. */
  MortgageAndFundingInstitutions = 'MORTGAGE_AND_FUNDING_INSTITUTIONS',
  NonClassifiableNonClassifiedInstitutions = 'NON_CLASSIFIABLE_NON_CLASSIFIED_INSTITUTIONS',
  /** Production and initial processing of non-ferrous metals such as lead, zinc, tin, copper, aluminium ; wire and cable production from these metals, e.g. for the electrical industry. */
  NonFerrousMetals = 'NON_FERROUS_METALS',
  Other = 'OTHER',
  /** Production, trade & import of packaging and wrapping material out  of different material (e.g., bottles, boxes, twines/strings, bags, one-way packaging). */
  PackagingIndustries = 'PACKAGING_INDUSTRIES',
  /** Exploration, extraction, trade & import of petroleum and natural gas; services in connection with the extraction of petroleum and natural gases; pipelines. */
  PetroleumOilAndNaturalGas = 'PETROLEUM_OIL_AND_NATURAL_GAS',
  /** Production, trade & import of: Pharmaceutical basic products; Medicaments and other pharmaceutical products; Supply for medical doctors and dentists; Production, trade & import of detergents, cleansers, perfumes and products for personal hygiene. */
  PharmaceuticalsCosmeticsAndMedProducts = 'PHARMACEUTICALS_COSMETICS_AND_MED_PRODUCTS',
  /** Production, trade & import of optical appliances,  cameras;  Projectors and cinema projectors. */
  PhotographicAndOptics = 'PHOTOGRAPHIC_AND_OPTICS',
  /** Production and first processing of precious metals, such as gold, silver and platinum; extraction of other minerals and  miscellaneous mining (precious stones), processing of precious stones and stones that are then made into jewellery. */
  PreciousMetalsAndPreciousStones = 'PRECIOUS_METALS_AND_PRECIOUS_STONES',
  PublicNonProfitInstitutions = 'PUBLIC_NON_PROFIT_INSTITUTIONS',
  /** Companies that  mainly aim at  the valorisation of their real estate or its utilisation as security or capital investment; Coverage & trade of real estate (apartment buildings, apartments, buildings not used for living, such as  warehouses, pieces of real estate); Rent and lease of own real estate; Procurement and  administration of real estate. */
  RealEstate = 'REAL_ESTATE',
  /** Retail trade in stores with different goods (or different branches); Small and large supermarkets or shops; Discount shops, shopping centres,  retailer cooperative; Large and small shops. Example: Food, beverages and tobacco products; Retail trade not in stores: mail order selling, internet selling. */
  RetailTradeAndDepartmentStores = 'RETAIL_TRADE_AND_DEPARTMENT_STORES',
  /** Production, trade & import of: Tires; Other products made from rubber. */
  RubberAndTires = 'RUBBER_AND_TIRES',
  SupranationalOrganisations = 'SUPRANATIONAL_ORGANISATIONS',
  /** Signal services; includes: Transmission of sound, pictures, data, etc. by cable, radio, satellites, telephone, fax. Includes operating; Production of all requisite technical facilities. */
  Telecommunication = 'TELECOMMUNICATION',
  /** Textiles; Production, trade & import of clothing (inclusive rubber); furs; Leather goods & shoes. */
  TextilesGarmentsAndLeatherGoods = 'TEXTILES_GARMENTS_AND_LEATHER_GOODS',
  /** Production, trade & import of spirituous beverages, wine, beer, malt  and other  fermented beverages; Production, processing, trade & import of tobacco and  tobacco products. */
  TobaccoAndAlcoholicBeverages = 'TOBACCO_AND_ALCOHOLIC_BEVERAGES',
  /** National post and courier services, rail traffic, road traffic; Navigation and aviation (incl. infrastructure); Miscellaneous activities in transportation. */
  TrafficAndTransportation = 'TRAFFIC_AND_TRANSPORTATION',
  /** Production, trade & import of furniture, shelves, warehouse equipment, etc. */
  VariousCapitalGoods = 'VARIOUS_CAPITAL_GOODS',
  /** Production, trade & import of: Automobiles, trailers and belongings; Miscellaneous vehicles - Motorcycles  and bikes; Railway carriages, engines. */
  Vehicles = 'VEHICLES',
  /** Production, assembly, trade & import of watches and clocks; Production, trade & import of jewellery. */
  WatchAndClockIndustryJewellery = 'WATCH_AND_CLOCK_INDUSTRY_JEWELLERY'
}

export enum SecurityType {
  Commodity = 'COMMODITY',
  Currency = 'CURRENCY',
  Debt = 'DEBT',
  Equity = 'EQUITY',
  Etd = 'ETD',
  EtdContractSpecification = 'ETD_CONTRACT_SPECIFICATION',
  Index = 'INDEX',
  InterestRate = 'INTEREST_RATE',
  InvestmentTrustUnitShare = 'INVESTMENT_TRUST_UNIT_SHARE',
  LeveragedProductSubscriptionRight = 'LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT',
  Other = 'OTHER',
  StructuredProduct = 'STRUCTURED_PRODUCT'
}

/** This indicates the rank compared with other securities of the same type issued by the same issuer in the case of liquidation. */
export enum Seniority {
  /** Subordinated securities that rank below other subordinated (e.g. senior) securities with regard to claims on assets or earnings. */
  JuniorSubordinated = 'JUNIOR_SUBORDINATED',
  /** In finance, mezzanine capital is any subordinated debt or preferred equity instrument that represents a claim on a company's assets which is senior only to that of the common shares. Mezzanine financings can be structured either as debt (typically an unsecured and subordinated note) or preferred stock. Mezzanine capital is often a more expensive financing source for a company than secured debt or senior debt. The higher cost of capital associated with mezzanine financings is the result of its being an unsecured, subordinated (or junior) obligation in a company's capital structure (i.e., in the event of default, the mezzanine financing is only repaid after all senior obligations have been satisfied). Additionally, mezzanine financings, which are usually private placements, are often used by smaller companies and may involve greater overall levels of leverage than issues in the high-yield market; they thus involve additional risk. In compensation for the increased risk, mezzanine debt holders require a higher return for their investment than secured or more senior lenders. */
  Mezzanine = 'MEZZANINE',
  /** An empty value in this element means that the security has no particular ranking in comparison to other securities of the same issuer. However, the value "No information available" means that despite intense sourcing activities, no information regarding the ranking of the security could be found. */
  NoInformationAvailable = 'NO_INFORMATION_AVAILABLE',
  Other = 'OTHER',
  PariPassu = 'PARI_PASSU',
  RankingAccordingToApplicableLaw = 'RANKING_ACCORDING_TO_APPLICABLE_LAW',
  /** Securities that rank above other securities with regard to claims on assets or earnings. In case of default, creditors with senior debt must be paid in full before subordinated debt is paid. */
  Senior = 'SENIOR',
  SeniorNonPreferred = 'SENIOR_NON_PREFERRED',
  /** Subordinated securities that rank above other subordinated (e.g. junior) securities with regard to claims on assets or earnings. */
  SeniorSubordinated = 'SENIOR_SUBORDINATED',
  /** In case of default, creditors with subordinated debt will not be paid out until after the other debtholders are paid in full. Compared to the other bonds the interest rate will be slightly higher. */
  Subordinated = 'SUBORDINATED',
  /** The most senior piece of a collateralised debt obligation’s capital structure which is the least likely part to default.  This type of risk always used to carry the credit-ratings agencies' triple-A designation, i.e. Super senior notes are the top-rated debt in credit rating. */
  SuperSenior = 'SUPER_SENIOR'
}

export type Span = {
  __typename?: 'Span';
  close?: Maybe<Scalars['LocalTime']['output']>;
  open?: Maybe<Scalars['LocalTime']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Stream messages for the specified query and conflation options. */
  startStream: Array<Message>;
};


export type SubscriptionStartStreamArgs = {
  conflationInterval?: InputMaybe<Scalars['String']['input']>;
  conflationPeriod?: InputMaybe<Scalars['Duration']['input']>;
  conflationType?: Conflation;
  ids: Array<Scalars['UserInputId']['input']>;
  qualityOfService?: InputMaybe<QualityOfService>;
  scheme: ListingScheme;
  streamId?: InputMaybe<Scalars['ID']['input']>;
};

/** Indicates the current state of the trading, e.g. trading temporarily suspended, not traded, calculated, etc. in coded form. */
export enum TradingStatus {
  /** The financial instrument is not a listed security but a specific size such as an index which is designed and calculated by a stock exchange. */
  Calculated = 'CALCULATED',
  /** The security is delisted and not traded anymore. */
  Delisting = 'DELISTING',
  /** The security is no longer traded actively but prices may still be available. */
  DerivativeInstrDiscontinued = 'DERIVATIVE_INSTR_DISCONTINUED',
  /** The security is not traded but is expected to become marketable. */
  NotYetTraded = 'NOT_YET_TRADED',
  /** The security used to be marketable but is no longer traded, e.g. as it was exchanged for another or has matured or expired. */
  NoLongerTraded = 'NO_LONGER_TRADED',
  /** No prices are available for the security. */
  NoTrade = 'NO_TRADE',
  Other = 'OTHER',
  /** The financial instrument is not listed on a stock exchange but prices are transmitted to SIX Financial Information from another provider, e.g. for certain investment funds (type of securities 7 and C). */
  Reported = 'REPORTED',
  /** The security is traded. */
  Traded = 'TRADED',
  /** Temporary halt in trading in a particular security. */
  TradeTemporarilySuspended = 'TRADE_TEMPORARILY_SUSPENDED'
}

export enum UnderlyingAsset {
  /** Equities Index contains at least 1 U.S. equities as component. */
  EquitiesIndexContainsAtLeast_1UsEquitiesAsComponent = 'EQUITIES_INDEX_CONTAINS_AT_LEAST_1_US_EQUITIES_AS_COMPONENT',
  ExposureToCryptoUnderlying = 'EXPOSURE_TO_CRYPTO_UNDERLYING',
  Other = 'OTHER',
  UnderlyingContainsAtLeast_1SpanishFttLiableSecurity = 'UNDERLYING_CONTAINS_AT_LEAST_1_SPANISH_FTT_LIABLE_SECURITY',
  /** There is at least one underlying instrument that pertains to an issuer domiciled in the US. This code is assigned to all instruments for which - upon conversion or exercise - an investor is entitled to receive a US-security. */
  UnderlyingContainsAtLeast_1UsSecurity = 'UNDERLYING_CONTAINS_AT_LEAST_1_US_SECURITY'
}

/** Indicates the unit of measurement in which the instrument quantity is expressed: per instrument or per nominal. For prices, this is the unit in which the instrument is traded. */
export enum Unit {
  Arroba = 'ARROBA',
  /** Unit of weight for gold in Thailand. 1 Baht = 15.244 grams. */
  Baht = 'BAHT',
  Barrel = 'BARREL',
  /** The board foot is a specialized unit of measure for the volume of lumber in the United States and Canada. It is the volume of a one foot length of a board one foot wide and one inch thick. */
  BoardFoot = 'BOARD_FOOT',
  Bushel = 'BUSHEL',
  Contract = 'CONTRACT',
  /** Cubic meters (m3), volume equals 1000 liters. */
  CubicMetersM3 = 'CUBIC_METERS_M3',
  Gallon = 'GALLON',
  /** Gigawatt-hours (GWh). */
  GigawattHoursGwh = 'GIGAWATT_HOURS_GWH',
  Gram = 'GRAM',
  HundredweightCwt = 'HUNDREDWEIGHT_CWT',
  IndexPoint = 'INDEX_POINT',
  Kilogram = 'KILOGRAM',
  /** Kilowatt-hours (kWh). */
  KilowattHoursKwh = 'KILOWATT_HOURS_KWH',
  Megawatt = 'MEGAWATT',
  /** Megawatt-hours (MWh). */
  MegawattHoursMwh = 'MEGAWATT_HOURS_MWH',
  MetricTonne = 'METRIC_TONNE',
  Mmbtu = 'MMBTU',
  /** Nominal value: The price of a security (stocks, shares, bonds etc.) when originally issued. This bears no relation to the market price. Also known as face value or par value. */
  Nominal = 'NOMINAL',
  NominalCurrencyUnitPerIndexPoint = 'NOMINAL_CURRENCY_UNIT_PER_INDEX_POINT',
  Other = 'OTHER',
  Ounce = 'OUNCE',
  PhysicalUnit = 'PHYSICAL_UNIT',
  PieceUnit = 'PIECE_UNIT',
  PoundLb = 'POUND_LB',
  /** Ratio of two values according to the definition of the specific amount. */
  Ratio = 'RATIO',
  Sack = 'SACK',
  Tael = 'TAEL',
  Tola = 'TOLA',
  TroyOunce = 'TROY_OUNCE'
}

export type Value = {
  __typename?: 'Value';
  /**
   * Generally, in real-time feeds, the providers disseminate various Timestamps that are associated with different price types or events. There could be multiple timestamps associated with a given price.
   *
   * Different providers may have different names for these timestamps and will not necessarily provide all of them in their feeds. In some cases, if the timestamp is not provided by the exchange, SIX internal timestamp may be used.
   *
   * In SIX products only one timestamp can be displayed with a given price or event. If the exchange provides multiple timestamps within the feed, use the timestamps in the following priority:
   *
   * Market data entry time - the time when the price was entered on a trader's side.
   * Transaction time - the time when the price was recognized by the exchange.
   * Exchange processing time - the time when the price was processed for updates, calculations at the exchange.
   * Exchange's sending time - the time that the exchange disseminate the price via the feed.
   */
  timestamp: Scalars['ZonedDateTime']['output'];
  /** Same as `timestamp`, but represented as IEEE 754 float: numberOfSeconds.microSeconds. Timezone is always UTC. */
  unixTimestamp: Scalars['Float']['output'];
  /** The Value of the price type. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type ValueAndSize = {
  __typename?: 'ValueAndSize';
  /**
   * A Size associated with a price value represent an amount of units/contracts/nominal offered for sale, demanded for purchase, traded, orders that will be executed at a given price (e.g. in the event of an auction theoretical matching price quantity).
   *
   * The size associated with a quote can directly signal the market participant the ability of the market to absorb their order. Furthermore, it provides an indication of a market imbalance. The Ask Size is required by traders trading data products and those entities interest in intra-day market data values.
   *
   * The size associated with a trade allows a market participant to see the trade volumes and estimate or understand the impact of their own order on the market and the probability of getting it fully executed. In addition, the trade size allows calculation of the Volume Weighted Average Price (VWAP).
   */
  size?: Maybe<Scalars['Float']['output']>;
  /**
   * Generally, in real-time feeds, the providers disseminate various Timestamps that are associated with different price types or events. There could be multiple timestamps associated with a given price.
   *
   * Different providers may have different names for these timestamps and will not necessarily provide all of them in their feeds. In some cases, if the timestamp is not provided by the exchange, SIX internal timestamp may be used.
   *
   * In SIX products only one timestamp can be displayed with a given price or event. If the exchange provides multiple timestamps within the feed, use the timestamps in the following priority:
   *
   * Market data entry time - the time when the price was entered on a trader's side.
   * Transaction time - the time when the price was recognized by the exchange.
   * Exchange processing time - the time when the price was processed for updates, calculations at the exchange.
   * Exchange's sending time - the time that the exchange disseminate the price via the feed.
   */
  timestamp: Scalars['ZonedDateTime']['output'];
  /** Same as `timestamp`, but represented as IEEE 754 float: numberOfSeconds.microSeconds. Timezone is always UTC. */
  unixTimestamp: Scalars['Float']['output'];
  /** The Value of the price type. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type ValFragment = { __typename?: 'Value', value?: number | null, timestamp: any };

export type ValSizeFragment = { __typename?: 'ValueAndSize', value?: number | null, timestamp: any };

export type PriceFragment = { __typename?: 'IntradayHistorySummary', intervalFrom?: any | null, last?: number | null };

export type StreamInstrumentPricesSubscriptionVariables = Exact<{
  isin: Scalars['UserInputId']['input'];
  interval?: InputMaybe<Scalars['Duration']['input']>;
}>;


export type StreamInstrumentPricesSubscription = { __typename?: 'Subscription', startStream: Array<{ __typename?: 'Message', type: MessageType, streamId: string, last?: { __typename?: 'ValueAndSize', value?: number | null, timestamp: any } | null }> };

export type GetInstrumentDetailsQueryVariables = Exact<{
  isin: Scalars['UserInputId']['input'];
  dateFrom: Scalars['LocalDate']['input'];
}>;


export type GetInstrumentDetailsQuery = { __typename?: 'Query', listings: Array<{ __typename?: 'Listing', lookupStatus: LookupStatus, lookup?: { __typename?: 'ListingLookup', listingCurrency: any } | null, marketData?: { __typename?: 'ListingMarketData', intradaySnapshot?: { __typename?: 'IntradaySnapshot', yieldToMaturity?: { __typename?: 'Value', value?: number | null, timestamp: any } | null, priceEarningsRatioEstimated?: { __typename?: 'Value', value?: number | null, timestamp: any } | null, marketCapitalisation?: { __typename?: 'Value', value?: number | null, timestamp: any } | null, turnover?: { __typename?: 'Value', value?: number | null, timestamp: any } | null } | null, intradayHistory?: { __typename?: 'IntradayHistory', summary?: Array<{ __typename?: 'IntradayHistorySummary', intervalFrom?: any | null, last?: number | null } | null> | null } | null } | null }> };

export type GetInstrumentLastPriceQueryVariables = Exact<{
  isins: Array<Scalars['UserInputId']['input']> | Scalars['UserInputId']['input'];
}>;


export type GetInstrumentLastPriceQuery = { __typename?: 'Query', listings: Array<{ __typename?: 'Listing', requestedId: any, lookupStatus: LookupStatus, lookup?: { __typename?: 'ListingLookup', listingCurrency: any } | null, marketData?: { __typename?: 'ListingMarketData', intradaySnapshot?: { __typename?: 'IntradaySnapshot', last?: { __typename?: 'ValueAndSize', value?: number | null, timestamp: any } | null } | null } | null }> };

export type GetInstrumentMarketQueryVariables = Exact<{
  isins: Array<Scalars['UserInputId']['input']> | Scalars['UserInputId']['input'];
}>;


export type GetInstrumentMarketQuery = { __typename?: 'Query', instruments: Array<{ __typename?: 'Instrument', requestedId: any, lookupStatus: LookupStatus, referenceData?: { __typename?: 'InstrumentReferenceData', instrumentSummary?: { __typename?: 'InstrumentSummary', mostLiquidMarket?: { __typename?: 'MarketReference', name: string, bc: any } | null } | null } | null }> };
